{
  "level": "mt03b",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt03b",
    "objects": "AREAS.E3:mt03b.e3",
    "mesh": "TREES.E3:mt03b.e3"
  },
  "spawn_point": {
    "position": [
      -834.3722013960959,
      -2760.2893525713293,
      692.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -834.3722013960959,
      -2660.2893525713293,
      692.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1070.0,
      -2978.0,
      668.0
    ],
    "bbox_max": [
      -602.0,
      -2630.0,
      863.8005981445312
    ],
    "vertex_count": 1483,
    "vertices": [
      [
        -656.0,
        -2688.0,
        776.111083984375
      ],
      [
        -656.0,
        -2688.0,
        775.0
      ],
      [
        -656.0,
        -2688.0,
        776.111083984375
      ],
      [
        -656.0,
        -2688.0,
        775.0
      ],
      [
        -656.0,
        -2635.0,
        760.0
      ],
      [
        -656.0,
        -2630.0,
        775.0
      ],
      [
        -656.0,
        -2630.0,
        775.0
      ],
      [
        -656.0,
        -2633.0,
        790.0
      ],
      [
        -732.0,
        -2688.0,
        830.0
      ],
      [
        -732.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -732.0,
        -2667.0,
        766.0
      ],
      [
        -732.0,
        -2685.60009765625,
        766.0
      ],
      [
        -732.0,
        -2685.60009765625,
        766.0
      ],
      [
        -656.0,
        -2688.0,
        766.0
      ],
      [
        -732.0,
        -2688.0,
        766.0
      ],
      [
        -716.5,
        -2633.0,
        766.0
      ],
      [
        -685.5,
        -2633.0,
        766.0
      ],
      [
        -716.5,
        -2633.0,
        766.0
      ],
      [
        -732.0,
        -2635.0,
        760.0
      ],
      [
        -732.0,
        -2633.0,
        766.0
      ],
      [
        -685.5,
        -2633.0,
        766.0
      ],
      [
        -656.0,
        -2633.0,
        766.0
      ],
      [
        -687.0,
        -2678.0,
        766.0
      ],
      [
        -687.0,
        -2688.0,
        766.0
      ],
      [
        -656.0,
        -2685.60009765625,
        766.0
      ],
      [
        -718.0,
        -2678.0,
        766.0
      ],
      [
        -718.0,
        -2688.0,
        766.0
      ],
      [
        -732.0,
        -2683.30908203125,
        787.0
      ],
      [
        -732.0,
        -2683.30908203125,
        787.0
      ],
      [
        -732.0,
        -2682.98193359375,
        784.0
      ],
      [
        -687.0,
        -2681.01904296875,
        766.0
      ],
      [
        -687.0,
        -2667.0,
        790.0
      ],
      [
        -687.0,
        -2633.0,
        790.0
      ],
      [
        -687.0,
        -2633.0,
        790.0
      ],
      [
        -687.0,
        -2630.0,
        775.0
      ],
      [
        -687.0,
        -2630.0,
        775.0
      ],
      [
        -687.0,
        -2633.0,
        766.0
      ],
      [
        -658.0,
        -2681.01904296875,
        766.0
      ],
      [
        -732.0,
        -2633.0,
        790.0
      ],
      [
        -732.0,
        -2667.0,
        790.0
      ],
      [
        -698.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -732.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -705.0,
        -2686.907958984375,
        820.0
      ],
      [
        -725.0,
        -2686.907958984375,
        820.0
      ],
      [
        -718.0,
        -2678.0,
        804.727294921875
      ],
      [
        -718.0,
        -2685.8173828125,
        810.0
      ],
      [
        -718.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -718.0,
        -2678.0,
        790.0
      ],
      [
        -718.0,
        -2683.63623046875,
        790.0
      ],
      [
        -732.0,
        -2630.0,
        775.0
      ],
      [
        -732.0,
        -2633.0,
        790.0
      ],
      [
        -732.0,
        -2630.0,
        775.0
      ],
      [
        -732.0,
        -2682.98193359375,
        784.0
      ],
      [
        -732.0,
        -2668.199951171875,
        784.0
      ],
      [
        -718.0,
        -2678.0,
        784.0
      ],
      [
        -718.0,
        -2682.98193359375,
        784.0
      ],
      [
        -718.0,
        -2681.01904296875,
        766.0
      ],
      [
        -689.0,
        -2681.01904296875,
        766.0
      ],
      [
        -720.0,
        -2681.01904296875,
        766.0
      ],
      [
        -687.0,
        -2682.0,
        775.0
      ],
      [
        -687.0,
        -2685.60009765625,
        766.0
      ],
      [
        -698.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -718.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -718.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -705.0,
        -2688.0,
        820.0
      ],
      [
        -718.0,
        -2686.907958984375,
        820.0
      ],
      [
        -718.0,
        -2688.0,
        820.0
      ],
      [
        -718.0,
        -2682.0,
        775.0
      ],
      [
        -718.0,
        -2685.60009765625,
        766.0
      ],
      [
        -732.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -725.0,
        -2688.0,
        820.0
      ],
      [
        -808.0,
        -2688.0,
        766.0
      ],
      [
        -747.5,
        -2633.0,
        766.0
      ],
      [
        -732.0,
        -2633.0,
        766.0
      ],
      [
        -747.5,
        -2633.0,
        766.0
      ],
      [
        -778.5,
        -2633.0,
        766.0
      ],
      [
        -812.4000244140625,
        -2633.0,
        766.0
      ],
      [
        -778.5,
        -2633.0,
        766.0
      ],
      [
        -780.0,
        -2678.0,
        766.0
      ],
      [
        -780.0,
        -2688.0,
        766.0
      ],
      [
        -749.0,
        -2678.0,
        766.0
      ],
      [
        -749.0,
        -2688.0,
        766.0
      ],
      [
        -808.0,
        -2688.0,
        766.0
      ],
      [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      [
        -780.0,
        -2681.01904296875,
        766.0
      ],
      [
        -749.0,
        -2681.01904296875,
        766.0
      ],
      [
        -749.0,
        -2633.0,
        790.0
      ],
      [
        -749.0,
        -2667.0,
        790.0
      ],
      [
        -749.0,
        -2630.0,
        775.0
      ],
      [
        -749.0,
        -2633.0,
        790.0
      ],
      [
        -749.0,
        -2633.0,
        766.0
      ],
      [
        -749.0,
        -2630.0,
        775.0
      ],
      [
        -780.0,
        -2667.0,
        790.0
      ],
      [
        -780.0,
        -2633.0,
        790.0
      ],
      [
        -780.0,
        -2633.0,
        790.0
      ],
      [
        -780.0,
        -2630.0,
        775.0
      ],
      [
        -780.0,
        -2630.0,
        775.0
      ],
      [
        -780.0,
        -2633.0,
        766.0
      ],
      [
        -751.0,
        -2681.01904296875,
        766.0
      ],
      [
        -782.0,
        -2681.01904296875,
        766.0
      ],
      [
        -806.0,
        -2681.01904296875,
        766.0
      ],
      [
        -749.0,
        -2682.0,
        775.0
      ],
      [
        -749.0,
        -2685.60009765625,
        766.0
      ],
      [
        -780.0,
        -2682.0,
        775.0
      ],
      [
        -780.0,
        -2685.60009765625,
        766.0
      ],
      [
        -808.0,
        -2688.0,
        774.0181884765625
      ],
      [
        -808.0,
        -2688.0,
        774.0181884765625
      ],
      [
        -808.0,
        -2688.0,
        775.0
      ],
      [
        -808.0,
        -2688.0,
        775.0
      ],
      [
        -824.0,
        -2737.0,
        721.0
      ],
      [
        -824.0,
        -2737.0,
        740.0
      ],
      [
        -795.0,
        -2745.0,
        740.0
      ],
      [
        -824.0,
        -2737.0,
        740.0
      ],
      [
        -824.0,
        -2745.0,
        740.0
      ],
      [
        -795.0,
        -2745.0,
        721.0
      ],
      [
        -824.0,
        -2745.0,
        721.0
      ],
      [
        -824.0,
        -2737.0,
        721.0
      ],
      [
        -795.0,
        -2745.0,
        721.0
      ],
      [
        -795.0,
        -2745.0,
        740.0
      ],
      [
        -824.0,
        -2753.0,
        740.0
      ],
      [
        -824.0,
        -2772.0,
        735.0
      ],
      [
        -824.0,
        -2772.0,
        721.0
      ],
      [
        -824.0,
        -2754.0,
        735.0
      ],
      [
        -824.0,
        -2766.0,
        735.0
      ],
      [
        -824.0,
        -2772.0,
        735.0
      ],
      [
        -824.0,
        -2754.0,
        735.0
      ],
      [
        -824.0,
        -2766.0,
        735.0
      ],
      [
        -824.0,
        -2772.0,
        721.0
      ],
      [
        -824.0,
        -2766.0,
        721.0
      ],
      [
        -824.0,
        -2766.0,
        721.0
      ],
      [
        -824.0,
        -2754.0,
        721.0
      ],
      [
        -824.0,
        -2753.0,
        740.0
      ],
      [
        -824.0,
        -2753.0,
        721.0
      ],
      [
        -685.5,
        -2745.0,
        830.0
      ],
      [
        -701.5,
        -2688.0,
        830.0
      ],
      [
        -701.5,
        -2745.0,
        830.0
      ],
      [
        -682.5999755859375,
        -2736.0,
        827.0
      ],
      [
        -656.0,
        -2736.0,
        827.0
      ],
      [
        -656.0,
        -2736.0,
        827.0
      ],
      [
        -656.0,
        -2745.0,
        830.0
      ],
      [
        -656.0,
        -2745.0,
        827.0
      ],
      [
        -656.0,
        -2745.0,
        785.0
      ],
      [
        -656.0,
        -2745.0,
        775.0
      ],
      [
        -656.0,
        -2745.0,
        785.0
      ],
      [
        -656.0,
        -2734.0,
        827.0
      ],
      [
        -656.0,
        -2734.0,
        812.0
      ],
      [
        -656.0,
        -2690.0,
        812.0
      ],
      [
        -656.0,
        -2690.0,
        827.0
      ],
      [
        -701.5,
        -2690.0,
        810.0
      ],
      [
        -701.5,
        -2745.0,
        810.0
      ],
      [
        -700.0,
        -2745.0,
        810.0
      ],
      [
        -700.0,
        -2745.0,
        827.5
      ],
      [
        -701.5,
        -2745.0,
        827.5
      ],
      [
        -700.0,
        -2722.5,
        827.5
      ],
      [
        -700.0,
        -2727.5,
        827.5
      ],
      [
        -700.0,
        -2712.5,
        827.5
      ],
      [
        -700.0,
        -2717.5,
        827.5
      ],
      [
        -700.0,
        -2722.5,
        827.5
      ],
      [
        -697.5,
        -2722.5,
        827.5
      ],
      [
        -697.5,
        -2717.5,
        827.5
      ],
      [
        -700.0,
        -2717.5,
        827.5
      ],
      [
        -701.5,
        -2690.0,
        807.5
      ],
      [
        -701.5,
        -2700.0,
        807.5
      ],
      [
        -701.5,
        -2740.0,
        807.5
      ],
      [
        -701.5,
        -2745.0,
        807.5
      ],
      [
        -697.5,
        -2745.0,
        807.5
      ],
      [
        -701.5,
        -2700.0,
        807.5
      ],
      [
        -701.5,
        -2700.0,
        810.0
      ],
      [
        -698.0,
        -2688.166748046875,
        807.5
      ],
      [
        -701.5,
        -2688.166748046875,
        807.5
      ],
      [
        -701.5,
        -2690.0,
        808.0
      ],
      [
        -701.5,
        -2740.0,
        810.0
      ],
      [
        -701.5,
        -2740.0,
        807.5
      ],
      [
        -701.5,
        -2688.0,
        807.4545288085938
      ],
      [
        -701.5,
        -2802.0,
        830.0
      ],
      [
        -656.0,
        -2805.0,
        802.5
      ],
      [
        -656.0,
        -2805.0,
        780.0
      ],
      [
        -656.0,
        -2805.0,
        775.5555419921875
      ],
      [
        -656.0,
        -2805.0,
        780.0
      ],
      [
        -656.0,
        -2805.0,
        775.0
      ],
      [
        -656.0,
        -2805.0,
        775.5555419921875
      ],
      [
        -640.0,
        -2805.0,
        810.0
      ],
      [
        -635.2000122070312,
        -2805.0,
        810.0
      ],
      [
        -606.7999877929688,
        -2805.0,
        810.0
      ],
      [
        -602.0,
        -2805.0,
        810.0
      ],
      [
        -606.7999877929688,
        -2805.0,
        810.0
      ],
      [
        -635.2000122070312,
        -2805.0,
        810.0
      ],
      [
        -656.0,
        -2756.0,
        810.0
      ],
      [
        -656.0,
        -2800.0,
        810.0
      ],
      [
        -627.293212890625,
        -2779.966552734375,
        810.0
      ],
      [
        -627.293212890625,
        -2775.7939453125,
        810.0
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      [
        -623.7611083984375,
        -2783.96630859375,
        810.0
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      [
        -623.434326171875,
        -2784.293212890625,
        810.0
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        810.0
      ],
      [
        -623.722412109375,
        -2771.7939453125,
        810.0
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        810.0
      ],
      [
        -623.434326171875,
        -2771.505859375,
        810.0
      ],
      [
        -656.0,
        -2800.0,
        810.0
      ],
      [
        -656.0,
        -2800.0,
        795.0
      ],
      [
        -602.0,
        -2805.0,
        810.0
      ],
      [
        -602.0,
        -2805.0,
        795.0
      ],
      [
        -656.0,
        -2756.0,
        795.0
      ],
      [
        -656.0,
        -2756.0,
        810.0
      ],
      [
        -687.0,
        -2802.0,
        775.0
      ],
      [
        -687.0,
        -2805.0,
        830.0
      ],
      [
        -687.0,
        -2805.0,
        775.0
      ],
      [
        -687.0,
        -2802.0,
        775.0
      ],
      [
        -684.0,
        -2802.0,
        775.0
      ],
      [
        -685.5,
        -2805.0,
        802.5000610351562
      ],
      [
        -687.0,
        -2802.0,
        830.0
      ],
      [
        -687.0,
        -2805.0,
        802.5000610351562
      ],
      [
        -685.5,
        -2805.0,
        802.5000610351562
      ],
      [
        -656.0,
        -2805.0,
        802.5000610351562
      ],
      [
        -671.1666870117188,
        -2756.0,
        805.0
      ],
      [
        -656.0,
        -2756.0,
        805.0
      ],
      [
        -671.1666870117188,
        -2800.0,
        805.0
      ],
      [
        -656.0,
        -2800.0,
        805.0
      ],
      [
        -701.5,
        -2800.0,
        810.0
      ],
      [
        -698.0,
        -2802.272705078125,
        827.5
      ],
      [
        -687.0,
        -2802.272705078125,
        827.5
      ],
      [
        -700.0,
        -2772.5,
        827.5
      ],
      [
        -697.5,
        -2772.5,
        827.5
      ],
      [
        -701.5,
        -2800.0,
        830.0
      ],
      [
        -700.0,
        -2772.5,
        827.5
      ],
      [
        -700.0,
        -2777.5,
        827.5
      ],
      [
        -700.0,
        -2762.5,
        827.5
      ],
      [
        -700.0,
        -2767.5,
        827.5
      ],
      [
        -697.5,
        -2767.5,
        827.5
      ],
      [
        -700.0,
        -2767.5,
        827.5
      ],
      [
        -698.0,
        -2804.181884765625,
        810.0
      ],
      [
        -687.0,
        -2804.181884765625,
        810.0
      ],
      [
        -695.3035278320312,
        -2805.0,
        802.4999389648438
      ],
      [
        -701.5,
        -2804.534912109375,
        806.76318359375
      ],
      [
        -701.5,
        -2805.0,
        802.4999389648438
      ],
      [
        -695.3035278320312,
        -2805.0,
        802.4999389648438
      ],
      [
        -701.5,
        -2804.534912109375,
        806.76318359375
      ],
      [
        -701.5,
        -2805.0,
        806.6363525390625
      ],
      [
        -698.0,
        -2805.0,
        806.6363525390625
      ],
      [
        -698.0,
        -2804.534912109375,
        806.76318359375
      ],
      [
        -701.5,
        -2790.0,
        807.5
      ],
      [
        -701.5,
        -2800.0,
        807.5
      ],
      [
        -701.5,
        -2750.0,
        807.5
      ],
      [
        -701.5,
        -2790.0,
        810.0
      ],
      [
        -701.5,
        -2790.0,
        807.5
      ],
      [
        -701.5,
        -2800.0,
        808.0
      ],
      [
        -701.5,
        -2801.833251953125,
        807.5
      ],
      [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      [
        -701.5,
        -2750.0,
        807.5
      ],
      [
        -701.5,
        -2750.0,
        810.0
      ],
      [
        -656.0,
        -2805.0,
        775.0
      ],
      [
        -656.0,
        -2805.0,
        767.5
      ],
      [
        -701.5,
        -2688.0,
        766.0
      ],
      [
        -701.5,
        -2728.199951171875,
        766.0
      ],
      [
        -701.5,
        -2730.0,
        760.0
      ],
      [
        -701.5,
        -2730.0,
        764.0
      ],
      [
        -701.5,
        -2730.0,
        764.0
      ],
      [
        -701.5,
        -2728.199951171875,
        766.0
      ],
      [
        -682.0,
        -2805.0,
        766.0
      ],
      [
        -658.0,
        -2805.0,
        766.0
      ],
      [
        -701.5,
        -2804.39990234375,
        766.0
      ],
      [
        -689.0,
        -2805.0,
        766.0
      ],
      [
        -701.5,
        -2805.0,
        766.0
      ],
      [
        -701.5,
        -2804.39990234375,
        766.0
      ],
      [
        -701.5,
        -2761.800048828125,
        766.0
      ],
      [
        -701.5,
        -2760.0,
        764.0
      ],
      [
        -701.5,
        -2760.0,
        760.0
      ],
      [
        -701.5,
        -2760.0,
        764.0
      ],
      [
        -701.5,
        -2761.800048828125,
        766.0
      ],
      [
        -687.0,
        -2805.0,
        760.0
      ],
      [
        -687.0,
        -2802.0,
        766.0
      ],
      [
        -687.0,
        -2805.0,
        766.0
      ],
      [
        -656.0,
        -2804.39990234375,
        766.0
      ],
      [
        -687.0,
        -2802.0,
        766.0
      ],
      [
        -684.0,
        -2802.0,
        766.0
      ],
      [
        -682.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -687.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -687.0,
        -2804.39990234375,
        766.0
      ],
      [
        -656.0,
        -2805.0,
        767.5
      ],
      [
        -658.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -658.0,
        -2805.0,
        766.0
      ],
      [
        -658.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -689.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -689.0,
        -2805.0,
        766.0
      ],
      [
        -689.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -808.0,
        -2805.0,
        767.5
      ],
      [
        -808.0,
        -2805.0,
        774.5090942382812
      ],
      [
        -808.0,
        -2805.0,
        774.5090942382812
      ],
      [
        -808.0,
        -2805.0,
        775.0
      ],
      [
        -808.0,
        -2805.0,
        775.0
      ],
      [
        -808.0,
        -2805.0,
        802.5
      ],
      [
        -819.5,
        -2756.0,
        777.5
      ],
      [
        -819.5,
        -2756.0,
        765.0
      ],
      [
        -819.5,
        -2734.0,
        765.0
      ],
      [
        -819.5,
        -2734.0,
        777.5
      ],
      [
        -815.5999755859375,
        -2748.199951171875,
        765.0
      ],
      [
        -815.5999755859375,
        -2748.199951171875,
        777.5
      ],
      [
        -819.5,
        -2734.0,
        777.5
      ],
      [
        -815.5999755859375,
        -2741.800048828125,
        777.5
      ],
      [
        -815.5999755859375,
        -2748.199951171875,
        777.5
      ],
      [
        -819.5,
        -2756.0,
        777.5
      ],
      [
        -819.5,
        -2794.0,
        765.0
      ],
      [
        -819.5,
        -2794.0,
        777.5
      ],
      [
        -815.5999755859375,
        -2801.800048828125,
        777.5
      ],
      [
        -815.5999755859375,
        -2801.800048828125,
        765.0
      ],
      [
        -819.5,
        -2794.0,
        777.5
      ],
      [
        -815.5999755859375,
        -2801.800048828125,
        777.5
      ],
      [
        -808.0,
        -2769.0,
        766.9635620117188
      ],
      [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      [
        -808.5499877929688,
        -2767.89990234375,
        770.5
      ],
      [
        -808.5499877929688,
        -2767.89990234375,
        770.5
      ],
      [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      [
        -808.0,
        -2769.0,
        774.0364379882812
      ],
      [
        -808.550048828125,
        -2782.10009765625,
        770.5
      ],
      [
        -808.0,
        -2782.10009765625,
        770.5
      ],
      [
        -808.0,
        -2781.0,
        766.9638061523438
      ],
      [
        -808.0,
        -2781.0,
        774.0361938476562
      ],
      [
        -808.0,
        -2782.10009765625,
        770.5
      ],
      [
        -808.550048828125,
        -2782.10009765625,
        770.5
      ],
      [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      [
        -810.0,
        -2765.0,
        775.0
      ],
      [
        -810.0,
        -2785.0,
        775.0
      ],
      [
        -808.0,
        -2780.7001953125,
        776.0
      ],
      [
        -810.0,
        -2780.7001953125,
        776.0
      ],
      [
        -810.0,
        -2769.2998046875,
        776.0
      ],
      [
        -808.0,
        -2769.2998046875,
        776.0
      ],
      [
        -810.0,
        -2769.2998046875,
        775.0
      ],
      [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      [
        -808.0,
        -2769.2998046875,
        776.0
      ],
      [
        -810.0,
        -2769.2998046875,
        776.0
      ],
      [
        -810.0,
        -2780.7001953125,
        776.0
      ],
      [
        -808.0,
        -2780.7001953125,
        776.0
      ],
      [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      [
        -810.0,
        -2780.7001953125,
        775.0
      ],
      [
        -808.0,
        -2779.10009765625,
        766.0
      ],
      [
        -808.0,
        -2780.5,
        770.5
      ],
      [
        -810.0,
        -2778.7890625,
        765.0
      ],
      [
        -810.0,
        -2781.89990234375,
        775.0
      ],
      [
        -810.0,
        -2782.10009765625,
        770.5
      ],
      [
        -808.0,
        -2780.7001953125,
        766.0
      ],
      [
        -810.0,
        -2780.7001953125,
        766.0
      ],
      [
        -808.1500244140625,
        -2781.300048828125,
        773.0717163085938
      ],
      [
        -810.0,
        -2782.10009765625,
        770.5
      ],
      [
        -810.0,
        -2781.300048828125,
        773.07177734375
      ],
      [
        -810.5,
        -2781.300048828125,
        773.07177734375
      ],
      [
        -808.0,
        -2780.5,
        770.5
      ],
      [
        -808.0,
        -2779.10009765625,
        775.0
      ],
      [
        -810.0,
        -2780.7001953125,
        775.0
      ],
      [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      [
        -810.0,
        -2781.300048828125,
        773.07177734375
      ],
      [
        -810.0,
        -2765.818115234375,
        766.0
      ],
      [
        -810.0,
        -2765.0,
        766.0
      ],
      [
        -810.0,
        -2765.818115234375,
        766.0
      ],
      [
        -808.0,
        -2769.5,
        770.5
      ],
      [
        -808.0,
        -2770.89990234375,
        766.0
      ],
      [
        -810.0,
        -2768.100341796875,
        775.0
      ],
      [
        -810.0,
        -2769.2998046875,
        766.0
      ],
      [
        -808.0,
        -2769.2998046875,
        766.0
      ],
      [
        -810.0,
        -2767.89990234375,
        770.5
      ],
      [
        -810.0,
        -2767.89990234375,
        770.5
      ],
      [
        -808.1499633789062,
        -2768.699951171875,
        773.072021484375
      ],
      [
        -810.0,
        -2768.7001953125,
        773.0721435546875
      ],
      [
        -810.5,
        -2768.7001953125,
        773.0722045898438
      ],
      [
        -808.0,
        -2770.89990234375,
        775.0
      ],
      [
        -808.0,
        -2769.5,
        770.5
      ],
      [
        -810.0,
        -2768.7001953125,
        773.0721435546875
      ],
      [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      [
        -810.0,
        -2769.2998046875,
        775.0
      ],
      [
        -819.5,
        -2696.0,
        777.5
      ],
      [
        -819.5,
        -2696.0,
        765.0
      ],
      [
        -815.5999755859375,
        -2688.199951171875,
        777.5
      ],
      [
        -819.5,
        -2696.0,
        777.5
      ],
      [
        -808.550048828125,
        -2722.10009765625,
        770.5
      ],
      [
        -808.0,
        -2722.10009765625,
        770.5
      ],
      [
        -808.0,
        -2721.0,
        766.9638061523438
      ],
      [
        -808.0,
        -2721.0,
        774.0361938476562
      ],
      [
        -808.0,
        -2722.10009765625,
        770.5
      ],
      [
        -808.550048828125,
        -2722.10009765625,
        770.5
      ],
      [
        -808.0,
        -2709.0,
        766.9635620117188
      ],
      [
        -808.0,
        -2707.89990234375,
        770.5
      ],
      [
        -808.5499877929688,
        -2707.89990234375,
        770.5
      ],
      [
        -808.5499877929688,
        -2707.89990234375,
        770.5
      ],
      [
        -808.0,
        -2707.89990234375,
        770.5
      ],
      [
        -808.0,
        -2709.0,
        774.0364379882812
      ],
      [
        -808.0,
        -2709.2998046875,
        775.0
      ],
      [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      [
        -810.0,
        -2725.0,
        775.0
      ],
      [
        -810.0,
        -2705.0,
        775.0
      ],
      [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      [
        -810.0,
        -2720.7001953125,
        776.0
      ],
      [
        -810.0,
        -2709.2998046875,
        776.0
      ],
      [
        -808.0,
        -2709.2998046875,
        776.0
      ],
      [
        -810.0,
        -2709.2998046875,
        775.0
      ],
      [
        -808.0,
        -2709.2998046875,
        775.0
      ],
      [
        -808.0,
        -2709.2998046875,
        776.0
      ],
      [
        -810.0,
        -2709.2998046875,
        776.0
      ],
      [
        -810.0,
        -2720.7001953125,
        776.0
      ],
      [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      [
        -810.0,
        -2720.7001953125,
        775.0
      ],
      [
        -808.0,
        -2719.10009765625,
        766.0
      ],
      [
        -808.0,
        -2720.5,
        770.5
      ],
      [
        -810.0,
        -2718.7890625,
        765.0
      ],
      [
        -810.0,
        -2721.89990234375,
        775.0
      ],
      [
        -810.0,
        -2722.10009765625,
        770.5
      ],
      [
        -808.0,
        -2720.7001953125,
        766.0
      ],
      [
        -810.0,
        -2720.7001953125,
        766.0
      ],
      [
        -808.1500244140625,
        -2721.300048828125,
        773.0717163085938
      ],
      [
        -810.0,
        -2722.10009765625,
        770.5
      ],
      [
        -810.0,
        -2721.300048828125,
        773.07177734375
      ],
      [
        -810.5,
        -2721.300048828125,
        773.07177734375
      ],
      [
        -808.0,
        -2720.5,
        770.5
      ],
      [
        -808.0,
        -2719.10009765625,
        775.0
      ],
      [
        -810.0,
        -2720.7001953125,
        775.0
      ],
      [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      [
        -810.0,
        -2721.300048828125,
        773.07177734375
      ],
      [
        -810.0,
        -2705.818115234375,
        766.0
      ],
      [
        -810.0,
        -2705.818115234375,
        766.0
      ],
      [
        -810.0,
        -2705.0,
        766.0
      ],
      [
        -808.0,
        -2709.5,
        770.5
      ],
      [
        -808.0,
        -2710.89990234375,
        766.0
      ],
      [
        -810.0,
        -2708.100341796875,
        775.0
      ],
      [
        -810.0,
        -2709.2998046875,
        766.0
      ],
      [
        -808.0,
        -2709.2998046875,
        766.0
      ],
      [
        -810.0,
        -2707.89990234375,
        770.5
      ],
      [
        -810.0,
        -2707.89990234375,
        770.5
      ],
      [
        -808.1499633789062,
        -2708.699951171875,
        773.072021484375
      ],
      [
        -810.0,
        -2708.7001953125,
        773.0721435546875
      ],
      [
        -810.5,
        -2708.7001953125,
        773.0722045898438
      ],
      [
        -808.0,
        -2710.89990234375,
        775.0
      ],
      [
        -808.0,
        -2709.5,
        770.5
      ],
      [
        -810.0,
        -2708.7001953125,
        773.0721435546875
      ],
      [
        -808.0,
        -2709.2998046875,
        775.0
      ],
      [
        -810.0,
        -2709.2998046875,
        775.0
      ],
      [
        -730.0,
        -2745.0,
        810.0
      ],
      [
        -701.5,
        -2745.0,
        810.0
      ],
      [
        -701.5,
        -2745.0,
        829.5
      ],
      [
        -728.5,
        -2745.0,
        829.5
      ],
      [
        -732.0,
        -2688.0,
        830.0
      ],
      [
        -732.0,
        -2745.0,
        830.0
      ],
      [
        -716.5,
        -2745.0,
        830.0
      ],
      [
        -701.5,
        -2745.0,
        830.0
      ],
      [
        -716.5,
        -2745.0,
        830.0
      ],
      [
        -730.0,
        -2690.0,
        829.5
      ],
      [
        -730.0,
        -2690.39990234375,
        829.5
      ],
      [
        -730.0,
        -2690.39990234375,
        829.5
      ],
      [
        -730.0,
        -2745.0,
        830.0
      ],
      [
        -730.0,
        -2745.0,
        829.5
      ],
      [
        -730.0,
        -2690.0,
        829.5
      ],
      [
        -730.0,
        -2690.0,
        829.7142944335938
      ],
      [
        -730.0,
        -2719.5,
        829.5
      ],
      [
        -732.0,
        -2719.5,
        829.5
      ],
      [
        -732.0,
        -2720.0,
        830.0
      ],
      [
        -732.0,
        -2690.0,
        829.5
      ],
      [
        -732.0,
        -2720.0,
        830.0
      ],
      [
        -732.0,
        -2720.5,
        829.5
      ],
      [
        -730.0,
        -2720.5,
        829.5
      ],
      [
        -730.0,
        -2745.0,
        812.0
      ],
      [
        -730.0,
        -2745.0,
        810.0
      ],
      [
        -730.0,
        -2745.0,
        827.5
      ],
      [
        -728.5,
        -2745.0,
        827.5
      ],
      [
        -730.0,
        -2745.0,
        827.5
      ],
      [
        -728.5,
        -2690.0,
        827.5
      ],
      [
        -730.0,
        -2690.0,
        827.5
      ],
      [
        -730.0,
        -2690.0,
        829.5
      ],
      [
        -701.5,
        -2690.0,
        827.5
      ],
      [
        -728.5,
        -2690.0,
        827.5
      ],
      [
        -729.2000122070312,
        -2690.0,
        810.0
      ],
      [
        -730.0,
        -2690.0,
        810.0
      ],
      [
        -732.0,
        -2700.0,
        810.0
      ],
      [
        -732.0,
        -2690.0,
        810.0
      ],
      [
        -732.0,
        -2740.0,
        810.0
      ],
      [
        -732.0,
        -2688.0,
        766.0
      ],
      [
        -732.0,
        -2728.199951171875,
        766.0
      ],
      [
        -732.0,
        -2730.0,
        760.0
      ],
      [
        -732.0,
        -2730.0,
        764.0
      ],
      [
        -732.0,
        -2730.0,
        764.0
      ],
      [
        -732.0,
        -2728.199951171875,
        766.0
      ],
      [
        -732.0,
        -2690.0,
        807.5
      ],
      [
        -732.0,
        -2700.0,
        807.5
      ],
      [
        -732.0,
        -2740.0,
        807.5
      ],
      [
        -732.0,
        -2745.0,
        807.5
      ],
      [
        -701.5,
        -2745.0,
        807.5
      ],
      [
        -732.0,
        -2700.0,
        807.5
      ],
      [
        -732.0,
        -2700.0,
        810.0
      ],
      [
        -732.0,
        -2688.166748046875,
        807.5
      ],
      [
        -701.5,
        -2688.166748046875,
        807.5
      ],
      [
        -732.0,
        -2740.0,
        810.0
      ],
      [
        -732.0,
        -2740.0,
        807.5
      ],
      [
        -808.0,
        -2745.0,
        830.0
      ],
      [
        -778.5,
        -2745.0,
        830.0
      ],
      [
        -747.5,
        -2745.0,
        830.0
      ],
      [
        -778.5,
        -2745.0,
        830.0
      ],
      [
        -747.5,
        -2745.0,
        830.0
      ],
      [
        -732.5,
        -2745.0,
        807.5
      ],
      [
        -732.5,
        -2745.0,
        810.0
      ],
      [
        -732.5,
        -2742.5,
        807.5
      ],
      [
        -732.5,
        -2745.0,
        807.5
      ],
      [
        -732.0,
        -2742.5,
        807.5
      ],
      [
        -732.5,
        -2697.5,
        807.5
      ],
      [
        -732.0,
        -2697.5,
        807.5
      ],
      [
        -732.0,
        -2805.0,
        806.6363525390625
      ],
      [
        -732.0,
        -2805.0,
        830.0
      ],
      [
        -732.0,
        -2802.0,
        830.0
      ],
      [
        -732.0,
        -2745.0,
        830.0
      ],
      [
        -730.0,
        -2799.60009765625,
        829.5
      ],
      [
        -730.0,
        -2800.0,
        829.5
      ],
      [
        -730.0,
        -2799.60009765625,
        829.5
      ],
      [
        -730.0,
        -2745.0,
        829.5
      ],
      [
        -730.0,
        -2800.0,
        829.7142944335938
      ],
      [
        -730.0,
        -2800.0,
        829.5
      ],
      [
        -730.0,
        -2800.0,
        830.0
      ],
      [
        -730.0,
        -2800.0,
        829.7142944335938
      ],
      [
        -732.0,
        -2770.0,
        830.0
      ],
      [
        -732.0,
        -2770.5,
        829.5
      ],
      [
        -730.0,
        -2770.5,
        829.5
      ],
      [
        -732.0,
        -2800.0,
        829.5
      ],
      [
        -730.0,
        -2769.5,
        829.5
      ],
      [
        -732.0,
        -2769.5,
        829.5
      ],
      [
        -732.0,
        -2770.0,
        830.0
      ],
      [
        -728.5,
        -2800.0,
        827.5
      ],
      [
        -730.0,
        -2800.0,
        829.5
      ],
      [
        -730.0,
        -2800.0,
        827.5
      ],
      [
        -728.5,
        -2800.0,
        827.5
      ],
      [
        -701.5,
        -2800.0,
        827.5
      ],
      [
        -729.2000122070312,
        -2800.0,
        810.0
      ],
      [
        -730.0,
        -2800.0,
        810.0
      ],
      [
        -725.0,
        -2805.0,
        820.0
      ],
      [
        -705.0,
        -2805.0,
        820.0
      ],
      [
        -732.0,
        -2790.0,
        810.0
      ],
      [
        -732.0,
        -2800.0,
        810.0
      ],
      [
        -732.0,
        -2750.0,
        810.0
      ],
      [
        -713.0,
        -2805.0,
        766.0
      ],
      [
        -732.0,
        -2804.39990234375,
        766.0
      ],
      [
        -720.0,
        -2805.0,
        766.0
      ],
      [
        -732.0,
        -2805.0,
        766.0
      ],
      [
        -732.0,
        -2804.39990234375,
        766.0
      ],
      [
        -732.0,
        -2761.800048828125,
        766.0
      ],
      [
        -732.0,
        -2760.0,
        764.0
      ],
      [
        -732.0,
        -2760.0,
        760.0
      ],
      [
        -732.0,
        -2760.0,
        764.0
      ],
      [
        -732.0,
        -2761.800048828125,
        766.0
      ],
      [
        -718.0,
        -2805.0,
        760.0
      ],
      [
        -718.0,
        -2802.0,
        766.0
      ],
      [
        -718.0,
        -2805.0,
        766.0
      ],
      [
        -718.0,
        -2802.0,
        766.0
      ],
      [
        -715.0,
        -2802.0,
        766.0
      ],
      [
        -718.0,
        -2805.0,
        810.0
      ],
      [
        -718.0,
        -2805.0,
        806.6363525390625
      ],
      [
        -701.5,
        -2802.0,
        807.4545288085938
      ],
      [
        -718.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -716.5,
        -2805.0,
        802.4999389648438
      ],
      [
        -718.0,
        -2804.534912109375,
        806.76318359375
      ],
      [
        -718.0,
        -2805.0,
        802.4999389648438
      ],
      [
        -716.5,
        -2805.0,
        802.4999389648438
      ],
      [
        -713.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -718.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -718.0,
        -2804.39990234375,
        766.0
      ],
      [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -732.0,
        -2805.0,
        806.6363525390625
      ],
      [
        -732.0,
        -2805.0,
        802.4999389648438
      ],
      [
        -720.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -720.0,
        -2805.0,
        766.0
      ],
      [
        -720.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -732.0,
        -2790.0,
        807.5
      ],
      [
        -732.0,
        -2800.0,
        807.5
      ],
      [
        -732.0,
        -2750.0,
        807.5
      ],
      [
        -732.0,
        -2745.0,
        807.5
      ],
      [
        -732.0,
        -2790.0,
        810.0
      ],
      [
        -732.0,
        -2790.0,
        807.5
      ],
      [
        -732.0,
        -2801.833251953125,
        807.5
      ],
      [
        -701.5,
        -2801.833251953125,
        807.5
      ],
      [
        -732.0,
        -2750.0,
        807.5
      ],
      [
        -732.0,
        -2750.0,
        810.0
      ],
      [
        -744.0,
        -2805.0,
        766.0
      ],
      [
        -775.0,
        -2805.0,
        766.0
      ],
      [
        -751.0,
        -2805.0,
        766.0
      ],
      [
        -806.0,
        -2805.0,
        766.0
      ],
      [
        -782.0,
        -2805.0,
        766.0
      ],
      [
        -749.0,
        -2802.0,
        766.0
      ],
      [
        -746.0,
        -2802.0,
        766.0
      ],
      [
        -780.0,
        -2802.0,
        766.0
      ],
      [
        -777.0,
        -2802.0,
        766.0
      ],
      [
        -780.0,
        -2805.0,
        760.0
      ],
      [
        -780.0,
        -2802.0,
        766.0
      ],
      [
        -780.0,
        -2805.0,
        766.0
      ],
      [
        -749.0,
        -2805.0,
        760.0
      ],
      [
        -749.0,
        -2802.0,
        766.0
      ],
      [
        -749.0,
        -2805.0,
        766.0
      ],
      [
        -808.0,
        -2804.39990234375,
        766.0
      ],
      [
        -780.0,
        -2805.0,
        830.0
      ],
      [
        -749.0,
        -2805.0,
        830.0
      ],
      [
        -735.3436279296875,
        -2805.0,
        802.4999389648438
      ],
      [
        -735.3436279296875,
        -2805.0,
        802.4999389648438
      ],
      [
        -747.5,
        -2805.0,
        802.5000610351562
      ],
      [
        -749.0,
        -2805.0,
        802.5000610351562
      ],
      [
        -747.5,
        -2805.0,
        802.5000610351562
      ],
      [
        -749.0,
        -2802.0,
        830.0
      ],
      [
        -744.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -749.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -749.0,
        -2804.39990234375,
        766.0
      ],
      [
        -780.0,
        -2805.0,
        802.5000610351562
      ],
      [
        -778.5,
        -2805.0,
        802.5000610351562
      ],
      [
        -780.0,
        -2802.0,
        830.0
      ],
      [
        -778.5,
        -2805.0,
        802.5000610351562
      ],
      [
        -775.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -780.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -780.0,
        -2804.39990234375,
        766.0
      ],
      [
        -751.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -751.0,
        -2805.0,
        766.0
      ],
      [
        -751.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -808.0,
        -2805.0,
        802.5000610351562
      ],
      [
        -782.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -806.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -808.0,
        -2805.0,
        767.5
      ],
      [
        -782.0,
        -2805.0,
        766.0
      ],
      [
        -782.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -806.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -806.0,
        -2805.0,
        766.0
      ],
      [
        -732.5,
        -2747.5,
        807.5
      ],
      [
        -732.0,
        -2747.5,
        807.5
      ],
      [
        -732.5,
        -2792.5,
        807.5
      ],
      [
        -732.0,
        -2792.5,
        807.5
      ],
      [
        -732.0,
        -2806.69091796875,
        787.0
      ],
      [
        -732.0,
        -2805.0,
        802.4999389648438
      ],
      [
        -732.0,
        -2806.69091796875,
        787.0
      ],
      [
        -732.0,
        -2807.01806640625,
        784.0
      ],
      [
        -687.0,
        -2809.63525390625,
        760.0
      ],
      [
        -687.0,
        -2805.0,
        802.5062866210938
      ],
      [
        -687.0,
        -2855.0,
        760.0
      ],
      [
        -687.0,
        -2860.0,
        775.0
      ],
      [
        -687.0,
        -2860.0,
        775.0
      ],
      [
        -687.0,
        -2857.0,
        790.0
      ],
      [
        -687.0,
        -2857.0,
        790.0
      ],
      [
        -687.0,
        -2823.0,
        790.0
      ],
      [
        -602.8185424804688,
        -2805.818603515625,
        795.0
      ],
      [
        -602.0,
        -2805.0,
        802.505615234375
      ],
      [
        -682.0,
        -2808.98095703125,
        766.0
      ],
      [
        -658.0,
        -2808.98095703125,
        766.0
      ],
      [
        -658.0,
        -2808.98095703125,
        766.0
      ],
      [
        -732.0,
        -2823.0,
        790.0
      ],
      [
        -732.0,
        -2857.0,
        790.0
      ],
      [
        -718.0,
        -2805.0,
        806.6363525390625
      ],
      [
        -718.0,
        -2812.0,
        804.727294921875
      ],
      [
        -718.0,
        -2806.36376953125,
        790.0
      ],
      [
        -718.0,
        -2805.0,
        802.5051879882812
      ],
      [
        -718.0,
        -2812.0,
        790.0
      ],
      [
        -732.0,
        -2860.0,
        775.0
      ],
      [
        -732.0,
        -2855.0,
        760.0
      ],
      [
        -732.0,
        -2857.0,
        790.0
      ],
      [
        -732.0,
        -2860.0,
        775.0
      ],
      [
        -718.0,
        -2809.63525390625,
        760.0
      ],
      [
        -713.0,
        -2808.98095703125,
        766.0
      ],
      [
        -689.0,
        -2808.98095703125,
        766.0
      ],
      [
        -689.0,
        -2808.98095703125,
        766.0
      ],
      [
        -732.0,
        -2821.800048828125,
        784.0
      ],
      [
        -732.0,
        -2807.01806640625,
        784.0
      ],
      [
        -720.0,
        -2808.98095703125,
        766.0
      ],
      [
        -732.0,
        -2823.0,
        766.0
      ],
      [
        -732.0,
        -2808.98095703125,
        766.0
      ],
      [
        -720.0,
        -2808.98095703125,
        766.0
      ],
      [
        -687.0,
        -2808.0,
        775.0
      ],
      [
        -687.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -718.0,
        -2808.0,
        775.0
      ],
      [
        -718.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -732.0,
        -2805.0,
        766.0
      ],
      [
        -780.0,
        -2809.63525390625,
        760.0
      ],
      [
        -780.0,
        -2805.0,
        802.5062866210938
      ],
      [
        -749.0,
        -2809.63525390625,
        760.0
      ],
      [
        -749.0,
        -2805.0,
        802.5062866210938
      ],
      [
        -749.0,
        -2823.0,
        790.0
      ],
      [
        -749.0,
        -2857.0,
        790.0
      ],
      [
        -749.0,
        -2860.0,
        775.0
      ],
      [
        -749.0,
        -2855.0,
        760.0
      ],
      [
        -749.0,
        -2857.0,
        790.0
      ],
      [
        -749.0,
        -2860.0,
        775.0
      ],
      [
        -744.0,
        -2808.98095703125,
        766.0
      ],
      [
        -732.0,
        -2808.98095703125,
        766.0
      ],
      [
        -780.0,
        -2857.0,
        790.0
      ],
      [
        -780.0,
        -2823.0,
        790.0
      ],
      [
        -780.0,
        -2855.0,
        760.0
      ],
      [
        -780.0,
        -2860.0,
        775.0
      ],
      [
        -780.0,
        -2860.0,
        775.0
      ],
      [
        -780.0,
        -2857.0,
        790.0
      ],
      [
        -775.0,
        -2808.98095703125,
        766.0
      ],
      [
        -751.0,
        -2808.98095703125,
        766.0
      ],
      [
        -751.0,
        -2808.98095703125,
        766.0
      ],
      [
        -806.0,
        -2808.98095703125,
        766.0
      ],
      [
        -782.0,
        -2808.98095703125,
        766.0
      ],
      [
        -782.0,
        -2808.98095703125,
        766.0
      ],
      [
        -806.0,
        -2808.98095703125,
        766.0
      ],
      [
        -749.0,
        -2808.0,
        775.0
      ],
      [
        -749.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -780.0,
        -2808.0,
        775.0
      ],
      [
        -780.0,
        -2805.0,
        767.5001831054688
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -985.4205932617188,
        -2640.0,
        705.8635864257812
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -977.0639038085938,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -879.32861328125,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -966.0363159179688,
        -2920.0,
        788.0
      ],
      [
        -941.6363525390625,
        -2930.0,
        792.4444580078125
      ],
      [
        -939.038330078125,
        -2930.0,
        790.4069213867188
      ],
      [
        -940.416259765625,
        -2930.0,
        792.4444580078125
      ],
      [
        -927.2113037109375,
        -2920.0,
        863.8005981445312
      ],
      [
        -904.548583984375,
        -2920.0,
        840.8545532226562
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -932.0,
        -2925.0,
        844.0625
      ],
      [
        -914.0,
        -2859.5,
        832.9804077148438
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -914.0,
        -2920.0,
        843.216552734375
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -932.0,
        -2920.0,
        863.8005981445312
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -914.0,
        -2920.0,
        843.2164916992188
      ],
      [
        -914.0,
        -2920.0,
        850.4241333007812
      ],
      [
        -906.88134765625,
        -2920.0,
        843.2164916992188
      ],
      [
        -932.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -914.0,
        -2863.125,
        833.59375
      ],
      [
        -914.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2920.0,
        840.0
      ],
      [
        -914.0,
        -2920.0,
        840.0
      ],
      [
        -914.0,
        -2920.0,
        843.2164916992188
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -889.454833984375,
        -2863.125,
        818.7603149414062
      ],
      [
        -889.0310668945312,
        -2859.5,
        817.4066162109375
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -904.9830932617188,
        -2920.0,
        840.0
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -870.5189208984375,
        -2859.5,
        791.3280639648438
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -870.5189208984375,
        -2859.5,
        791.3280639648438
      ],
      [
        -869.887939453125,
        -2859.5,
        790.0740966796875
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -932.0,
        -2930.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -972.8826293945312,
        -2920.0,
        805.2472534179688
      ],
      [
        -957.2628784179688,
        -2920.0,
        825.7915649414062
      ],
      [
        -957.2628784179688,
        -2920.0,
        825.7915649414062
      ],
      [
        -941.999755859375,
        -2920.0,
        845.86669921875
      ],
      [
        -941.999755859375,
        -2920.0,
        845.86669921875
      ],
      [
        -932.0,
        -2920.0,
        859.0191040039062
      ],
      [
        -962.0082397460938,
        -2930.0,
        820.943359375
      ],
      [
        -956.3942260742188,
        -2930.0,
        826.6275634765625
      ],
      [
        -962.0082397460938,
        -2930.0,
        820.943359375
      ],
      [
        -962.000732421875,
        -2930.0,
        819.25341796875
      ],
      [
        -985.7762451171875,
        -2859.5,
        790.45849609375
      ],
      [
        -985.7095336914062,
        -2859.5,
        790.23095703125
      ],
      [
        -985.7762451171875,
        -2859.5,
        790.45849609375
      ],
      [
        -984.927490234375,
        -2859.5,
        791.2595825195312
      ],
      [
        -954.5962524414062,
        -2930.0,
        792.7979125976562
      ],
      [
        -961.9993286132812,
        -2930.0,
        818.93994140625
      ],
      [
        -956.1746826171875,
        -2920.0,
        788.0
      ],
      [
        -959.5332641601562,
        -2920.0,
        799.8597412109375
      ],
      [
        -959.5332641601562,
        -2920.0,
        799.8597412109375
      ],
      [
        -964.2677612304688,
        -2920.0,
        816.5782470703125
      ],
      [
        -983.5882568359375,
        -2859.5,
        782.9964599609375
      ],
      [
        -952.7792358398438,
        -2930.0,
        792.8374633789062
      ],
      [
        -954.5962524414062,
        -2930.0,
        792.7979125976562
      ],
      [
        -961.9993286132812,
        -2930.0,
        818.93994140625
      ],
      [
        -977.84033203125,
        -2859.5,
        763.3938598632812
      ],
      [
        -956.1475219726562,
        -2920.0,
        788.0
      ],
      [
        -956.8463745117188,
        -2920.0,
        790.3719482421875
      ],
      [
        -977.0639038085938,
        -2859.5,
        761.111083984375
      ],
      [
        -977.84033203125,
        -2859.5,
        763.3938598632812
      ],
      [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      [
        -956.4358520507812,
        -2920.0,
        825.2838745117188
      ],
      [
        -961.7054443359375,
        -2920.0,
        819.9484252929688
      ],
      [
        -956.4358520507812,
        -2920.0,
        825.2838745117188
      ],
      [
        -939.9971923828125,
        -2920.0,
        841.9281005859375
      ],
      [
        -939.9971923828125,
        -2920.0,
        841.9281005859375
      ],
      [
        -932.0,
        -2920.0,
        850.0252685546875
      ],
      [
        -937.571044921875,
        -2930.0,
        845.6749267578125
      ],
      [
        -935.4811401367188,
        -2930.0,
        845.7122802734375
      ],
      [
        -937.571044921875,
        -2930.0,
        845.6749267578125
      ],
      [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -938.7246704101562,
        -2920.0,
        843.216552734375
      ],
      [
        -935.0020141601562,
        -2930.0,
        845.7208251953125
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      [
        -950.0,
        -2930.0,
        792.89794921875
      ],
      [
        -950.0,
        -2923.65380859375,
        789.6239013671875
      ],
      [
        -942.1470947265625,
        -2930.0,
        793.0687255859375
      ],
      [
        -940.857421875,
        -2930.0,
        793.0968017578125
      ],
      [
        -940.857421875,
        -2930.0,
        793.0968017578125
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        670.0
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -990.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -970.0,
        -2677.65380859375,
        680.2904663085938
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -994.123291015625,
        -2682.291259765625,
        694.1002197265625
      ],
      [
        -1007.907958984375,
        -2697.0,
        720.0
      ],
      [
        -1007.4884643554688,
        -2695.500244140625,
        720.0
      ],
      [
        -1007.907958984375,
        -2697.0,
        720.0
      ],
      [
        -1007.45263671875,
        -2700.84130859375,
        720.0
      ],
      [
        -1006.3765869140625,
        -2710.0,
        720.0
      ],
      [
        -1007.45263671875,
        -2700.84130859375,
        720.0
      ],
      [
        -981.5535278320312,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -994.123291015625,
        -2682.291259765625,
        694.1002197265625
      ],
      [
        -972.8922729492188,
        -2710.0,
        748.4310302734375
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -971.9118041992188,
        -2712.0,
        752.3527221679688
      ],
      [
        -1011.9400024414062,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -1000.169921875,
        -2710.0,
        748.4310913085938
      ],
      [
        -1011.9400024414062,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -1010.0033569335938,
        -2698.625732421875,
        726.1282958984375
      ],
      [
        -1009.0059204101562,
        -2697.0,
        722.940673828125
      ],
      [
        -1010.0033569335938,
        -2698.625732421875,
        726.1282958984375
      ],
      [
        -1009.0059204101562,
        -2697.0,
        722.940673828125
      ],
      [
        -968.076904296875,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -870.4964599609375,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -866.9043579101562,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -836.0967407226562,
        -2712.0,
        718.0
      ],
      [
        -836.8701171875,
        -2708.11181640625,
        744.7284545898438
      ],
      [
        -836.0967407226562,
        -2712.0,
        752.3526000976562
      ],
      [
        -840.5,
        -2708.11181640625,
        744.7286987304688
      ],
      [
        -838.5,
        -2708.11181640625,
        744.7286987304688
      ],
      [
        -838.5,
        -2708.11181640625,
        744.7286987304688
      ],
      [
        -839.0,
        -2707.51171875,
        743.5524291992188
      ],
      [
        -840.0,
        -2707.51171875,
        743.5524291992188
      ],
      [
        -840.5,
        -2708.11181640625,
        744.7286987304688
      ],
      [
        -840.0,
        -2707.51171875,
        743.5524291992188
      ],
      [
        -839.0,
        -2707.51171875,
        743.5524291992188
      ],
      [
        -838.9999389648438,
        -2707.51171875,
        718.0
      ],
      [
        -838.5003051757812,
        -2708.11181640625,
        718.0
      ],
      [
        -840.4999389648438,
        -2708.11181640625,
        718.0
      ],
      [
        -840.0,
        -2707.51171875,
        718.0
      ],
      [
        -839.4998168945312,
        -2706.911376953125,
        718.0
      ],
      [
        -853.0,
        -2697.099365234375,
        718.0
      ],
      [
        -853.0,
        -2708.11181640625,
        718.0
      ],
      [
        -853.0,
        -2697.099365234375,
        718.0
      ],
      [
        -853.0,
        -2697.099365234375,
        723.1361083984375
      ],
      [
        -846.61181640625,
        -2698.3701171875,
        725.6273803710938
      ],
      [
        -840.77197265625,
        -2702.27197265625,
        733.2783813476562
      ],
      [
        -836.8701171875,
        -2708.11181640625,
        744.7284545898438
      ],
      [
        -846.61181640625,
        -2698.3701171875,
        725.6273803710938
      ],
      [
        -840.77197265625,
        -2702.27197265625,
        733.2783813476562
      ],
      [
        -836.0967407226562,
        -2712.0,
        718.0
      ],
      [
        -853.0,
        -2712.0,
        718.0
      ],
      [
        -870.9032592773438,
        -2712.0,
        718.0
      ],
      [
        -870.9032592773438,
        -2712.0,
        752.3527221679688
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        744.7285766601562
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        744.7285766601562
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        733.2783813476562
      ],
      [
        -870.9032592773438,
        -2712.0,
        718.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        733.2783813476562
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        725.6273803710938
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        725.6273803710938
      ],
      [
        -853.5,
        -2697.0,
        722.9411010742188
      ],
      [
        -853.5,
        -2697.0,
        722.9411010742188
      ],
      [
        -991.0,
        -2650.0,
        668.0
      ],
      [
        -853.0,
        -2697.099365234375,
        782.5
      ],
      [
        -853.0,
        -2697.099365234375,
        723.1361083984375
      ],
      [
        -831.7825317382812,
        -2708.278076171875,
        775.0
      ],
      [
        -831.7825317382812,
        -2708.278076171875,
        765.0
      ],
      [
        -825.0,
        -2712.0,
        775.0
      ],
      [
        -825.0,
        -2712.0,
        774.0
      ],
      [
        -825.0,
        -2712.0,
        774.0
      ],
      [
        -824.0,
        -2712.0,
        774.0
      ],
      [
        -825.0,
        -2712.0,
        765.0
      ],
      [
        -824.0,
        -2712.0,
        765.0
      ],
      [
        -831.7825317382812,
        -2708.278076171875,
        775.0
      ],
      [
        -826.2119750976562,
        -2712.0,
        775.0
      ],
      [
        -825.0,
        -2712.0,
        775.0
      ],
      [
        -825.0,
        -2712.0,
        765.0
      ],
      [
        -826.2119750976562,
        -2712.0,
        765.0
      ],
      [
        -831.7825317382812,
        -2708.278076171875,
        765.0
      ],
      [
        -834.2724609375,
        -2712.0,
        775.0
      ],
      [
        -834.2724609375,
        -2712.0,
        765.0
      ],
      [
        -839.0001220703125,
        -2707.51171875,
        782.5
      ],
      [
        -839.9998779296875,
        -2707.51171875,
        782.5
      ],
      [
        -840.4998779296875,
        -2708.11181640625,
        782.5
      ],
      [
        -838.500244140625,
        -2708.11181640625,
        782.5
      ],
      [
        -837.2710571289062,
        -2707.51171875,
        782.5
      ],
      [
        -836.0967407226562,
        -2712.0,
        782.5
      ],
      [
        -836.0967407226562,
        -2712.0,
        775.0
      ],
      [
        -836.0967407226562,
        -2712.0,
        765.0
      ],
      [
        -836.0967407226562,
        -2712.0,
        765.0
      ],
      [
        -836.0967407226562,
        -2712.0,
        775.0
      ],
      [
        -836.0967407226562,
        -2712.0,
        782.5
      ],
      [
        -843.7395629882812,
        -2712.0,
        782.5
      ],
      [
        -853.0,
        -2707.51171875,
        782.5
      ],
      [
        -853.0,
        -2712.0,
        782.5
      ],
      [
        -853.0,
        -2697.099365234375,
        782.5
      ],
      [
        -932.0,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -932.0,
        -2640.0,
        748.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -898.6423950195312,
        -2650.0,
        775.49560546875
      ],
      [
        -932.0,
        -2640.0,
        771.9608154296875
      ],
      [
        -932.0,
        -2650.0,
        775.49560546875
      ],
      [
        -921.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -921.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -921.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -888.2786865234375,
        -2650.0,
        761.384521484375
      ],
      [
        -898.6423950195312,
        -2650.0,
        775.49560546875
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        754.0
      ],
      [
        -853.5,
        -2697.0,
        731.1354370117188
      ],
      [
        -853.0,
        -2697.099365234375,
        730.4908447265625
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        741.0130615234375
      ],
      [
        -853.5,
        -2697.0,
        731.1354370117188
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        750.384765625
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        741.0130615234375
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        757.82275390625
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        750.384765625
      ],
      [
        -870.9032592773438,
        -2712.0,
        760.2907104492188
      ],
      [
        -870.9032592773438,
        -2712.0,
        782.5
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        757.82275390625
      ],
      [
        -870.9032592773438,
        -2712.0,
        782.5
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -932.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -873.5,
        -2712.0,
        763.6296997070312
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.4685668945312
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -914.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.468505859375
      ],
      [
        -995.3317260742188,
        -2660.0,
        714.0372314453125
      ],
      [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      [
        -991.0,
        -2650.0,
        709.2665405273438
      ],
      [
        -982.3170776367188,
        -2650.0,
        727.1830444335938
      ],
      [
        -970.2431640625,
        -2650.0,
        752.0966186523438
      ],
      [
        -982.3170776367188,
        -2650.0,
        727.1830444335938
      ],
      [
        -967.8667602539062,
        -2650.0,
        757.0
      ],
      [
        -970.2431640625,
        -2650.0,
        752.0966186523438
      ],
      [
        -972.0087280273438,
        -2660.0,
        672.4444580078125
      ],
      [
        -990.8366088867188,
        -2660.0,
        701.9979858398438
      ],
      [
        -991.0,
        -2650.0,
        708.1119384765625
      ],
      [
        -980.2110595703125,
        -2650.0,
        691.1768188476562
      ],
      [
        -980.2109985351562,
        -2650.0,
        691.1768188476562
      ],
      [
        -965.4456176757812,
        -2650.0,
        668.0
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      [
        -972.0,
        -2650.0,
        748.4714965820312
      ],
      [
        -972.0,
        -2650.0,
        678.2882080078125
      ],
      [
        -989.3621826171875,
        -2650.0,
        705.541015625
      ],
      [
        -990.860595703125,
        -2650.0,
        709.5540771484375
      ],
      [
        -990.8366088867188,
        -2660.0,
        701.9979858398438
      ],
      [
        -995.3317260742188,
        -2660.0,
        714.0372314453125
      ],
      [
        -932.6353759765625,
        -2640.0,
        771.9608154296875
      ],
      [
        -953.0830078125,
        -2650.0,
        775.49560546875
      ],
      [
        -932.0,
        -2650.0,
        775.49560546875
      ],
      [
        -932.0,
        -2642.125,
        772.7119750976562
      ],
      [
        -934.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -940.0,
        -2648.0,
        763.253662109375
      ],
      [
        -934.0,
        -2648.0,
        770.3472900390625
      ],
      [
        -934.0,
        -2648.0,
        770.3473510742188
      ],
      [
        -934.0,
        -2642.0,
        770.3472900390625
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -990.4483642578125,
        -2712.0,
        760.0
      ],
      [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.468505859375
      ],
      [
        -970.0,
        -2712.0,
        780.0
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.4685668945312
      ],
      [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      [
        -873.5,
        -2712.0,
        695.5555419921875
      ],
      [
        -871.1580810546875,
        -2762.5,
        718.0
      ],
      [
        -873.5,
        -2762.5,
        718.0
      ],
      [
        -871.5,
        -2788.75,
        784.205322265625
      ],
      [
        -873.5,
        -2788.75,
        786.5338134765625
      ],
      [
        -873.5,
        -2790.18115234375,
        786.7009887695312
      ],
      [
        -871.5,
        -2790.30859375,
        784.3873901367188
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -871.5,
        -2859.5,
        792.4702758789062
      ],
      [
        -871.5,
        -2790.30859375,
        784.3873901367188
      ],
      [
        -873.5,
        -2790.18115234375,
        786.7009887695312
      ],
      [
        -873.5,
        -2859.5,
        795.2313232421875
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -871.5,
        -2766.559326171875,
        719.8040771484375
      ],
      [
        -873.5,
        -2790.302978515625,
        730.3568725585938
      ],
      [
        -871.5,
        -2762.5,
        718.0
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -871.5,
        -2841.150634765625,
        763.2430419921875
      ],
      [
        -871.5,
        -2859.5,
        784.7289428710938
      ],
      [
        -873.5,
        -2859.5,
        778.097412109375
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -871.5,
        -2830.819580078125,
        748.3642578125
      ],
      [
        -871.5,
        -2841.150634765625,
        763.2430419921875
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -873.5,
        -2754.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        735.0
      ],
      [
        -873.5,
        -2788.75,
        786.5338134765625
      ],
      [
        -871.5,
        -2788.75,
        784.205322265625
      ],
      [
        -871.5,
        -2781.199951171875,
        782.2899780273438
      ],
      [
        -873.5,
        -2735.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        721.0
      ],
      [
        -873.5,
        -2735.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        735.0
      ],
      [
        -853.0,
        -2792.900634765625,
        782.5
      ],
      [
        -853.0,
        -2792.900634765625,
        718.0
      ],
      [
        -831.782470703125,
        -2781.721923828125,
        765.0
      ],
      [
        -831.782470703125,
        -2781.721923828125,
        775.0
      ],
      [
        -825.0,
        -2777.190185546875,
        774.0
      ],
      [
        -825.0,
        -2777.190185546875,
        775.0
      ],
      [
        -824.0,
        -2776.522216796875,
        765.0
      ],
      [
        -825.0,
        -2777.190185546875,
        765.0
      ],
      [
        -824.0,
        -2776.522216796875,
        774.0
      ],
      [
        -825.0,
        -2777.190185546875,
        774.0
      ],
      [
        -825.0,
        -2777.190185546875,
        775.0
      ],
      [
        -831.782470703125,
        -2781.721923828125,
        775.0
      ],
      [
        -831.782470703125,
        -2781.721923828125,
        765.0
      ],
      [
        -825.0,
        -2777.190185546875,
        765.0
      ],
      [
        -830.2892456054688,
        -2737.0,
        721.0
      ],
      [
        -830.2892456054688,
        -2737.0,
        740.0
      ],
      [
        -830.2892456054688,
        -2737.0,
        740.0
      ],
      [
        -824.0,
        -2738.810302734375,
        740.0
      ],
      [
        -830.2892456054688,
        -2737.0,
        721.0
      ],
      [
        -824.0,
        -2738.810302734375,
        721.0
      ],
      [
        -847.314208984375,
        -2732.09912109375,
        730.0
      ],
      [
        -852.404296875,
        -2735.5,
        744.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        744.0
      ],
      [
        -844.2769165039062,
        -2757.0263671875,
        744.0
      ],
      [
        -845.9649047851562,
        -2754.5,
        744.0
      ],
      [
        -852.404296875,
        -2735.5,
        744.0
      ],
      [
        -853.0,
        -2735.89794921875,
        744.0
      ],
      [
        -853.0,
        -2743.970703125,
        744.0
      ],
      [
        -845.9649047851562,
        -2754.5,
        744.0
      ],
      [
        -833.2137451171875,
        -2773.584716796875,
        765.0
      ],
      [
        -833.2137451171875,
        -2773.584716796875,
        765.0
      ],
      [
        -829.0130004882812,
        -2779.87158203125,
        765.0
      ],
      [
        -833.2137451171875,
        -2773.584716796875,
        775.0
      ],
      [
        -833.2137451171875,
        -2773.584716796875,
        775.0
      ],
      [
        -829.0130004882812,
        -2779.87158203125,
        775.0
      ],
      [
        -825.39990234375,
        -2770.0,
        735.0
      ],
      [
        -825.39990234375,
        -2770.0,
        721.0
      ],
      [
        -844.2769165039062,
        -2757.0263671875,
        718.0
      ],
      [
        -844.2769165039062,
        -2757.0263671875,
        744.0
      ],
      [
        -853.0,
        -2742.0,
        731.0
      ],
      [
        -853.0,
        -2743.970458984375,
        731.0
      ],
      [
        -850.3077392578125,
        -2748.0,
        731.0
      ],
      [
        -853.0,
        -2737.0,
        744.0
      ],
      [
        -853.0,
        -2742.0,
        731.0
      ],
      [
        -850.3077392578125,
        -2748.0,
        731.0
      ],
      [
        -846.9669799804688,
        -2753.0,
        744.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        731.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        744.0
      ],
      [
        -846.05615234375,
        -2732.46142578125,
        731.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        730.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        730.0
      ],
      [
        -832.2679443359375,
        -2775.000244140625,
        765.0
      ],
      [
        -832.2679443359375,
        -2775.000244140625,
        775.0
      ],
      [
        -847.314208984375,
        -2757.90087890625,
        730.0
      ],
      [
        -848.6626586914062,
        -2756.999755859375,
        730.0
      ],
      [
        -848.6626586914062,
        -2756.999755859375,
        744.0
      ],
      [
        -848.6626586914062,
        -2756.999755859375,
        730.0
      ],
      [
        -853.0,
        -2748.0,
        731.0
      ],
      [
        -853.0,
        -2753.0,
        744.0
      ],
      [
        -853.0,
        -2752.999755859375,
        744.0
      ],
      [
        -846.9672241210938,
        -2753.0,
        744.0
      ],
      [
        -853.0,
        -2748.0,
        731.0
      ],
      [
        -848.6626586914062,
        -2756.999755859375,
        744.0
      ],
      [
        -852.4041137695312,
        -2754.5,
        744.0
      ],
      [
        -853.0,
        -2754.101806640625,
        744.0
      ],
      [
        -852.4041137695312,
        -2754.5,
        744.0
      ],
      [
        -839.0000610351562,
        -2767.5,
        782.5
      ],
      [
        -839.9998779296875,
        -2767.5,
        782.5
      ],
      [
        -840.4999389648438,
        -2768.10009765625,
        782.5
      ],
      [
        -838.5001831054688,
        -2768.10009765625,
        782.5
      ],
      [
        -836.8779296875,
        -2768.10009765625,
        782.5
      ],
      [
        -837.2788696289062,
        -2767.5,
        782.5
      ],
      [
        -853.0,
        -2767.5,
        782.5
      ],
      [
        -853.0,
        -2768.10009765625,
        782.5
      ],
      [
        -853.0,
        -2757.099365234375,
        730.0
      ],
      [
        -853.0,
        -2757.099365234375,
        782.5
      ],
      [
        -853.0,
        -2756.103271484375,
        730.0
      ],
      [
        -853.0,
        -2756.103271484375,
        744.0
      ],
      [
        -853.0,
        -2757.099365234375,
        730.0
      ],
      [
        -853.0,
        -2756.103271484375,
        730.0
      ],
      [
        -853.0,
        -2756.103271484375,
        744.0
      ],
      [
        -853.0,
        -2754.5,
        744.0
      ],
      [
        -853.0,
        -2754.5,
        744.0
      ],
      [
        -853.0,
        -2757.099365234375,
        782.5
      ],
      [
        -838.5,
        -2781.89990234375,
        782.5
      ],
      [
        -840.4998168945312,
        -2781.89990234375,
        782.5
      ],
      [
        -840.0000610351562,
        -2782.5,
        782.5
      ],
      [
        -839.0,
        -2782.5,
        782.5
      ],
      [
        -853.0,
        -2781.89990234375,
        782.5
      ],
      [
        -853.0,
        -2782.5,
        782.5
      ],
      [
        -837.2788696289062,
        -2782.5,
        782.5
      ],
      [
        -836.8779296875,
        -2781.89990234375,
        782.5
      ],
      [
        -853.0,
        -2792.900634765625,
        782.5
      ],
      [
        -834.7584228515625,
        -2778.7275390625,
        775.0
      ],
      [
        -834.7584228515625,
        -2778.7275390625,
        765.0
      ],
      [
        -838.5,
        -2721.88818359375,
        782.5
      ],
      [
        -840.5000610351562,
        -2721.88818359375,
        782.5
      ],
      [
        -840.0000610351562,
        -2722.48828125,
        782.5
      ],
      [
        -838.9996948242188,
        -2722.48828125,
        782.5
      ],
      [
        -853.0,
        -2721.88818359375,
        782.5
      ],
      [
        -853.0,
        -2722.48828125,
        782.5
      ],
      [
        -853.0,
        -2732.900634765625,
        730.0
      ],
      [
        -853.0,
        -2732.900634765625,
        782.5
      ],
      [
        -853.0,
        -2733.896728515625,
        730.0
      ],
      [
        -853.0,
        -2733.896728515625,
        744.0
      ],
      [
        -853.0,
        -2733.896728515625,
        730.0
      ],
      [
        -853.0,
        -2732.900634765625,
        730.0
      ],
      [
        -853.0,
        -2735.5,
        744.0
      ],
      [
        -853.0,
        -2733.896728515625,
        744.0
      ],
      [
        -853.0,
        -2735.5,
        744.0
      ],
      [
        -853.0,
        -2732.900634765625,
        782.5
      ],
      [
        -834.9032592773438,
        -2712.0,
        765.0
      ],
      [
        -834.9032592773438,
        -2712.0,
        775.0
      ],
      [
        -853.0,
        -2712.0,
        782.5
      ],
      [
        -871.443359375,
        -2774.71533203125,
        782.5
      ],
      [
        -871.3280639648438,
        -2775.864501953125,
        782.5
      ],
      [
        -853.0,
        -2732.900634765625,
        756.142822265625
      ],
      [
        -853.5,
        -2733.0,
        756.7365112304688
      ],
      [
        -853.5,
        -2757.0,
        759.5401000976562
      ],
      [
        -853.0,
        -2757.099365234375,
        758.9696655273438
      ],
      [
        -860.38818359375,
        -2758.3701171875,
        767.7196655273438
      ],
      [
        -853.5,
        -2757.0,
        759.5401000976562
      ],
      [
        -853.5,
        -2793.0,
        763.74560546875
      ],
      [
        -853.0,
        -2792.900634765625,
        763.1519165039062
      ],
      [
        -853.5,
        -2793.0,
        763.74560546875
      ],
      [
        -860.38818359375,
        -2791.6298828125,
        771.6050415039062
      ],
      [
        -866.22802734375,
        -2762.27197265625,
        774.9745483398438
      ],
      [
        -860.38818359375,
        -2758.3701171875,
        767.7196655273438
      ],
      [
        -860.38818359375,
        -2791.6298828125,
        771.6050415039062
      ],
      [
        -866.22802734375,
        -2787.72802734375,
        777.9482421875
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        780.199462890625
      ],
      [
        -866.22802734375,
        -2762.27197265625,
        774.9745483398438
      ],
      [
        -866.22802734375,
        -2787.72802734375,
        777.9482421875
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        781.8087158203125
      ],
      [
        -871.443359375,
        -2774.71533203125,
        782.5
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        780.1994018554688
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        781.8087768554688
      ],
      [
        -871.328125,
        -2775.8642578125,
        782.5
      ],
      [
        -853.5,
        -2733.0,
        756.7365112304688
      ],
      [
        -860.38818359375,
        -2731.6298828125,
        764.595947265625
      ],
      [
        -860.38818359375,
        -2731.6298828125,
        764.595947265625
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        770.9391479492188
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        770.9391479492188
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        774.7996826171875
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        774.7996826171875
      ],
      [
        -871.5,
        -2715.0,
        775.590087890625
      ],
      [
        -871.5,
        -2715.0,
        775.590087890625
      ],
      [
        -870.9032592773438,
        -2712.0,
        774.544921875
      ],
      [
        -863.1043701171875,
        -2817.20849609375,
        763.0463256835938
      ],
      [
        -861.600341796875,
        -2824.770263671875,
        776.8876342773438
      ],
      [
        -865.3851318359375,
        -2805.7421875,
        737.2188110351562
      ],
      [
        -863.1043701171875,
        -2817.20849609375,
        763.0463256835938
      ],
      [
        -862.3924560546875,
        -2793.468994140625,
        731.7640380859375
      ],
      [
        -857.3999633789062,
        -2800.94091796875,
        762.9126586914062
      ],
      [
        -857.3999633789062,
        -2800.94091796875,
        762.9126586914062
      ],
      [
        -856.3597412109375,
        -2802.49755859375,
        768.1845092773438
      ],
      [
        -863.1659545898438,
        -2733.10107421875,
        744.0
      ],
      [
        -863.1659545898438,
        -2733.10107421875,
        718.0
      ],
      [
        -867.6431884765625,
        -2755.610107421875,
        744.0
      ],
      [
        -867.6431884765625,
        -2755.610107421875,
        718.0
      ],
      [
        -863.64306640625,
        -2735.5,
        744.0
      ],
      [
        -863.1659545898438,
        -2733.10107421875,
        744.0
      ],
      [
        -867.6431884765625,
        -2755.610107421875,
        744.0
      ],
      [
        -867.4223022460938,
        -2754.5,
        744.0
      ],
      [
        -867.4223022460938,
        -2754.5,
        744.0
      ],
      [
        -863.64306640625,
        -2735.5,
        744.0
      ],
      [
        -864.93603515625,
        -2742.0,
        731.0
      ],
      [
        -866.12939453125,
        -2748.0,
        731.0
      ],
      [
        -863.94140625,
        -2737.0,
        744.0
      ],
      [
        -864.93603515625,
        -2742.0,
        731.0
      ],
      [
        -866.12939453125,
        -2748.0,
        731.0
      ],
      [
        -867.1239624023438,
        -2753.0,
        744.0
      ],
      [
        -866.2289428710938,
        -2748.5,
        719.0
      ],
      [
        -865.5,
        -2744.83544921875,
        719.0
      ],
      [
        -866.2289428710938,
        -2748.5,
        718.5
      ],
      [
        -865.5,
        -2744.83544921875,
        718.5
      ],
      [
        -865.5,
        -2744.83544921875,
        719.0
      ],
      [
        -865.5,
        -2744.83544921875,
        718.5
      ],
      [
        -866.2289428710938,
        -2748.5,
        718.5
      ],
      [
        -866.2289428710938,
        -2748.5,
        719.0
      ],
      [
        -862.581787109375,
        -2730.164306640625,
        718.0
      ],
      [
        -862.581787109375,
        -2730.164306640625,
        766.9785766601562
      ],
      [
        -862.7232055664062,
        -2757.0263671875,
        744.0
      ],
      [
        -862.7232055664062,
        -2757.0263671875,
        718.0
      ],
      [
        -859.685791015625,
        -2732.09912109375,
        730.0
      ],
      [
        -854.5955810546875,
        -2735.5,
        744.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        744.0
      ],
      [
        -862.7232055664062,
        -2757.0263671875,
        744.0
      ],
      [
        -861.03515625,
        -2754.5,
        744.0
      ],
      [
        -861.03515625,
        -2754.5,
        744.0
      ],
      [
        -853.5,
        -2743.22216796875,
        744.0
      ],
      [
        -853.5,
        -2736.23193359375,
        744.0
      ],
      [
        -854.5955810546875,
        -2735.5,
        744.0
      ],
      [
        -853.5,
        -2736.23193359375,
        744.0
      ],
      [
        -853.5,
        -2743.22216796875,
        744.0
      ],
      [
        -853.0,
        -2742.473876953125,
        744.0
      ],
      [
        -853.0,
        -2736.566162109375,
        744.0
      ],
      [
        -856.6923828125,
        -2748.0,
        731.0
      ],
      [
        -860.0330200195312,
        -2753.0,
        744.0
      ],
      [
        -856.6923828125,
        -2748.0,
        731.0
      ],
      [
        -853.0,
        -2742.473876953125,
        731.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        730.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        744.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        730.0
      ],
      [
        -853.0,
        -2733.099365234375,
        730.0
      ],
      [
        -853.0,
        -2734.103271484375,
        744.0
      ],
      [
        -856.8466796875,
        -2793.995849609375,
        755.1698608398438
      ],
      [
        -855.3218383789062,
        -2795.0146484375,
        762.8639526367188
      ],
      [
        -855.3218383789062,
        -2795.0146484375,
        762.8639526367188
      ],
      [
        -854.6973266601562,
        -2795.43212890625,
        765.4237060546875
      ],
      [
        -859.685791015625,
        -2757.90087890625,
        730.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        730.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        744.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        730.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        744.0
      ],
      [
        -854.5957641601562,
        -2754.5,
        744.0
      ],
      [
        -854.5957641601562,
        -2754.5,
        744.0
      ],
      [
        -853.5,
        -2753.767822265625,
        744.0
      ],
      [
        -853.5,
        -2753.767822265625,
        744.0
      ],
      [
        -853.0,
        -2753.433837890625,
        744.0
      ],
      [
        -853.0,
        -2756.900634765625,
        730.0
      ],
      [
        -853.0,
        -2755.896484375,
        744.0
      ],
      [
        -970.0,
        -2788.75,
        803.5133056640625
      ],
      [
        -970.0,
        -2718.603271484375,
        785.2112426757812
      ],
      [
        -1012.960693359375,
        -2776.68798828125,
        760.0
      ],
      [
        -1012.9199829101562,
        -2777.22900390625,
        760.0
      ],
      [
        -970.0,
        -2718.603271484375,
        785.2112426757812
      ],
      [
        -970.0,
        -2712.0,
        782.79443359375
      ],
      [
        -1012.7234497070312,
        -2779.8427734375,
        760.0
      ],
      [
        -970.0,
        -2788.75,
        803.5133056640625
      ],
      [
        -970.0,
        -2818.693115234375,
        804.289794921875
      ],
      [
        -970.0,
        -2818.693115234375,
        804.289794921875
      ],
      [
        -970.0,
        -2859.5,
        810.2523193359375
      ],
      [
        -1012.0335693359375,
        -2789.0185546875,
        760.0
      ],
      [
        -977.9397583007812,
        -2857.0,
        760.0
      ],
      [
        -1012.0335693359375,
        -2789.0185546875,
        760.0
      ],
      [
        -977.939697265625,
        -2857.0,
        760.0
      ],
      [
        -970.0,
        -2857.0,
        760.0
      ],
      [
        -970.0,
        -2859.5,
        761.111083984375
      ],
      [
        -1066.1201171875,
        -2774.0,
        726.3181762695312
      ],
      [
        -1066.1202392578125,
        -2774.0,
        723.7416381835938
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -990.0,
        -2774.0,
        723.111083984375
      ],
      [
        -970.0,
        -2774.0,
        723.111083984375
      ],
      [
        -978.9999389648438,
        -2776.0,
        724.000244140625
      ],
      [
        -979.22216796875,
        -2774.0,
        723.1113891601562
      ],
      [
        -980.0,
        -2774.0,
        720.0
      ],
      [
        -970.0,
        -2774.0,
        760.0
      ],
      [
        -1058.0,
        -2712.0,
        756.5
      ],
      [
        -1058.0,
        -2716.5,
        756.5
      ],
      [
        -1058.0,
        -2716.5,
        760.0
      ],
      [
        -1070.0,
        -2714.5,
        754.5
      ],
      [
        -1058.0,
        -2714.5,
        754.5
      ],
      [
        -1058.0,
        -2714.5,
        754.5
      ],
      [
        -1058.0,
        -2714.5,
        756.5
      ],
      [
        -1070.0,
        -2716.5,
        754.5
      ],
      [
        -1058.0,
        -2716.5,
        754.5
      ],
      [
        -1058.0,
        -2716.5,
        754.5
      ],
      [
        -1008.0,
        -2716.5,
        720.0
      ],
      [
        -1008.0,
        -2716.5,
        725.5
      ],
      [
        -1020.0,
        -2720.0,
        757.5
      ],
      [
        -1008.0,
        -2720.0,
        757.5
      ],
      [
        -1070.0,
        -2720.0,
        757.5
      ],
      [
        -1058.0,
        -2720.0,
        757.5
      ],
      [
        -1058.0,
        -2720.0,
        757.5
      ],
      [
        -1058.0,
        -2720.0,
        760.0
      ],
      [
        -1008.0,
        -2720.0,
        722.5
      ],
      [
        -1020.0,
        -2720.0,
        722.5
      ],
      [
        -1008.0,
        -2720.0,
        720.0
      ],
      [
        -1008.0,
        -2720.0,
        722.5
      ],
      [
        -1058.0,
        -2769.5,
        760.0
      ],
      [
        -1058.0,
        -2769.5,
        756.5
      ],
      [
        -1058.0,
        -2774.0,
        756.5
      ],
      [
        -1008.0,
        -2767.0,
        756.5
      ],
      [
        -1008.0,
        -2766.0,
        757.5
      ],
      [
        -1020.0,
        -2766.0,
        757.5
      ],
      [
        -1020.0,
        -2767.0,
        756.5
      ],
      [
        -1058.0,
        -2767.0,
        756.5
      ],
      [
        -1058.0,
        -2766.0,
        757.5
      ],
      [
        -1070.0,
        -2766.0,
        757.5
      ],
      [
        -1070.0,
        -2767.0,
        756.5
      ],
      [
        -1058.0,
        -2766.0,
        760.0
      ],
      [
        -1058.0,
        -2766.0,
        757.5
      ],
      [
        -1058.0,
        -2767.0,
        756.5
      ],
      [
        -1020.0,
        -2766.0,
        722.5
      ],
      [
        -1008.0,
        -2766.0,
        722.5
      ],
      [
        -990.0,
        -2767.0,
        720.0
      ],
      [
        -980.0,
        -2767.0,
        720.0
      ],
      [
        -979.2222900390625,
        -2774.0,
        723.111083984375
      ],
      [
        -1008.0,
        -2774.0,
        723.1112060546875
      ],
      [
        -1008.0,
        -2767.0,
        720.0
      ],
      [
        -1008.0,
        -2766.0,
        722.5
      ],
      [
        -1008.0,
        -2766.0,
        720.0
      ],
      [
        -1070.0,
        -2720.5,
        758.0
      ],
      [
        -1060.0,
        -2722.5,
        760.0
      ],
      [
        -1060.0,
        -2720.5,
        758.0
      ],
      [
        -1060.0,
        -2763.5,
        760.0
      ],
      [
        -1070.0,
        -2765.5,
        758.0
      ],
      [
        -1060.0,
        -2765.5,
        758.0
      ],
      [
        -1068.0,
        -2735.0,
        720.0
      ],
      [
        -1067.0,
        -2733.5,
        720.0
      ],
      [
        -1068.0,
        -2728.5,
        720.0
      ],
      [
        -1067.0,
        -2730.0,
        720.0
      ],
      [
        -1067.0,
        -2733.5,
        720.0
      ],
      [
        -1067.0,
        -2730.0,
        720.0
      ],
      [
        -1060.0,
        -2720.0,
        757.5
      ],
      [
        -1068.0,
        -2751.0,
        720.0
      ],
      [
        -1067.0,
        -2752.5,
        720.0
      ],
      [
        -1068.0,
        -2757.5,
        720.0
      ],
      [
        -1067.0,
        -2756.0,
        720.0
      ],
      [
        -1067.0,
        -2756.0,
        720.0
      ],
      [
        -1067.0,
        -2752.5,
        720.0
      ],
      [
        -1060.0,
        -2766.0,
        757.5
      ],
      [
        -1058.0,
        -2720.5,
        758.0
      ],
      [
        -1060.0,
        -2720.5,
        758.0
      ],
      [
        -1058.0,
        -2720.5,
        758.0
      ],
      [
        -1058.0,
        -2720.0,
        758.0
      ],
      [
        -1058.0,
        -2765.5,
        758.0
      ],
      [
        -1060.0,
        -2765.5,
        758.0
      ],
      [
        -1058.0,
        -2765.5,
        758.0
      ],
      [
        -1058.0,
        -2766.0,
        758.0
      ],
      [
        -1020.0,
        -2720.5,
        758.0
      ],
      [
        -1010.0,
        -2722.5,
        760.0
      ],
      [
        -1010.0,
        -2720.5,
        758.0
      ],
      [
        -1010.0,
        -2763.5,
        760.0
      ],
      [
        -1020.0,
        -2765.5,
        758.0
      ],
      [
        -1010.0,
        -2765.5,
        758.0
      ],
      [
        -1008.0,
        -2720.5,
        758.0
      ],
      [
        -1008.0,
        -2765.5,
        758.0
      ],
      [
        -970.0,
        -2767.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -1068.0,
        -2760.0,
        716.8889770507812
      ],
      [
        -1068.0,
        -2726.0,
        701.77783203125
      ],
      [
        -1046.5,
        -2764.0,
        718.6666870117188
      ],
      [
        -1064.0,
        -2764.0,
        718.6666870117188
      ],
      [
        -1068.0,
        -2760.0,
        716.8889770507812
      ],
      [
        -1064.0,
        -2764.0,
        718.6666870117188
      ],
      [
        -1068.0,
        -2757.5,
        715.77783203125
      ],
      [
        -1067.0,
        -2756.0,
        715.111083984375
      ],
      [
        -1067.0,
        -2756.0,
        715.111083984375
      ],
      [
        -1067.0,
        -2752.5,
        713.5555419921875
      ],
      [
        -1067.0,
        -2733.5,
        705.1111450195312
      ],
      [
        -1067.0,
        -2730.0,
        703.5555419921875
      ],
      [
        -1068.0,
        -2751.0,
        712.888916015625
      ],
      [
        -1067.0,
        -2752.5,
        713.5555419921875
      ],
      [
        -1068.0,
        -2735.0,
        705.7777099609375
      ],
      [
        -1067.0,
        -2733.5,
        705.1111450195312
      ],
      [
        -1068.0,
        -2728.5,
        702.8888549804688
      ],
      [
        -1067.0,
        -2730.0,
        703.5555419921875
      ],
      [
        -1068.0,
        -2726.0,
        701.77783203125
      ],
      [
        -1067.0,
        -2725.0,
        701.3333740234375
      ],
      [
        -1067.0,
        -2725.0,
        680.0
      ],
      [
        -1046.5,
        -2722.0,
        699.9999389648438
      ],
      [
        -1064.0,
        -2722.0,
        699.9999389648438
      ],
      [
        -1064.0,
        -2722.0,
        699.9999389648438
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -880.5184326171875,
        -2766.999755859375,
        720.0
      ],
      [
        -887.5,
        -2766.999755859375,
        720.0
      ],
      [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -894.0,
        -2787.562744140625,
        810.099365234375
      ],
      [
        -894.0,
        -2787.562744140625,
        810.099365234375
      ],
      [
        -894.0,
        -2712.0,
        790.9302978515625
      ],
      [
        -894.0,
        -2859.5,
        824.5013427734375
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -894.0,
        -2788.87353515625,
        810.4149780273438
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2788.87353515625,
        810.4149780273438
      ],
      [
        -884.5228271484375,
        -2724.954833984375,
        783.1830444335938
      ],
      [
        -873.5,
        -2719.897216796875,
        766.400146484375
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2762.8076171875,
        720.0
      ],
      [
        -878.5,
        -2722.19140625,
        774.012939453125
      ],
      [
        -878.5,
        -2712.0,
        770.4376831054688
      ],
      [
        -878.5,
        -2754.5,
        720.0
      ],
      [
        -878.5,
        -2735.5,
        720.0
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -932.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -914.0,
        -2855.230712890625,
        831.371337890625
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -914.0,
        -2859.5,
        832.5732421875
      ],
      [
        -914.0,
        -2855.230712890625,
        831.371337890625
      ],
      [
        -914.0,
        -2833.164306640625,
        825.159423828125
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -914.0,
        -2833.164306640625,
        825.159423828125
      ],
      [
        -914.0,
        -2788.75,
        812.65625
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -928.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -918.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -918.0,
        -2853.0,
        830.743408203125
      ],
      [
        -918.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -919.0,
        -2852.0,
        830.4619140625
      ],
      [
        -927.0,
        -2852.0,
        830.4619140625
      ],
      [
        -954.572998046875,
        -2978.0,
        817.5613403320312
      ],
      [
        -956.2754516601562,
        -2978.0,
        817.5243530273438
      ],
      [
        -944.0224609375,
        -2978.0,
        801.9602661132812
      ],
      [
        -954.572998046875,
        -2978.0,
        817.5613403320312
      ],
      [
        -956.2754516601562,
        -2978.0,
        817.5243530273438
      ],
      [
        -957.1927490234375,
        -2978.0,
        820.763671875
      ],
      [
        -957.2632446289062,
        -2978.0,
        836.5609130859375
      ],
      [
        -957.1927490234375,
        -2978.0,
        820.763671875
      ],
      [
        -957.5886840820312,
        -2978.0,
        841.4196166992188
      ],
      [
        -957.2632446289062,
        -2978.0,
        836.5609130859375
      ],
      [
        -957.5886840820312,
        -2978.0,
        841.4196166992188
      ],
      [
        -957.2863159179688,
        -2978.0,
        841.7111206054688
      ],
      [
        -914.2279052734375,
        -2978.0,
        859.777587890625
      ],
      [
        -893.377685546875,
        -2978.0,
        842.0687866210938
      ],
      [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      [
        -914.2279052734375,
        -2978.0,
        859.777587890625
      ],
      [
        -934.7142944335938,
        -2978.0,
        859.526611328125
      ],
      [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      [
        -934.7142944335938,
        -2978.0,
        859.526611328125
      ],
      [
        -957.1957397460938,
        -2978.0,
        821.439697265625
      ],
      [
        -957.1978759765625,
        -2978.0,
        821.9124755859375
      ],
      [
        -954.774169921875,
        -2978.0,
        844.1331176757812
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.2780352234840393,
        0.9369372129440308,
        0.2117668241262436
      ],
      "plane_d": 2668.039794921875,
      "bbox_min": [
        -1403.4910888671875,
        -3470.2734375,
        507.9460754394531
      ],
      "bbox_max": [
        -773.760498046875,
        -3115.6298828125,
        1323.6763916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9616637229919434,
        0.25931835174560547,
        0.08920100331306458
      ],
      "plane_d": 2092.122802734375,
      "bbox_min": [
        -1403.4910888671875,
        -3321.37109375,
        507.9460754394531
      ],
      "bbox_max": [
        -1324.896728515625,
        -3115.6298828125,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9655990600585938,
        0.23379258811473846,
        0.11383970826864243
      ],
      "plane_d": 1997.5523681640625,
      "bbox_min": [
        -1392.2449951171875,
        -3321.37109375,
        507.9460754394531
      ],
      "bbox_max": [
        -1324.896728515625,
        -3115.6298828125,
        624.2720947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9320849776268005,
        0.2389715313911438,
        0.2722319960594177
      ],
      "plane_d": 1873.2095947265625,
      "bbox_min": [
        -1392.2449951171875,
        -3321.37109375,
        593.9807739257812
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3115.6298828125,
        624.2720947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        -1070.0,
        -3053.61669921875,
        650.0
      ],
      "bbox_max": [
        -567.0,
        -2559.375,
        867.4175415039062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -824.0,
      "bbox_min": [
        -1070.0,
        -2978.0,
        658.0
      ],
      "bbox_max": [
        -567.0,
        -2559.375,
        863.8005981445312
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -824.0,
        -2870.0,
        715.0
      ],
      "bbox_max": [
        -567.0,
        -2630.0,
        840.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -816.0,
        -2688.0,
        715.0
      ],
      "bbox_max": [
        -610.0,
        -2630.0,
        840.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -656.0,
        -2633.0,
        775.0
      ],
      "bbox_max": [
        -610.0,
        -2630.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -816.0,
        -2688.0,
        715.0
      ],
      "bbox_max": [
        -656.0,
        -2630.0,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -732.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2630.0,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -718.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.776832818402909e-05,
        -0.9284732937812805,
        0.3713994026184082
      ],
      "plane_d": -2777.97509765625,
      "bbox_min": [
        -658.0,
        -2686.800048828125,
        763.0
      ],
      "bbox_max": [
        -656.0,
        -2685.60009765625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -718.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -718.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9941065907478333,
        -0.10840680450201035
      ],
      "plane_d": -2582.17919921875,
      "bbox_min": [
        -732.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2630.0,
        830.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -687.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2630.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -687.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2630.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -687.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2630.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -682.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2667.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 71.74334716796875,
      "bbox_min": [
        -732.0,
        -2686.907958984375,
        790.0
      ],
      "bbox_max": [
        -698.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -725.0,
        -2686.907958984375,
        804.727294921875
      ],
      "bbox_max": [
        -705.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -718.0,
        -2685.8173828125,
        804.727294921875
      ],
      "bbox_max": [
        -718.0,
        -2678.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -718.0,
        -2685.46435546875,
        790.0
      ],
      "bbox_max": [
        -718.0,
        -2678.0,
        806.7630004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -732.0,
        -2683.63623046875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2630.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -732.0,
        -2683.63623046875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2630.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -718.0,
        -2683.63623046875,
        784.0
      ],
      "bbox_max": [
        -718.0,
        -2678.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -720.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2667.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -720.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -720.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -718.0,
        -2688.0,
        820.0
      ],
      "bbox_max": [
        -705.0,
        -2686.907958984375,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732937812805,
        0.3713993728160858
      ],
      "plane_d": -2778.0,
      "bbox_min": [
        -718.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -689.0,
      "bbox_min": [
        -689.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 71.74334716796875,
      "bbox_min": [
        -732.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2681.01904296875,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -725.0,
        -2688.0,
        820.0
      ],
      "bbox_max": [
        -718.0,
        -2686.907958984375,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -720.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732937812805,
        0.3713993728160858
      ],
      "plane_d": -2778.0,
      "bbox_min": [
        -720.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -816.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2630.0,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -812.4000244140625,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2633.0,
        766.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -749.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -749.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -806.0,
        -2685.60009765625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284753799438477,
        0.37139391899108887
      ],
      "plane_d": -2778.001220703125,
      "bbox_min": [
        -808.0,
        -2686.800048828125,
        763.0
      ],
      "bbox_max": [
        -806.0,
        -2685.60009765625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9941065907478333,
        -0.10840680450201035
      ],
      "plane_d": -2582.17919921875,
      "bbox_min": [
        -816.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2630.0,
        830.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -780.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2630.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -749.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2630.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -749.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2630.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -749.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2630.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -749.0,
        -2633.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2630.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -780.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2630.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -780.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2630.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -775.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2667.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -751.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -816.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2630.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -816.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2630.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -782.0,
      "bbox_min": [
        -806.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -782.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2667.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -749.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -780.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -751.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -782.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        -824.0,
        -2870.0,
        715.0
      ],
      "bbox_max": [
        -567.0,
        -2688.0,
        840.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2737.0,
      "bbox_min": [
        -824.0,
        -2745.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        -824.0,
        -2745.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -824.0,
        -2745.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -795.0,
        -2745.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2753.0,
      "bbox_min": [
        -824.0,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2745.0,
        740.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2754.0,
      "bbox_min": [
        -824.0,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -807.199951171875,
        -2754.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -824.0,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -807.199951171875,
        -2754.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -824.0,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -807.199951171875,
        -2754.0,
        735.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -807.199951171875,
      "bbox_min": [
        -823.0,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -807.199951171875,
        -2754.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.0,
      "bbox_min": [
        -823.0,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -809.5,
        -2754.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 819.199951171875,
      "bbox_min": [
        -819.599853515625,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -812.800048828125,
        -2766.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2766.39990234375,
      "bbox_min": [
        -819.599853515625,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -819.199951171875,
        -2766.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -819.599853515625,
      "bbox_min": [
        -819.599853515625,
        -2766.39990234375,
        721.0
      ],
      "bbox_max": [
        -819.599853515625,
        -2766.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -819.599853515625,
      "bbox_min": [
        -819.599853515625,
        -2772.0,
        722.0
      ],
      "bbox_max": [
        -819.199951171875,
        -2766.400146484375,
        730.0114135742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -730.0114135742188,
      "bbox_min": [
        -819.599853515625,
        -2772.0,
        722.0
      ],
      "bbox_max": [
        -819.199951171875,
        -2766.400146484375,
        730.0114135742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 722.0,
      "bbox_min": [
        -819.599853515625,
        -2772.0,
        722.0
      ],
      "bbox_max": [
        -819.199951171875,
        -2766.400146484375,
        722.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2766.39990234375,
      "bbox_min": [
        -813.199951171875,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -812.800048828125,
        -2766.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 812.800048828125,
      "bbox_min": [
        -813.199951171875,
        -2766.39990234375,
        721.0
      ],
      "bbox_max": [
        -812.800048828125,
        -2766.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -813.199951171875,
      "bbox_min": [
        -813.199951171875,
        -2766.39990234375,
        721.0
      ],
      "bbox_max": [
        -813.199951171875,
        -2766.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -813.199951171875,
      "bbox_min": [
        -813.199951171875,
        -2772.0,
        722.0
      ],
      "bbox_max": [
        -812.800048828125,
        -2766.400146484375,
        730.0114135742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 812.800048828125,
      "bbox_min": [
        -813.199951171875,
        -2772.0,
        722.0
      ],
      "bbox_max": [
        -812.800048828125,
        -2766.400146484375,
        730.0114135742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -730.0114135742188,
      "bbox_min": [
        -813.199951171875,
        -2772.0,
        722.0
      ],
      "bbox_max": [
        -812.800048828125,
        -2766.400146484375,
        730.0114135742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 722.0,
      "bbox_min": [
        -813.199951171875,
        -2772.0,
        722.0
      ],
      "bbox_max": [
        -812.800048828125,
        -2766.400146484375,
        722.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -817.10009765625,
      "bbox_min": [
        -823.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -809.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 812.5,
      "bbox_min": [
        -817.10009765625,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -809.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -814.0,
      "bbox_min": [
        -817.10009765625,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -812.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3714102506637573,
        -0.9284689426422119
      ],
      "plane_d": -351.02374267578125,
      "bbox_min": [
        -814.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -812.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.4000244140625,
      "bbox_min": [
        -814.0,
        -2755.0,
        724.0
      ],
      "bbox_max": [
        -812.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2755.0,
      "bbox_min": [
        -814.0,
        -2755.0,
        724.0
      ],
      "bbox_max": [
        -812.5,
        -2755.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3714102506637573,
        -0.9284689426422119
      ],
      "plane_d": -351.02374267578125,
      "bbox_min": [
        -817.10009765625,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -815.60009765625,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.4000244140625,
      "bbox_min": [
        -817.10009765625,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -815.60009765625,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2755.0,
      "bbox_min": [
        -817.10009765625,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -815.60009765625,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 815.60009765625,
      "bbox_min": [
        -815.60009765625,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -815.60009765625,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3714102506637573,
        -0.9284689426422119
      ],
      "plane_d": -351.02374267578125,
      "bbox_min": [
        -811.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -809.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.4000244140625,
      "bbox_min": [
        -811.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -809.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2755.0,
      "bbox_min": [
        -811.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -809.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -811.0,
      "bbox_min": [
        -811.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -809.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 809.5,
      "bbox_min": [
        -809.5,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -809.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        -823.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -818.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3714102506637573,
        -0.9284689426422119
      ],
      "plane_d": -351.02374267578125,
      "bbox_min": [
        -820.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -818.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.4000244140625,
      "bbox_min": [
        -820.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -818.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2755.0,
      "bbox_min": [
        -820.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -818.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 818.5,
      "bbox_min": [
        -818.5,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -818.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3714102506637573,
        -0.9284689426422119
      ],
      "plane_d": -351.02374267578125,
      "bbox_min": [
        -823.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -821.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.4000244140625,
      "bbox_min": [
        -823.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -821.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2755.0,
      "bbox_min": [
        -823.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -821.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -823.0,
      "bbox_min": [
        -823.0,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -821.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -821.5,
        -2755.0,
        723.5999755859375
      ],
      "bbox_max": [
        -821.5,
        -2754.0,
        724.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        -824.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2745.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2752.0,
      "bbox_min": [
        -824.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -822.0,
        -2752.0,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 822.0,
      "bbox_min": [
        -824.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -822.0,
        -2752.0,
        731.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1429.77001953125,
      "bbox_min": [
        -824.0,
        -2753.0,
        730.0
      ],
      "bbox_max": [
        -822.0,
        -2752.0,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -701.4999389648438,
      "bbox_min": [
        -824.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -567.0,
        -2688.0,
        840.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -701.5,
        -2745.0,
        775.0
      ],
      "bbox_max": [
        -633.0,
        -2688.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9061829447746277,
        0.0,
        -0.4228859841823578
      ],
      "plane_d": -268.83380126953125,
      "bbox_min": [
        -701.5,
        -2745.0,
        775.0
      ],
      "bbox_max": [
        -633.0,
        -2688.0,
        830.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -684.0,
        -2745.0,
        775.0
      ],
      "bbox_max": [
        -633.0,
        -2688.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -684.0,
        -2745.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2736.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -656.0,
        -2745.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2736.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -656.0,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -656.0,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -646.5,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2690.0,
        827.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2720.0,
      "bbox_min": [
        -646.5,
        -2720.0,
        823.25
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        823.25
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 785.0,
      "bbox_min": [
        -682.5999755859375,
        -2736.0,
        785.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -682.5999755859375,
        -2736.0,
        785.0
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -681.5,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -681.5,
        -2732.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2732.0,
      "bbox_min": [
        -679.800048828125,
        -2732.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2691.5,
        821.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2691.5,
      "bbox_min": [
        -679.800048828125,
        -2693.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2691.5,
        821.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": -2171.512451171875,
      "bbox_min": [
        -677.2333984375,
        -2693.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2691.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -701.5,
        -2745.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        -700.0,
        -2727.5,
        827.5
      ],
      "bbox_max": [
        -697.5,
        -2712.5,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2510.229248046875,
      "bbox_min": [
        -700.0,
        -2722.5,
        827.5
      ],
      "bbox_max": [
        -697.5,
        -2717.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1336.431884765625,
      "bbox_min": [
        -700.0,
        -2720.0,
        827.5
      ],
      "bbox_max": [
        -697.5,
        -2717.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        -701.5,
        -2745.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2692.0,
        827.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2510.229248046875,
      "bbox_min": [
        -700.0,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2700.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1336.431884765625,
      "bbox_min": [
        -700.0,
        -2717.5,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2700.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2692.0,
      "bbox_min": [
        -701.5,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2692.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -701.5,
        -2745.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 71.74334716796875,
      "bbox_min": [
        -701.5,
        -2690.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2688.166748046875,
        808.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2740.0,
      "bbox_min": [
        -701.5,
        -2740.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2740.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 71.74334716796875,
      "bbox_min": [
        -701.5,
        -2688.166748046875,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -701.5,
        -2805.0,
        775.0
      ],
      "bbox_max": [
        -567.0,
        -2745.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -701.5,
        -2805.0,
        775.0
      ],
      "bbox_max": [
        -567.0,
        -2745.0,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -656.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2748.0,
        827.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -597.0,
      "bbox_min": [
        -629.0,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -567.0,
        -2758.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.768221378326416
      ],
      "plane_d": 267.7251892089844,
      "bbox_min": [
        -573.0,
        -2772.0,
        821.0
      ],
      "bbox_max": [
        -567.0,
        -2758.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -2393.556640625,
      "bbox_min": [
        -629.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.989777147769928,
        -0.14262303709983826
      ],
      "plane_d": 2858.98291015625,
      "bbox_min": [
        -629.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990997791290283,
        0.6990997791290283,
        -0.1500629037618637
      ],
      "plane_d": 1623.5672607421875,
      "bbox_min": [
        -629.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1535.12890625,
      "bbox_min": [
        -629.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2775.416015625,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9869229197502136,
        -0.16119296848773956
      ],
      "plane_d": -2616.993896484375,
      "bbox_min": [
        -629.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -617.0,
        -2775.416015625,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2244.845458984375,
      "bbox_min": [
        -629.0,
        -2786.0,
        810.0
      ],
      "bbox_max": [
        -623.36376953125,
        -2775.416015625,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229793548584,
        0.0,
        0.16119298338890076
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.293212890625,
        -2780.36376953125,
        810.0
      ],
      "bbox_max": [
        -627.1298828125,
        -2775.416015625,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -627.293212890625,
        -2784.1298828125,
        810.0
      ],
      "bbox_max": [
        -623.36376953125,
        -2779.966552734375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229793548584,
        0.0,
        0.16119298338890076
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      "bbox_max": [
        -627.1298828125,
        -2779.966552734375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2788.0,
      "bbox_min": [
        -625.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -617.0,
        -2783.96630859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -623.7611083984375,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -623.36376953125,
        -2783.96630859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998983383179,
        0.6990998983383179,
        0.1500629186630249
      ],
      "plane_d": 1380.1656494140625,
      "bbox_min": [
        -627.293212890625,
        -2775.7939453125,
        810.0
      ],
      "bbox_max": [
        -623.36376953125,
        -2771.64990234375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229793548584,
        0.0,
        0.16119298338890076
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.293212890625,
        -2775.7939453125,
        810.0
      ],
      "bbox_max": [
        -627.1298828125,
        -2775.36474609375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2768.0,
      "bbox_min": [
        -625.0,
        -2771.7939453125,
        810.0
      ],
      "bbox_max": [
        -617.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998983383179,
        0.6990998983383179,
        0.1500629186630249
      ],
      "plane_d": 1380.1656494140625,
      "bbox_min": [
        -623.722412109375,
        -2771.7939453125,
        810.0
      ],
      "bbox_max": [
        -623.36376953125,
        -2771.505859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.0,
      "bbox_min": [
        -656.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2756.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -656.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2756.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -602.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2756.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -623.434326171875,
        -2756.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -646.5,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -623.434326171875,
        -2756.0,
        810.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -646.5,
        -2788.5,
        798.75
      ],
      "bbox_max": [
        -623.434326171875,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998983383179,
        0.6990998983383179,
        0.1500629186630249
      ],
      "plane_d": 1380.1656494140625,
      "bbox_min": [
        -629.0,
        -2781.171630859375,
        799.5499877929688
      ],
      "bbox_max": [
        -623.434326171875,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229793548584,
        0.0,
        0.16119298338890076
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -629.0,
        -2781.171630859375,
        799.5499877929688
      ],
      "bbox_max": [
        -627.293212890625,
        -2774.828369140625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547002553939819
      ],
      "plane_d": 2765.3193359375,
      "bbox_min": [
        -646.5,
        -2788.5,
        798.75
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.0,
      "bbox_min": [
        -646.5,
        -2786.0,
        806.25
      ],
      "bbox_max": [
        -645.0,
        -2786.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547002553939819
      ],
      "plane_d": -1857.55224609375,
      "bbox_min": [
        -646.5,
        -2788.5,
        798.75
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        806.25
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 1875.025390625,
      "bbox_min": [
        -646.5,
        -2788.5,
        798.75
      ],
      "bbox_max": [
        -645.0,
        -2786.0,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -701.5,
        -2805.0,
        775.0
      ],
      "bbox_max": [
        -656.0,
        -2745.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941022396087646,
        -0.10844772309064865
      ],
      "plane_d": 2875.486083984375,
      "bbox_min": [
        -687.0,
        -2805.0,
        802.5000610351562
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9061815142631531,
        -0.0,
        -0.42288893461227417
      ],
      "plane_d": -268.830322265625,
      "bbox_min": [
        -684.0,
        -2802.0,
        785.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        830.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -684.0,
        -2802.0,
        785.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 785.0,
      "bbox_min": [
        -673.5,
        -2802.0,
        785.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -673.5,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 805.0,
      "bbox_min": [
        -673.5,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -672.333251953125,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2758.0,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -860.894775390625,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320503234863281
      ],
      "plane_d": 2221.01953125,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2796.5,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 887.6589965820312,
      "bbox_min": [
        -669.300048828125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2796.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -701.5,
        -2805.0,
        802.4999389648438
      ],
      "bbox_max": [
        -687.0,
        -2745.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941022396087646,
        -0.10844772309064865
      ],
      "plane_d": 2875.486083984375,
      "bbox_min": [
        -701.5,
        -2802.272705078125,
        827.5
      ],
      "bbox_max": [
        -687.0,
        -2762.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -701.5,
        -2800.0,
        827.5
      ],
      "bbox_max": [
        -698.0,
        -2770.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        -700.0,
        -2777.5,
        827.5
      ],
      "bbox_max": [
        -700.0,
        -2770.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        -700.0,
        -2770.0,
        827.5
      ],
      "bbox_max": [
        -697.5,
        -2762.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -700.0,
        -2770.0,
        827.5
      ],
      "bbox_max": [
        -697.5,
        -2767.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        -700.0,
        -2804.181884765625,
        810.0
      ],
      "bbox_max": [
        -687.0,
        -2745.0,
        827.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -700.0,
        -2804.181884765625,
        810.0
      ],
      "bbox_max": [
        -687.0,
        -2750.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941022396087646,
        -0.10844772309064865
      ],
      "plane_d": 2875.486083984375,
      "bbox_min": [
        -698.0,
        -2804.181884765625,
        810.0
      ],
      "bbox_max": [
        -687.0,
        -2802.272705078125,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -700.0,
        -2767.5,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2750.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941022396087646,
        -0.10844772309064865
      ],
      "plane_d": 2875.486083984375,
      "bbox_min": [
        -701.5,
        -2805.0,
        802.4999389648438
      ],
      "bbox_max": [
        -687.0,
        -2745.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 1516.258056640625,
      "bbox_min": [
        -701.5,
        -2805.0,
        806.6363525390625
      ],
      "bbox_max": [
        -698.0,
        -2804.534912109375,
        806.76318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -701.5,
        -2804.534912109375,
        806.76318359375
      ],
      "bbox_max": [
        -697.5,
        -2745.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 1516.258056640625,
      "bbox_min": [
        -701.5,
        -2801.833251953125,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        808.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2750.0,
      "bbox_min": [
        -701.5,
        -2750.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2750.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 1516.258056640625,
      "bbox_min": [
        -701.5,
        -2804.534912109375,
        806.76318359375
      ],
      "bbox_max": [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -701.5,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -580.0,
        -2688.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2730.0,
      "bbox_min": [
        -701.5,
        -2730.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2728.199951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7432851195335388,
        0.668974757194519
      ],
      "plane_d": -2540.26513671875,
      "bbox_min": [
        -701.5,
        -2730.0,
        764.0
      ],
      "bbox_max": [
        -656.0,
        -2728.199951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -701.5,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.7432851195335388,
        0.668974757194519
      ],
      "plane_d": 1540.3702392578125,
      "bbox_min": [
        -701.5,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284767508506775,
        0.371390700340271
      ],
      "plane_d": 2319.3349609375,
      "bbox_min": [
        -687.0,
        -2804.39990234375,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -687.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -689.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -689.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732937812805,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -687.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2804.39990234375,
        767.5001831054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -657.9999389648438,
      "bbox_min": [
        -658.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2804.39990234375,
        767.5001831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732937812805,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -689.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2804.39990234375,
        767.5001831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -688.9999389648438,
      "bbox_min": [
        -689.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2804.39990234375,
        767.5001831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -824.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -701.5,
        -2688.0,
        840.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -824.0,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2688.199951171875,
        790.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.4472135901451111,
        -0.0
      ],
      "plane_d": 1955.6650390625,
      "bbox_min": [
        -824.0,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2688.199951171875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -824.0,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2734.0,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.4472135901451111,
        0.0
      ],
      "plane_d": -499.5375671386719,
      "bbox_min": [
        -824.0,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2734.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2756.0,
        765.0
      ],
      "bbox_max": [
        -815.5999755859375,
        -2734.0,
        777.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.199951171875,
      "bbox_min": [
        -819.5,
        -2756.0,
        765.0
      ],
      "bbox_max": [
        -815.5999755859375,
        -2734.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 777.5,
      "bbox_min": [
        -819.5,
        -2741.800048828125,
        777.5
      ],
      "bbox_max": [
        -815.5999755859375,
        -2734.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 777.5,
      "bbox_min": [
        -819.5,
        -2756.0,
        777.5
      ],
      "bbox_max": [
        -815.5999755859375,
        -2748.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.4472135901451111,
        -0.0
      ],
      "plane_d": 1982.497802734375,
      "bbox_min": [
        -824.0,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2748.199951171875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -815.5999755859375,
        -2794.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2801.800048828125,
      "bbox_min": [
        -819.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -815.5999755859375,
        -2794.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 777.5,
      "bbox_min": [
        -819.5,
        -2801.800048828125,
        777.5
      ],
      "bbox_max": [
        -815.5999755859375,
        -2794.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.0,
      "bbox_min": [
        -821.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2748.199951171875,
        790.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -814.0,
      "bbox_min": [
        -819.5,
        -2760.0,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2748.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2760.0,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2748.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.199951171875,
      "bbox_min": [
        -819.5,
        -2760.0,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2748.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 777.5,
      "bbox_min": [
        -819.5,
        -2760.0,
        777.5
      ],
      "bbox_max": [
        -814.0,
        -2748.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        -0.44721361994743347,
        0.0
      ],
      "plane_d": -1961.03173828125,
      "bbox_min": [
        -821.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2760.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2871.83935546875,
      "bbox_min": [
        -808.5499877929688,
        -2769.0,
        766.9635620117188
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        774.0364379882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -808.5499877929688,
        -2769.0,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        774.0364379882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2790.0,
      "bbox_min": [
        -821.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -814.0,
      "bbox_min": [
        -819.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2790.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2790.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2801.800048828125,
      "bbox_min": [
        -819.5,
        -2801.800048828125,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2790.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 777.5,
      "bbox_min": [
        -819.5,
        -2801.800048828125,
        777.5
      ],
      "bbox_max": [
        -814.0,
        -2790.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": 521.00390625,
      "bbox_min": [
        -812.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2427.648193359375,
      "bbox_min": [
        -808.550048828125,
        -2782.10009765625,
        766.9638061523438
      ],
      "bbox_max": [
        -808.0,
        -2781.0,
        774.0361938476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -808.550048828125,
        -2782.10009765625,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2781.0,
        774.0361938476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -810.5,
        -2785.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        790.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -810.5,
        -2785.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2785.0,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2780.7001953125,
      "bbox_min": [
        -810.0,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2780.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -776.0,
      "bbox_min": [
        -810.5,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -810.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2769.2998046875,
      "bbox_min": [
        -810.5,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -810.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2780.7001953125,
      "bbox_min": [
        -810.5,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -810.0,
        -2780.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": 2426.12060546875,
      "bbox_min": [
        -810.5,
        -2785.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2785.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2778.7890625,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2427.648193359375,
      "bbox_min": [
        -810.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2780.7001953125,
        773.07177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -810.0,
        -2782.10009765625,
        770.5
      ],
      "bbox_max": [
        -808.1500244140625,
        -2781.300048828125,
        773.07177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2427.648193359375,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        765.0
      ],
      "bbox_max": [
        -810.0,
        -2780.699951171875,
        773.07177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.000244140625
      ],
      "plane_d": -2780.51318359375,
      "bbox_min": [
        -810.5,
        -2780.7001953125,
        765.0
      ],
      "bbox_max": [
        -810.0,
        -2780.699951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": 2883.87109375,
      "bbox_min": [
        -810.5,
        -2781.89990234375,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2781.89990234375,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2779.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -810.0,
        -2781.300048828125,
        773.0717163085938
      ],
      "bbox_max": [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -810.5,
        -2781.300048828125,
        773.07177734375
      ],
      "bbox_max": [
        -810.0,
        -2780.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -810.5,
        -2779.10009765625,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2779.10009765625,
        765.0
      ],
      "bbox_max": [
        -810.0,
        -2765.0,
        766.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2770.89990234375,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2765.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2871.83935546875,
      "bbox_min": [
        -810.0,
        -2769.2998046875,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        773.0721435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -810.0,
        -2768.7001953125,
        770.5
      ],
      "bbox_max": [
        -808.1499633789062,
        -2767.89990234375,
        773.0721435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2871.83935546875,
      "bbox_min": [
        -810.5,
        -2769.2998046875,
        766.0
      ],
      "bbox_max": [
        -810.0,
        -2767.89990234375,
        773.0722045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": -2415.616943359375,
      "bbox_min": [
        -810.5,
        -2770.89990234375,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2768.100341796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2770.89990234375,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2768.100341796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -810.0,
        -2769.2998046875,
        773.072021484375
      ],
      "bbox_max": [
        -808.0,
        -2768.699951171875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -810.5,
        -2769.2998046875,
        773.0721435546875
      ],
      "bbox_max": [
        -810.0,
        -2768.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -824.0,
        -2741.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2688.199951171875,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.4472135901451111,
        0.0
      ],
      "plane_d": -472.70477294921875,
      "bbox_min": [
        -824.0,
        -2741.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2688.199951171875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2696.0,
        765.0
      ],
      "bbox_max": [
        -815.5999755859375,
        -2688.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 777.5,
      "bbox_min": [
        -819.5,
        -2696.0,
        777.5
      ],
      "bbox_max": [
        -815.5999755859375,
        -2688.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2730.0,
      "bbox_min": [
        -821.5,
        -2741.800048828125,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2688.199951171875,
        790.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -814.0,
      "bbox_min": [
        -819.5,
        -2741.800048828125,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2730.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2741.800048828125,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2730.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 777.5,
      "bbox_min": [
        -819.5,
        -2741.800048828125,
        777.5
      ],
      "bbox_max": [
        -814.0,
        -2730.0,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": 494.1710205078125,
      "bbox_min": [
        -821.5,
        -2730.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2688.199951171875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2370.3564453125,
      "bbox_min": [
        -808.550048828125,
        -2722.10009765625,
        766.9638061523438
      ],
      "bbox_max": [
        -808.0,
        -2721.0,
        774.0361938476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -808.550048828125,
        -2722.10009765625,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2721.0,
        774.0361938476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2700.0,
      "bbox_min": [
        -821.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2688.199951171875,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -814.0,
      "bbox_min": [
        -819.5,
        -2700.0,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2688.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 819.5,
      "bbox_min": [
        -819.5,
        -2700.0,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2688.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 777.5,
      "bbox_min": [
        -819.5,
        -2700.0,
        777.5
      ],
      "bbox_max": [
        -814.0,
        -2688.199951171875,
        777.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        -0.44721361994743347,
        0.0
      ],
      "plane_d": -1934.198974609375,
      "bbox_min": [
        -812.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2700.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2814.547607421875,
      "bbox_min": [
        -808.5499877929688,
        -2709.0,
        766.9635620117188
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        774.0364379882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2356.79736328125,
      "bbox_min": [
        -808.5499877929688,
        -2709.0,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        774.0364379882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -810.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        790.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -810.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2725.0,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2720.7001953125,
      "bbox_min": [
        -810.0,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -776.0,
      "bbox_min": [
        -810.5,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -810.0,
        -2709.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2709.2998046875,
      "bbox_min": [
        -810.5,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -810.0,
        -2709.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2720.7001953125,
      "bbox_min": [
        -810.5,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -810.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": 2368.828857421875,
      "bbox_min": [
        -810.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -809.9999389648438,
      "bbox_min": [
        -810.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2718.7890625,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2370.3564453125,
      "bbox_min": [
        -810.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2720.7001953125,
        773.07177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -810.0,
        -2722.10009765625,
        770.5
      ],
      "bbox_max": [
        -808.1500244140625,
        -2721.300048828125,
        773.07177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2370.3564453125,
      "bbox_min": [
        -810.5,
        -2722.10009765625,
        765.0
      ],
      "bbox_max": [
        -810.0,
        -2720.699951171875,
        773.07177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.000244140625
      ],
      "plane_d": -2720.51318359375,
      "bbox_min": [
        -810.5,
        -2720.7001953125,
        765.0
      ],
      "bbox_max": [
        -810.0,
        -2720.699951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": 2826.5791015625,
      "bbox_min": [
        -810.5,
        -2721.89990234375,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -809.9999389648438,
      "bbox_min": [
        -810.5,
        -2721.89990234375,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2719.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -810.0,
        -2721.300048828125,
        773.0717163085938
      ],
      "bbox_max": [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -810.5,
        -2721.300048828125,
        773.07177734375
      ],
      "bbox_max": [
        -810.0,
        -2720.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -810.5,
        -2719.10009765625,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2719.10009765625,
        765.0
      ],
      "bbox_max": [
        -810.0,
        -2705.0,
        766.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2710.89990234375,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2814.547607421875,
      "bbox_min": [
        -810.0,
        -2709.2998046875,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        773.0721435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2356.79736328125,
      "bbox_min": [
        -810.0,
        -2708.7001953125,
        770.5
      ],
      "bbox_max": [
        -808.1499633789062,
        -2707.89990234375,
        773.0721435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2814.547607421875,
      "bbox_min": [
        -810.5,
        -2709.2998046875,
        766.0
      ],
      "bbox_max": [
        -810.0,
        -2707.89990234375,
        773.0722045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": -2358.3251953125,
      "bbox_min": [
        -810.5,
        -2710.89990234375,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2708.100341796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -810.5,
        -2710.89990234375,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2708.100341796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2356.79736328125,
      "bbox_min": [
        -810.0,
        -2709.2998046875,
        773.072021484375
      ],
      "bbox_max": [
        -808.0,
        -2708.699951171875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -808.0,
        -2745.0,
        760.0
      ],
      "bbox_max": [
        -701.5,
        -2688.0,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -732.0,
        -2745.0,
        760.0
      ],
      "bbox_max": [
        -701.5,
        -2688.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -732.0,
        -2745.0,
        829.5
      ],
      "bbox_max": [
        -701.5,
        -2688.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        -732.0,
        -2745.0,
        829.5
      ],
      "bbox_max": [
        -728.5,
        -2690.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -730.0,
        -2690.0,
        829.5
      ],
      "bbox_max": [
        -728.5,
        -2690.0,
        829.7142944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -732.0,
        -2720.5,
        829.5
      ],
      "bbox_max": [
        -730.0,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        829.5
      ],
      "bbox_max": [
        -730.0,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -732.0,
        -2720.5,
        829.5
      ],
      "bbox_max": [
        -730.0,
        -2720.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        -732.0,
        -2745.0,
        810.0
      ],
      "bbox_max": [
        -701.5,
        -2688.0,
        829.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -730.0,
        -2690.0,
        827.5
      ],
      "bbox_max": [
        -701.5,
        -2690.0,
        829.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -730.0,
        -2692.0,
        810.0
      ],
      "bbox_max": [
        -701.5,
        -2688.0,
        827.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -725.0,
        -2690.0,
        820.0
      ],
      "bbox_max": [
        -705.0,
        -2688.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2692.0,
      "bbox_min": [
        -730.0,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2692.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -732.0,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2690.0,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2690.0,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -732.0,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2720.5,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2730.0,
      "bbox_min": [
        -732.0,
        -2730.0,
        760.0
      ],
      "bbox_max": [
        -701.5,
        -2728.199951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7432851195335388,
        0.668974757194519
      ],
      "plane_d": -2540.26513671875,
      "bbox_min": [
        -732.0,
        -2730.0,
        764.0
      ],
      "bbox_max": [
        -701.5,
        -2728.199951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.0,
        -2745.0,
        807.4545288085938
      ],
      "bbox_max": [
        -701.5,
        -2688.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2700.0,
      "bbox_min": [
        -732.0,
        -2740.0,
        807.5
      ],
      "bbox_max": [
        -701.5,
        -2688.166748046875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 71.74334716796875,
      "bbox_min": [
        -732.0,
        -2690.0,
        807.5
      ],
      "bbox_max": [
        -701.5,
        -2688.166748046875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        808.0
      ],
      "bbox_max": [
        -729.2000122070312,
        -2690.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2740.0,
      "bbox_min": [
        -732.0,
        -2740.0,
        807.5
      ],
      "bbox_max": [
        -701.5,
        -2740.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 71.74334716796875,
      "bbox_min": [
        -732.0,
        -2688.166748046875,
        807.4545288085938
      ],
      "bbox_max": [
        -701.5,
        -2688.0,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -808.0,
        -2745.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2688.0,
        830.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7432851195335388,
        0.668974757194519
      ],
      "plane_d": -2540.26513671875,
      "bbox_min": [
        -808.0,
        -2730.0,
        764.0
      ],
      "bbox_max": [
        -732.0,
        -2728.199951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.5,
      "bbox_min": [
        -808.0,
        -2745.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2690.0,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -732.5,
        -2745.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2745.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2742.5,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -732.5,
        -2742.5,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2740.0,
      "bbox_min": [
        -732.5,
        -2742.5,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2697.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2700.0,
      "bbox_min": [
        -732.5,
        -2700.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2697.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2700.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2697.5,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 807.0,
      "bbox_min": [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2709.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2709.2998046875,
      "bbox_min": [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2709.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2720.7001953125,
      "bbox_min": [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 807.0,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        775.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2814.547607421875,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": -2358.3251953125,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2356.79736328125,
      "bbox_min": [
        -808.0,
        -2709.2998046875,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": -2816.075927734375,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2709.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2370.3564453125,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2719.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": 2826.5791015625,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2719.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2720.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": 2368.828857421875,
      "bbox_min": [
        -808.0,
        -2720.5,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2719.10009765625,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -808.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -701.5,
        -2745.0,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -732.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -701.5,
        -2745.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -732.0,
        -2802.0,
        829.5
      ],
      "bbox_max": [
        -701.5,
        -2745.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        -732.0,
        -2800.0,
        829.5
      ],
      "bbox_max": [
        -701.5,
        -2745.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -730.0,
        -2800.0,
        829.5
      ],
      "bbox_max": [
        -701.5,
        -2800.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -732.0,
        -2800.0,
        829.5
      ],
      "bbox_max": [
        -730.0,
        -2800.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -732.0,
        -2770.0,
        829.5
      ],
      "bbox_max": [
        -730.0,
        -2769.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        -732.0,
        -2805.0,
        810.0
      ],
      "bbox_max": [
        -701.5,
        -2745.0,
        829.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -730.0,
        -2800.0,
        827.5
      ],
      "bbox_max": [
        -701.5,
        -2800.0,
        829.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -730.0,
        -2805.0,
        810.0
      ],
      "bbox_max": [
        -701.5,
        -2798.0,
        827.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -725.0,
        -2805.0,
        820.0
      ],
      "bbox_max": [
        -705.0,
        -2800.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        -730.0,
        -2798.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2798.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -732.0,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2750.0,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -732.0,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2800.0,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -732.0,
        -2769.5,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2750.0,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2760.0,
      "bbox_min": [
        -732.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -701.5,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7432851195335388,
        0.668974757194519
      ],
      "plane_d": 1540.3702392578125,
      "bbox_min": [
        -732.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -701.5,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -718.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -718.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -732.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -701.5,
        -2745.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -732.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -701.5,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 1516.258056640625,
      "bbox_min": [
        -732.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2802.0,
        807.4545288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941021203994751,
        -0.10844862461090088
      ],
      "plane_d": 2875.486572265625,
      "bbox_min": [
        -732.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2804.39990234375,
        806.76318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732937812805,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -720.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2804.39990234375,
        767.5001831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -720.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -720.0,
        -2804.39990234375,
        767.5001831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -701.5,
        -2745.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2790.0,
      "bbox_min": [
        -732.0,
        -2801.833251953125,
        807.5
      ],
      "bbox_max": [
        -701.5,
        -2750.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 1516.258056640625,
      "bbox_min": [
        -732.0,
        -2801.833251953125,
        807.5
      ],
      "bbox_max": [
        -701.5,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -732.0,
        -2800.0,
        808.0
      ],
      "bbox_max": [
        -729.2000122070312,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2750.0,
      "bbox_min": [
        -732.0,
        -2750.0,
        807.5
      ],
      "bbox_max": [
        -701.5,
        -2750.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 1516.258056640625,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -701.5,
        -2801.833251953125,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -808.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2745.0,
        830.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -808.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2745.0,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.7432851195335388,
        0.668974757194519
      ],
      "plane_d": 1540.3702392578125,
      "bbox_min": [
        -808.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -808.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        766.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -808.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -749.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -749.0,
        -2805.0,
        760.0
      ],
      "bbox_max": [
        -749.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.55350774852559e-05,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.257568359375,
      "bbox_min": [
        -808.0,
        -2804.39990234375,
        760.0
      ],
      "bbox_max": [
        -806.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -808.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -780.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -751.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2804.39990234375,
        767.5001831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941021800041199,
        -0.10844771564006805
      ],
      "plane_d": 2875.48583984375,
      "bbox_min": [
        -808.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2805.0,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2804.39990234375,
        767.5001831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -732.5,
      "bbox_min": [
        -808.0,
        -2800.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2745.0,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -732.5,
        -2800.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2745.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2747.5,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2745.0,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -732.5,
        -2800.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2747.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2800.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2792.5,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2792.5,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2747.5,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2750.0,
      "bbox_min": [
        -732.5,
        -2790.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2750.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2790.0,
      "bbox_min": [
        -732.5,
        -2790.0,
        807.5
      ],
      "bbox_max": [
        -732.0,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -776.0,
      "bbox_min": [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 807.0,
      "bbox_min": [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2769.2998046875,
      "bbox_min": [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2780.7001953125,
      "bbox_min": [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2780.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 807.0,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        775.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2871.83935546875,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": -2415.616943359375,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -808.0,
        -2769.2998046875,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": -2873.36767578125,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2769.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2427.648193359375,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2779.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": 2883.87109375,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2779.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2780.7001953125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": 2426.12060546875,
      "bbox_min": [
        -808.0,
        -2780.5,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2779.10009765625,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        -816.0,
        -2870.0,
        760.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941065907478333,
        -0.10840680450201035
      ],
      "plane_d": 2875.466064453125,
      "bbox_min": [
        -732.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        830.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -732.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2468.15771484375,
      "bbox_min": [
        -687.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": 2956.45068359375,
      "bbox_min": [
        -687.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -687.0,
        -2857.0,
        766.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -640.0,
        -2808.0,
        795.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -605.0,
        -2808.0,
        795.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -682.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -732.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -687.0,
        -2805.0,
        820.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.2631174325942993,
        -0.964763879776001
      ],
      "plane_d": 1516.258056640625,
      "bbox_min": [
        -732.0,
        -2815.0,
        790.0
      ],
      "bbox_max": [
        -698.0,
        -2805.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -725.0,
        -2815.0,
        804.727294921875
      ],
      "bbox_max": [
        -705.0,
        -2805.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -718.0,
        -2812.0,
        804.727294921875
      ],
      "bbox_max": [
        -718.0,
        -2805.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -718.0,
        -2812.0,
        790.0
      ],
      "bbox_max": [
        -718.0,
        -2805.0,
        806.6363525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2468.15771484375,
      "bbox_min": [
        -732.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -687.0,
        -2806.36376953125,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": 2956.45068359375,
      "bbox_min": [
        -732.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -687.0,
        -2806.36376953125,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -732.0,
        -2823.0,
        760.0
      ],
      "bbox_max": [
        -689.0,
        -2806.36376953125,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -713.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -689.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -732.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -720.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -732.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -720.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -720.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -720.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -732.0,
        -2809.63525390625,
        760.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        802.5062866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -687.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        802.505615234375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -602.8185424804688,
        -2805.818603515625,
        795.0
      ],
      "bbox_max": [
        -602.0,
        -2805.0,
        802.505615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -657.9999389648438,
      "bbox_min": [
        -658.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -732.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -720.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -718.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732937812805,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -720.0,
        -2808.0,
        767.5001831054688
      ],
      "bbox_max": [
        -718.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9941065907478333,
        -0.10840680450201035
      ],
      "plane_d": 2875.466064453125,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2805.0,
        830.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -816.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2805.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -749.0,
      "bbox_min": [
        -780.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2805.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -749.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2468.15771484375,
      "bbox_min": [
        -749.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": 2956.45068359375,
      "bbox_min": [
        -749.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -744.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -744.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -732.0,
        -2808.98095703125,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2468.15771484375,
      "bbox_min": [
        -780.0,
        -2860.0,
        760.0
      ],
      "bbox_max": [
        -749.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": 2956.45068359375,
      "bbox_min": [
        -780.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -775.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -775.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -751.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": 2956.45068359375,
      "bbox_min": [
        -816.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -806.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -782.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -806.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -782.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -782.0,
      "bbox_min": [
        -806.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -782.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -808.0,
        -2809.63525390625,
        760.0
      ],
      "bbox_max": [
        -732.0,
        -2805.0,
        802.5062866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -749.0,
        -2808.0,
        767.5001831054688
      ],
      "bbox_max": [
        -744.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -780.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -749.0,
        -2805.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -751.0,
      "bbox_min": [
        -751.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -808.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2805.0,
        802.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -808.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -782.0,
      "bbox_min": [
        -808.0,
        -2808.98095703125,
        766.0
      ],
      "bbox_max": [
        -780.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.55350774852559e-05,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.257568359375,
      "bbox_min": [
        -808.0,
        -2808.0,
        767.5
      ],
      "bbox_max": [
        -806.0,
        -2805.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        682.5
      ],
      "bbox_max": [
        -895.7581787109375,
        -2559.375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        682.5
      ],
      "bbox_max": [
        -909.609375,
        -2559.375,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        719.03125
      ],
      "bbox_max": [
        -895.7581787109375,
        -2566.875,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      "bbox_max": [
        -895.7581787109375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      "bbox_max": [
        -895.7581787109375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -895.7581787109375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -895.7581787109375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2859.5,
      "bbox_min": [
        -1070.0,
        -2930.0,
        658.0
      ],
      "bbox_max": [
        -824.0,
        -2640.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -966.0363159179688,
        -2930.0,
        769.9266357421875
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7739577293395996,
        0.0,
        0.6332372426986694
      ],
      "plane_d": 226.98138427734375,
      "bbox_min": [
        -941.6363525390625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -940.416259765625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7111465930938721,
        -0.03083941340446472,
        -0.7023670673370361
      ],
      "plane_d": -142.72918701171875,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -927.2113037109375,
        -2920.0,
        840.8545532226562
      ],
      "bbox_max": [
        -892.8818359375,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        832.9804077148438
      ],
      "bbox_max": [
        -906.88134765625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        843.2164916992188
      ],
      "bbox_max": [
        -914.0,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.0,
        -2920.0,
        843.2164916992188
      ],
      "bbox_max": [
        -906.88134765625,
        -2920.0,
        850.4241333007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        817.4066162109375
      ],
      "bbox_max": [
        -889.0310668945312,
        -2859.5,
        843.216552734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -932.0,
        -2920.0,
        832.5732421875
      ],
      "bbox_max": [
        -914.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        840.0
      ],
      "bbox_max": [
        -914.0,
        -2920.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -914.0,
        -2920.0,
        817.4066162109375
      ],
      "bbox_max": [
        -889.0310668945312,
        -2859.5,
        843.2164916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.0,
        -2920.0,
        840.0
      ],
      "bbox_max": [
        -904.548583984375,
        -2920.0,
        843.2164916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563965916633606,
        -0.07589651644229889,
        -0.6496953964233398
      ],
      "plane_d": -361.36151123046875,
      "bbox_min": [
        -871.8587036132812,
        -2863.125,
        790.0740966796875
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9069751501083374,
        0.32028982043266296,
        0.27351534366607666
      ],
      "plane_d": -89.19590759277344,
      "bbox_min": [
        -870.625,
        -2863.125,
        790.0740966796875
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069751501083374,
        0.32028982043266296,
        0.27351534366607666
      ],
      "plane_d": -89.19590759277344,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.887939453125,
        -2859.5,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188839197158813,
        0.32406729459762573,
        0.2250170260667801
      ],
      "plane_d": -51.825958251953125,
      "bbox_min": [
        -879.7694091796875,
        -2864.73291015625,
        761.111083984375
      ],
      "bbox_max": [
        -877.9344482421875,
        -2859.5,
        763.4368286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        821.3333129882812
      ],
      "bbox_max": [
        -894.0,
        -2920.0,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8115347027778625,
        0.0,
        -0.5843042731285095
      ],
      "plane_d": -245.60345458984375,
      "bbox_min": [
        -906.0,
        -2930.0,
        821.3333129882812
      ],
      "bbox_max": [
        -894.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7959103584289551,
        0.01854807510972023,
        -0.6051303148269653
      ],
      "plane_d": 1315.767333984375,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -985.7762451171875,
        -2930.0,
        790.23095703125
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -962.000732421875,
        -2925.0,
        820.943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -985.7762451171875,
        -2863.125,
        790.23095703125
      ],
      "bbox_max": [
        -984.375,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -985.7762451171875,
        -2863.125,
        790.45849609375
      ],
      "bbox_max": [
        -984.375,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8746123313903809,
        0.4167838394641876,
        0.2476782649755478
      ],
      "plane_d": 1858.1204833984375,
      "bbox_min": [
        -985.7095336914062,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -985.7095336914062,
        -2930.0,
        782.9964599609375
      ],
      "bbox_max": [
        -952.7792358398438,
        -2859.5,
        819.25341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -985.7095336914062,
        -2920.0,
        782.9964599609375
      ],
      "bbox_max": [
        -956.1746826171875,
        -2859.5,
        816.5782470703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -961.9993286132812,
        -2925.0,
        819.25341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8725059032440186,
        0.4155133366584778,
        0.25706446170806885
      ],
      "plane_d": 1844.9765625,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -984.375,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -956.1475219726562,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -956.8463745117188,
        -2920.0,
        788.0
      ],
      "bbox_max": [
        -956.1475219726562,
        -2920.0,
        790.3719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6921083927154541,
        -0.23178932070732117,
        -0.6835638880729675
      ],
      "plane_d": 547.8385009765625,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        859.0191040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -961.7054443359375,
        -2920.0,
        819.9484252929688
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        859.0191040039062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      "bbox_max": [
        -935.4811401367188,
        -2925.0,
        845.7122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902596354484558,
        -0.23094093799591064,
        -0.685716986656189
      ],
      "plane_d": 550.4041748046875,
      "bbox_min": [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      "bbox_max": [
        -937.5,
        -2925.0,
        845.6749267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        850.0252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -938.7246704101562,
        -2930.0,
        843.216552734375
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        850.0252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -937.5,
        -2930.0,
        844.0625
      ],
      "bbox_max": [
        -935.0020141601562,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -984.927490234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -984.927490234375,
        -2863.125,
        791.2595825195312
      ],
      "bbox_max": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -964.2677612304688,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        -954.4213256835938,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -954.4213256835938,
        -2930.0,
        789.6239013671875
      ],
      "bbox_max": [
        -950.0,
        -2923.65380859375,
        792.89794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -950.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        793.0687255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -942.1470947265625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -940.857421875,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        793.0968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -938.0,
        -2930.0,
        838.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -953.0294189453125,
        -2863.125,
        832.5732421875
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        833.59375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2712.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        658.0
      ],
      "bbox_max": [
        -824.0,
        -2640.0,
        860.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -1020.0,
        -2712.0,
        670.0
      ],
      "bbox_max": [
        -836.0967407226562,
        -2670.0,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1020.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -970.0,
        -2674.543212890625,
        752.3527221679688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -1007.907958984375,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -970.0,
        -2674.543212890625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1007.45263671875,
        -2710.0,
        694.6666870117188
      ],
      "bbox_max": [
        -996.9083251953125,
        -2700.84130859375,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -996.2919311523438,
        -2697.0,
        678.9081420898438
      ],
      "bbox_max": [
        -981.5535278320312,
        -2674.543212890625,
        694.1002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -1012.0521240234375,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -971.9118041992188,
        -2695.500244140625,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1012.0521240234375,
        -2710.0,
        720.0
      ],
      "bbox_max": [
        -1006.3765869140625,
        -2695.500244140625,
        735.1856079101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -1009.0059204101562,
        -2697.0,
        720.0
      ],
      "bbox_max": [
        -1007.4884643554688,
        -2695.500244140625,
        722.940673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        -0.1950865238904953,
        0.0
      ],
      "plane_d": -1349.106689453125,
      "bbox_min": [
        -853.0,
        -2712.0,
        718.0
      ],
      "bbox_max": [
        -836.0967407226562,
        -2697.099365234375,
        752.3526000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -853.0,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -836.8701171875,
        -2697.099365234375,
        744.7286987304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 1087.79150390625,
      "bbox_min": [
        -853.0,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -838.5003051757812,
        -2697.099365234375,
        744.7286987304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2707.51171875,
      "bbox_min": [
        -840.4999389648438,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -838.5003051757812,
        -2706.911376953125,
        743.5524291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -840.4999389648438,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -838.5003051757812,
        -2707.51171875,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -840.0,
        -2707.51171875,
        718.0
      ],
      "bbox_max": [
        -838.9999389648438,
        -2706.911376953125,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -2811.6865234375,
      "bbox_min": [
        -853.0,
        -2698.3701171875,
        718.0
      ],
      "bbox_max": [
        -846.61181640625,
        -2697.099365234375,
        725.6273803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -846.61181640625,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -836.8701171875,
        -2698.3701171875,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -885.9562377929688,
        -2695.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        744.7285766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        733.2783813476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -2478.673828125,
      "bbox_min": [
        -860.38818359375,
        -2698.3701171875,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        725.6273803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -2811.6865234375,
      "bbox_min": [
        -853.5,
        -2697.099365234375,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        723.1361083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -1015.0,
        -2712.0,
        658.0
      ],
      "bbox_max": [
        -824.0,
        -2640.0,
        860.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2649.999755859375,
      "bbox_min": [
        -991.0,
        -2650.0,
        658.0
      ],
      "bbox_max": [
        -952.901611328125,
        -2650.0,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -2713.984375,
      "bbox_min": [
        -853.0,
        -2712.0,
        725.6273803710938
      ],
      "bbox_max": [
        -824.0,
        -2697.099365234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        -0.9994657635688782,
        -0.0
      ],
      "plane_d": -2734.018310546875,
      "bbox_min": [
        -831.7825317382812,
        -2712.0,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2708.278076171875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -831.7825317382812,
        -2712.0,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2708.278076171875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2710.89990234375,
      "bbox_min": [
        -825.0,
        -2712.0,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 774.0,
      "bbox_min": [
        -825.0,
        -2712.0,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -825.0,
        -2712.0,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -831.7825317382812,
        -2712.0,
        765.0
      ],
      "bbox_max": [
        -825.0,
        -2708.278076171875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        -0.9994657635688782,
        -0.0
      ],
      "plane_d": -2734.018310546875,
      "bbox_min": [
        -836.8701171875,
        -2712.0,
        765.0
      ],
      "bbox_max": [
        -826.2119750976562,
        -2708.11181640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -836.8701171875,
        -2712.0,
        765.0
      ],
      "bbox_max": [
        -826.2119750976562,
        -2708.11181640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -843.7395629882812,
        -2712.0,
        743.5524291992188
      ],
      "bbox_max": [
        -834.2724609375,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -840.5,
        -2708.11181640625,
        743.5524291992188
      ],
      "bbox_max": [
        -836.8701171875,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -779.9999389648438,
      "bbox_min": [
        -840.5,
        -2708.11181640625,
        780.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -840.4998779296875,
        -2708.11181640625,
        782.5
      ],
      "bbox_max": [
        -838.500244140625,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -839.0001220703125,
        -2708.11181640625,
        782.5
      ],
      "bbox_max": [
        -836.8701171875,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        -0.1950865238904953,
        0.0
      ],
      "plane_d": -1349.106689453125,
      "bbox_min": [
        -843.7395629882812,
        -2712.0,
        744.7284545898438
      ],
      "bbox_max": [
        -834.2724609375,
        -2708.11181640625,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -836.8701171875,
        -2712.0,
        775.0
      ],
      "bbox_max": [
        -834.2724609375,
        -2708.11181640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2712.0,
        782.5
      ],
      "bbox_max": [
        -839.9998779296875,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2707.51171875,
        782.5
      ],
      "bbox_max": [
        -837.2710571289062,
        -2697.099365234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -932.0,
        -2650.0,
        748.0
      ],
      "bbox_max": [
        -888.2786865234375,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2650.0,
        757.0
      ],
      "bbox_max": [
        -888.2786865234375,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -921.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 909.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -909.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -927.0,
        -2650.0,
        757.0
      ],
      "bbox_max": [
        -888.2786865234375,
        -2640.0,
        775.49560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -921.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 909.0,
      "bbox_min": [
        -909.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2660.0,
        750.0
      ],
      "bbox_max": [
        -880.7991943359375,
        -2650.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -932.0,
        -2660.0,
        750.0
      ],
      "bbox_max": [
        -880.7991943359375,
        -2650.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2650.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2660.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2650.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -932.0,
        -2712.0,
        722.9411010742188
      ],
      "bbox_max": [
        -853.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -2811.6865234375,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        730.4908447265625
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        741.0130615234375
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        750.384765625
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        782.5
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033253312110901,
        -0.5795758366584778
      ],
      "plane_d": -798.1557006835938,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -873.5,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.468505859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        -932.0,
        -2679.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2660.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292984008789,
        -0.1630813479423523,
        -0.6428514122962952
      ],
      "plane_d": -602.9217529296875,
      "bbox_min": [
        -898.28125,
        -2712.0,
        787.3197021484375
      ],
      "bbox_max": [
        -890.8987426757812,
        -2697.0,
        795.468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        722.9411010742188
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        760.2907104492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        722.9411010742188
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        760.2907104492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -2478.673828125,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        722.9411010742188
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        760.2907104492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        722.9411010742188
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        760.2907104492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -2811.6865234375,
      "bbox_min": [
        -853.5,
        -2697.099365234375,
        722.9411010742188
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        731.1354370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -991.0,
        -2650.0,
        709.2665405273438
      ],
      "bbox_max": [
        -967.8667602539062,
        -2650.0,
        757.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2649.999755859375,
      "bbox_min": [
        -991.0,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -965.4456176757812,
        -2650.0,
        708.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -988.625,
        -2645.0,
        705.8635864257812
      ],
      "bbox_max": [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 972.0,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2649.999755859375,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        678.2882080078125
      ],
      "bbox_max": [
        -972.0,
        -2645.0,
        748.4714965820312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        705.541015625
      ],
      "bbox_max": [
        -988.625,
        -2645.0,
        709.5540771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        701.9979858398438
      ],
      "bbox_max": [
        -989.3621826171875,
        -2650.0,
        714.0372314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -972.0,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.763513445854187,
        0.0,
        -0.6457920074462891
      ],
      "plane_d": 1210.605712890625,
      "bbox_min": [
        -972.0,
        -2650.0,
        725.420166015625
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -953.0830078125,
        -2650.0,
        763.253662109375
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -934.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        763.253662109375
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 934.0,
      "bbox_min": [
        -934.0,
        -2648.0,
        770.3472900390625
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -952.901611328125,
        -2650.0,
        748.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        772.7119750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 934.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        772.7119750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2648.0,
        770.3472900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.6353759765625,
        -2642.125,
        771.9608154296875
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        772.7119750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -953.8565673828125,
        -2660.0,
        775.49560546875
      ],
      "bbox_max": [
        -932.0,
        -2650.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230917811393738,
        -0.23741567134857178,
        -0.6486693620681763
      ],
      "plane_d": 565.302490234375,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        722.940673828125
      ],
      "bbox_max": [
        -932.0,
        -2697.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        722.940673828125
      ],
      "bbox_max": [
        -970.0,
        -2697.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1011.9400024414062,
        -2701.77294921875,
        726.1282958984375
      ],
      "bbox_max": [
        -1010.0033569335938,
        -2697.0,
        732.2994384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      "bbox_max": [
        -956.71875,
        -2697.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -873.5,
        -2859.5,
        683.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -873.5,
        -2762.5,
        695.5555419921875
      ],
      "bbox_max": [
        -866.9043579101562,
        -2712.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 871.5,
      "bbox_min": [
        -873.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7563965916633606,
        -0.07589651644229889,
        -0.6496953964233398
      ],
      "plane_d": -361.36151123046875,
      "bbox_min": [
        -873.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -871.5,
        -2735.5,
        795.2313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9188839197158813,
        0.32406729459762573,
        0.2250170260667801
      ],
      "plane_d": -51.825958251953125,
      "bbox_min": [
        -873.5,
        -2846.85400390625,
        748.3642578125
      ],
      "bbox_max": [
        -871.5,
        -2830.819580078125,
        763.2899169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -873.5,
        -2788.75,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2735.5,
        786.5338134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484284043312073,
        -0.16308389604091644,
        -0.6428518295288086
      ],
      "plane_d": -602.9276733398438,
      "bbox_min": [
        -873.5,
        -2788.75,
        782.2899780273438
      ],
      "bbox_max": [
        -871.5,
        -2775.0,
        786.5338134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2735.5,
        735.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2748.5,
      "bbox_min": [
        -872.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2741.5,
      "bbox_min": [
        -872.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -872.5,
        -2748.5,
        730.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -872.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -872.5,
        -2754.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        0.9807860851287842,
        0.0
      ],
      "plane_d": 2572.8291015625,
      "bbox_min": [
        -853.0,
        -2792.900634765625,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555502772331238,
        0.8314830660820007,
        0.0
      ],
      "plane_d": 1850.857666015625,
      "bbox_min": [
        -853.0,
        -2792.900634765625,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2753.048828125,
      "bbox_min": [
        -831.782470703125,
        -2781.721923828125,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2776.522216796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -831.782470703125,
        -2781.721923828125,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2776.522216796875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2779.10009765625,
      "bbox_min": [
        -825.0,
        -2779.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2776.522216796875,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -825.0,
        -2779.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2776.522216796875,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 774.0,
      "bbox_min": [
        -825.0,
        -2779.10009765625,
        774.0
      ],
      "bbox_max": [
        -824.0,
        -2776.522216796875,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -831.782470703125,
        -2781.721923828125,
        765.0
      ],
      "bbox_max": [
        -825.0,
        -2777.190185546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -831.782470703125,
        -2781.721923828125,
        765.0
      ],
      "bbox_max": [
        -825.0,
        -2777.190185546875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2721.88818359375,
      "bbox_min": [
        -853.0,
        -2792.900634765625,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555502772331238,
        0.8314830660820007,
        0.0
      ],
      "plane_d": 1800.968505859375,
      "bbox_min": [
        -853.0,
        -2792.900634765625,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2721.88818359375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -2233.668701171875,
      "bbox_min": [
        -853.0,
        -2792.900634765625,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2731.6298828125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2766169011592865,
        -0.9609803557395935,
        0.0
      ],
      "plane_d": -2859.875244140625,
      "bbox_min": [
        -853.0,
        -2779.87158203125,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2731.6298828125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314489126205444,
        -0.555601179599762,
        0.0
      ],
      "plane_d": -2221.611328125,
      "bbox_min": [
        -847.314208984375,
        -2738.810302734375,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2731.6298828125,
        744.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2737.0,
      "bbox_min": [
        -830.2892456054688,
        -2738.810302734375,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        -830.2892456054688,
        -2738.810302734375,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -830.2892456054688,
        -2738.810302734375,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -847.314208984375,
        -2732.46142578125,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2731.6298828125,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.0,
        -2779.87158203125,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2732.09912109375,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        -0.9994657635688782,
        -0.0
      ],
      "plane_d": -2793.986328125,
      "bbox_min": [
        -836.8701171875,
        -2779.87158203125,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2768.11181640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -764.9999389648438,
      "bbox_min": [
        -836.8701171875,
        -2779.87158203125,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2768.11181640625,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2770.89990234375,
      "bbox_min": [
        -825.0,
        -2777.190185546875,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2770.89990234375,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 774.0,
      "bbox_min": [
        -825.0,
        -2777.190185546875,
        774.0
      ],
      "bbox_max": [
        -824.0,
        -2770.89990234375,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -835.5,
      "bbox_min": [
        -853.0,
        -2772.0,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2732.09912109375,
        744.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2737.0,
      "bbox_min": [
        -835.5,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -835.5,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        740.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        -835.5,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2753.0,
      "bbox_min": [
        -835.5,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        740.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 834.400146484375,
      "bbox_min": [
        -834.400146484375,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2753.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -834.400146484375,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2753.0,
        735.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.0,
      "bbox_min": [
        -834.400146484375,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2753.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 825.39990234375,
      "bbox_min": [
        -825.39990234375,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2770.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2772.0,
      "bbox_min": [
        -825.39990234375,
        -2772.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2772.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.0,
      "bbox_min": [
        -834.400146484375,
        -2770.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2753.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -826.0,
      "bbox_min": [
        -826.0,
        -2770.0,
        721.0
      ],
      "bbox_max": [
        -825.39990234375,
        -2766.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 825.39990234375,
      "bbox_min": [
        -825.39990234375,
        -2770.0,
        721.0
      ],
      "bbox_max": [
        -825.39990234375,
        -2766.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2754.0,
      "bbox_min": [
        -834.400146484375,
        -2754.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2753.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -830.0,
        -2754.0,
        730.0
      ],
      "bbox_max": [
        -824.0,
        -2753.0,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 834.5,
      "bbox_min": [
        -835.5,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -830.0,
        -2737.0,
        740.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2748.5,
      "bbox_min": [
        -835.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -834.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2741.5,
      "bbox_min": [
        -835.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -834.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -835.5,
        -2748.5,
        730.0
      ],
      "bbox_max": [
        -834.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2752.0,
      "bbox_min": [
        -832.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -830.0,
        -2752.0,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -832.0,
      "bbox_min": [
        -832.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -830.0,
        -2752.0,
        731.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -832.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -830.0,
        -2752.0,
        731.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1429.77001953125,
      "bbox_min": [
        -832.0,
        -2753.0,
        730.0
      ],
      "bbox_max": [
        -830.0,
        -2752.0,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2766169011592865,
        0.9609803557395935,
        0.0
      ],
      "plane_d": 2415.906982421875,
      "bbox_min": [
        -853.0,
        -2757.0263671875,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2732.09912109375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -853.0,
        -2753.0,
        718.5
      ],
      "bbox_max": [
        -835.5,
        -2732.09912109375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": -2302.420166015625,
      "bbox_min": [
        -850.3077392578125,
        -2753.0,
        731.0
      ],
      "bbox_max": [
        -835.5,
        -2748.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2504.648193359375,
      "bbox_min": [
        -848.6627197265625,
        -2733.000244140625,
        731.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2732.46142578125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -719.0,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -837.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 718.5,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -839.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -841.5,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -839.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -839.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -841.5,
        -2741.5,
        718.5
      ],
      "bbox_max": [
        -839.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 719.5,
      "bbox_min": [
        -839.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -837.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -839.5,
      "bbox_min": [
        -839.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -837.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -839.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -837.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -839.5,
        -2741.5,
        719.5
      ],
      "bbox_max": [
        -837.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -848.6627197265625,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -835.5,
        -2732.09912109375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 720.5,
      "bbox_min": [
        -837.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -835.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -837.5,
      "bbox_min": [
        -837.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -835.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -837.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -835.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -837.5,
        -2741.5,
        720.5
      ],
      "bbox_max": [
        -835.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2504.648193359375,
      "bbox_min": [
        -848.6627197265625,
        -2733.000244140625,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2732.09912109375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -848.6627197265625,
        -2733.000244140625,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2732.09912109375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 849.6354370117188,
      "bbox_min": [
        -853.0,
        -2792.900634765625,
        718.0
      ],
      "bbox_max": [
        -829.0130004882812,
        -2743.970458984375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2753.048828125,
      "bbox_min": [
        -836.8701171875,
        -2781.88818359375,
        765.0
      ],
      "bbox_max": [
        -829.0130004882812,
        -2775.000244140625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -836.8701171875,
        -2781.88818359375,
        775.0
      ],
      "bbox_max": [
        -829.0130004882812,
        -2775.000244140625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314489126205444,
        0.555601179599762,
        0.0
      ],
      "plane_d": 828.6392211914062,
      "bbox_min": [
        -847.314208984375,
        -2758.3701171875,
        718.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2757.53857421875,
        744.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -847.314208984375,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2757.53857421875,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -848.6626586914062,
        -2757.90087890625,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2756.999755859375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": -2302.420166015625,
      "bbox_min": [
        -853.0,
        -2757.53857421875,
        731.0
      ],
      "bbox_max": [
        -844.2769165039062,
        -2743.970458984375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.0,
        -2753.0,
        731.0
      ],
      "bbox_max": [
        -846.9672241210938,
        -2743.970458984375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -853.0,
        -2748.0,
        731.0
      ],
      "bbox_max": [
        -850.3077392578125,
        -2743.970458984375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.0,
        -2757.53857421875,
        744.0
      ],
      "bbox_max": [
        -844.2769165039062,
        -2752.999755859375,
        744.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2767.5,
      "bbox_min": [
        -853.0,
        -2768.10009765625,
        718.0
      ],
      "bbox_max": [
        -836.8779296875,
        -2754.101806640625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 1126.19140625,
      "bbox_min": [
        -853.0,
        -2768.10009765625,
        718.0
      ],
      "bbox_max": [
        -836.8779296875,
        -2767.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2416.12109375,
      "bbox_min": [
        -840.5,
        -2768.10009765625,
        718.0
      ],
      "bbox_max": [
        -836.8779296875,
        -2767.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -779.9999389648438,
      "bbox_min": [
        -840.5,
        -2768.10009765625,
        780.0
      ],
      "bbox_max": [
        -838.5,
        -2767.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -840.4999389648438,
        -2768.10009765625,
        782.5
      ],
      "bbox_max": [
        -838.5001831054688,
        -2767.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -839.0000610351562,
        -2768.10009765625,
        782.5
      ],
      "bbox_max": [
        -836.8779296875,
        -2767.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2768.10009765625,
        782.5
      ],
      "bbox_max": [
        -839.9998779296875,
        -2767.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -2870.53369140625,
      "bbox_min": [
        -853.0,
        -2767.5,
        730.0
      ],
      "bbox_max": [
        -837.2788696289062,
        -2754.101806640625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        0.9793003797531128,
        -0.0
      ],
      "plane_d": 2871.710693359375,
      "bbox_min": [
        -853.0,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -846.61181640625,
        -2754.101806640625,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2767.5,
        782.5
      ],
      "bbox_max": [
        -837.2788696289062,
        -2757.099365234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        -0.6401229500770569,
        0.0
      ],
      "plane_d": -1136.5614013671875,
      "bbox_min": [
        -853.0,
        -2782.5,
        718.0
      ],
      "bbox_max": [
        -836.8779296875,
        -2781.89990234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7682725787162781,
        -0.6401229500770569,
        -0.0
      ],
      "plane_d": -2426.490966796875,
      "bbox_min": [
        -853.0,
        -2782.5,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2781.89990234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -779.9999389648438,
      "bbox_min": [
        -840.5,
        -2782.5,
        780.0
      ],
      "bbox_max": [
        -838.5,
        -2781.89990234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -840.4998168945312,
        -2782.5,
        782.5
      ],
      "bbox_max": [
        -838.5,
        -2781.89990234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2782.5,
        782.5
      ],
      "bbox_max": [
        -840.0000610351562,
        -2781.89990234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -839.0,
        -2782.5,
        782.5
      ],
      "bbox_max": [
        -836.8779296875,
        -2781.89990234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2792.900634765625,
        782.5
      ],
      "bbox_max": [
        -837.2788696289062,
        -2782.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        -0.1950865238904953,
        0.0
      ],
      "plane_d": -1360.811767578125,
      "bbox_min": [
        -853.0,
        -2781.89990234375,
        718.0
      ],
      "bbox_max": [
        -832.2679443359375,
        -2768.10009765625,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -764.9999389648438,
      "bbox_min": [
        -836.8701171875,
        -2778.7275390625,
        765.0
      ],
      "bbox_max": [
        -832.2679443359375,
        -2768.11181640625,
        765.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -836.8701171875,
        -2781.88818359375,
        765.0
      ],
      "bbox_max": [
        -834.7584228515625,
        -2775.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -836.8701171875,
        -2781.88818359375,
        765.0
      ],
      "bbox_max": [
        -834.7584228515625,
        -2775.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2781.89990234375,
        782.5
      ],
      "bbox_max": [
        -835.5,
        -2768.10009765625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        -0.6401229500770569,
        0.0
      ],
      "plane_d": -1098.1466064453125,
      "bbox_min": [
        -853.0,
        -2735.89794921875,
        718.0
      ],
      "bbox_max": [
        -836.8701171875,
        -2721.88818359375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2722.48828125,
      "bbox_min": [
        -853.0,
        -2735.89794921875,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2721.88818359375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7682725787162781,
        -0.6401229500770569,
        -0.0
      ],
      "plane_d": -2388.076171875,
      "bbox_min": [
        -853.0,
        -2722.48828125,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2721.88818359375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -840.5000610351562,
        -2722.48828125,
        780.0
      ],
      "bbox_max": [
        -838.5,
        -2721.88818359375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -779.9999389648438,
      "bbox_min": [
        -840.5,
        -2722.48828125,
        780.0
      ],
      "bbox_max": [
        -838.5,
        -2721.88818359375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2722.48828125,
        782.5
      ],
      "bbox_max": [
        -840.0000610351562,
        -2721.88818359375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        0.9807860851287842,
        0.0
      ],
      "plane_d": 2513.98193359375,
      "bbox_min": [
        -853.0,
        -2735.89794921875,
        730.0
      ],
      "bbox_max": [
        -838.9996948242188,
        -2722.48828125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2504.648193359375,
      "bbox_min": [
        -853.0,
        -2735.89794921875,
        730.0
      ],
      "bbox_max": [
        -846.61181640625,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831483006477356,
        0.555550217628479,
        0.0
      ],
      "plane_d": 816.3023071289062,
      "bbox_min": [
        -846.61181640625,
        -2731.6298828125,
        718.0
      ],
      "bbox_max": [
        -836.8701171875,
        -2721.88818359375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -846.61181640625,
        -2731.6298828125,
        782.5
      ],
      "bbox_max": [
        -836.8701171875,
        -2721.88818359375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        0.1950865238904953,
        0.0
      ],
      "plane_d": -289.78680419921875,
      "bbox_min": [
        -853.0,
        -2721.88818359375,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2693.080810546875,
      "bbox_min": [
        -836.8701171875,
        -2721.88818359375,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -836.8701171875,
        -2721.88818359375,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -836.8701171875,
        -2721.88818359375,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -825.0,
        -2721.5,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2719.10009765625,
      "bbox_min": [
        -825.0,
        -2719.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 774.0,
      "bbox_min": [
        -825.0,
        -2719.10009765625,
        774.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        -0.1950865238904953,
        0.0
      ],
      "plane_d": -1349.106689453125,
      "bbox_min": [
        -853.0,
        -2721.88818359375,
        718.0
      ],
      "bbox_max": [
        -834.9032592773438,
        -2712.0,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -836.0967407226562,
        -2715.0,
        765.0
      ],
      "bbox_max": [
        -834.9032592773438,
        -2712.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -836.0967407226562,
        -2715.0,
        765.0
      ],
      "bbox_max": [
        -834.9032592773438,
        -2712.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -853.0,
        -2721.88818359375,
        782.5
      ],
      "bbox_max": [
        -835.5,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563976049423218,
        -0.07589630782604218,
        -0.6496942043304443
      ],
      "plane_d": -361.36260986328125,
      "bbox_min": [
        -871.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        792.4702758789062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        0.9807860851287842,
        0.0
      ],
      "plane_d": 2513.98193359375,
      "bbox_min": [
        -871.5,
        -2793.0,
        756.142822265625
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        0.9807860851287842,
        0.0
      ],
      "plane_d": 2572.8291015625,
      "bbox_min": [
        -871.443359375,
        -2793.0,
        763.1519165039062
      ],
      "bbox_max": [
        -853.0,
        -2758.3701171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1815.5491943359375,
      "bbox_min": [
        -871.443359375,
        -2791.6298828125,
        767.7196655273438
      ],
      "bbox_max": [
        -860.38818359375,
        -2758.3701171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        0.8314830660820007,
        -0.0
      ],
      "plane_d": 2799.181884765625,
      "bbox_min": [
        -871.443359375,
        -2791.6298828125,
        771.6050415039062
      ],
      "bbox_max": [
        -860.38818359375,
        -2762.27197265625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -814.3270263671875,
      "bbox_min": [
        -871.443359375,
        -2787.72802734375,
        774.9745483398438
      ],
      "bbox_max": [
        -866.22802734375,
        -2762.27197265625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.443359375,
        -2787.72802734375,
        777.9482421875
      ],
      "bbox_max": [
        -866.22802734375,
        -2768.11181640625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 313.389892578125,
      "bbox_min": [
        -871.443359375,
        -2781.88818359375,
        780.1994018554688
      ],
      "bbox_max": [
        -870.1298828125,
        -2768.11181640625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.328125,
        -2781.88818359375,
        781.8087768554688
      ],
      "bbox_max": [
        -870.1298828125,
        -2775.8642578125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950865387916565,
        0.9807860851287842,
        -0.0
      ],
      "plane_d": 2846.99462890625,
      "bbox_min": [
        -871.5,
        -2733.0,
        756.7365112304688
      ],
      "bbox_max": [
        -853.5,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        0.8314830660820007,
        -0.0
      ],
      "plane_d": 2749.292724609375,
      "bbox_min": [
        -871.5,
        -2731.6298828125,
        764.595947265625
      ],
      "bbox_max": [
        -860.38818359375,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        770.9391479492188
      ],
      "bbox_max": [
        -866.22802734375,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        774.544921875
      ],
      "bbox_max": [
        -870.1298828125,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        790.45849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069751501083374,
        0.32028982043266296,
        0.27351534366607666
      ],
      "plane_d": -89.19590759277344,
      "bbox_min": [
        -871.5,
        -2859.5,
        737.2188110351562
      ],
      "bbox_max": [
        -861.600341796875,
        -2781.199951171875,
        790.45849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188839197158813,
        0.32406729459762573,
        0.2250170260667801
      ],
      "plane_d": -51.825958251953125,
      "bbox_min": [
        -871.5,
        -2841.150634765625,
        737.2188110351562
      ],
      "bbox_max": [
        -863.1043701171875,
        -2805.7421875,
        763.2430419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484284043312073,
        -0.16308389604091644,
        -0.6428518295288086
      ],
      "plane_d": -602.9276733398438,
      "bbox_min": [
        -871.5,
        -2788.75,
        781.369873046875
      ],
      "bbox_max": [
        -869.0645141601562,
        -2781.199951171875,
        784.205322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2824.770263671875,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188839197158813,
        0.32406729459762573,
        0.2250170260667801
      ],
      "plane_d": -51.825958251953125,
      "bbox_min": [
        -865.3851318359375,
        -2824.770263671875,
        731.7640380859375
      ],
      "bbox_max": [
        -856.3597412109375,
        -2793.468994140625,
        776.8876342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069751501083374,
        0.32028982043266296,
        0.27351534366607666
      ],
      "plane_d": -89.19590759277344,
      "bbox_min": [
        -863.1043701171875,
        -2824.770263671875,
        762.9126586914062
      ],
      "bbox_max": [
        -856.3597412109375,
        -2800.94091796875,
        776.8876342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 313.389892578125,
      "bbox_min": [
        -871.5,
        -2802.49755859375,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2766.559326171875,
        718.0
      ],
      "bbox_max": [
        -862.581787109375,
        -2712.0,
        775.590087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766169011592865,
        -0.9609803557395935,
        0.0
      ],
      "plane_d": -2387.690185546875,
      "bbox_min": [
        -871.5,
        -2766.559326171875,
        718.0
      ],
      "bbox_max": [
        -863.1659545898438,
        -2733.10107421875,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766169011592865,
        0.9609803557395935,
        0.0
      ],
      "plane_d": 2888.092041015625,
      "bbox_min": [
        -871.5,
        -2766.559326171875,
        718.0
      ],
      "bbox_max": [
        -863.1659545898438,
        -2733.10107421875,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -871.5,
        -2766.559326171875,
        718.0
      ],
      "bbox_max": [
        -871.1580810546875,
        -2762.5,
        719.8040771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -871.5,
        -2755.610107421875,
        718.5
      ],
      "bbox_max": [
        -863.1659545898438,
        -2733.10107421875,
        744.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -871.5,
        -2753.0,
        718.5
      ],
      "bbox_max": [
        -863.94140625,
        -2737.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": 2821.6474609375,
      "bbox_min": [
        -871.5,
        -2753.0,
        731.0
      ],
      "bbox_max": [
        -863.94140625,
        -2737.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": -2302.420166015625,
      "bbox_min": [
        -871.5,
        -2753.0,
        731.0
      ],
      "bbox_max": [
        -866.12939453125,
        -2748.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -871.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 719.5,
      "bbox_min": [
        -869.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        -869.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -867.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -869.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -867.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -869.5,
        -2741.5,
        719.5
      ],
      "bbox_max": [
        -867.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -719.0,
      "bbox_min": [
        -867.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 718.5,
      "bbox_min": [
        -867.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 865.5,
      "bbox_min": [
        -867.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -867.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -867.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -866.2289428710938,
        -2748.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -869.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 720.5,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -869.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -869.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -869.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -871.5,
        -2741.5,
        720.5
      ],
      "bbox_max": [
        -869.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2730.164306640625,
        718.0
      ],
      "bbox_max": [
        -862.581787109375,
        -2715.0,
        775.590087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        0.8314830660820007,
        -0.0
      ],
      "plane_d": 2749.292724609375,
      "bbox_min": [
        -866.22802734375,
        -2730.164306640625,
        718.0
      ],
      "bbox_max": [
        -862.581787109375,
        -2727.72802734375,
        770.9391479492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        0.8314830660820007,
        -0.0
      ],
      "plane_d": 2749.292724609375,
      "bbox_min": [
        -867.6431884765625,
        -2757.0263671875,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2730.164306640625,
        766.9785766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766169011592865,
        -0.9609803557395935,
        0.0
      ],
      "plane_d": -2387.690185546875,
      "bbox_min": [
        -867.6431884765625,
        -2757.0263671875,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314489126205444,
        -0.555601179599762,
        0.0
      ],
      "plane_d": -802.3280029296875,
      "bbox_min": [
        -860.94384765625,
        -2732.46142578125,
        718.0
      ],
      "bbox_max": [
        -859.685791015625,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -860.94384765625,
        -2732.46142578125,
        730.0
      ],
      "bbox_max": [
        -859.685791015625,
        -2731.6298828125,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -867.6431884765625,
        -2757.0263671875,
        718.5
      ],
      "bbox_max": [
        -853.0,
        -2732.09912109375,
        744.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": -2302.420166015625,
      "bbox_min": [
        -867.1239624023438,
        -2753.0,
        718.5
      ],
      "bbox_max": [
        -853.0,
        -2732.09912109375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": 2821.6474609375,
      "bbox_min": [
        -866.12939453125,
        -2748.0,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2732.09912109375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -866.12939453125,
        -2748.0,
        731.0
      ],
      "bbox_max": [
        -853.0,
        -2742.0,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2850.166015625,
      "bbox_min": [
        -860.94384765625,
        -2733.000244140625,
        730.0
      ],
      "bbox_max": [
        -858.3370361328125,
        -2732.09912109375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -860.94384765625,
        -2733.000244140625,
        730.0
      ],
      "bbox_max": [
        -858.3370361328125,
        -2732.09912109375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -719.0,
      "bbox_min": [
        -866.2289428710938,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2744.83544921875,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 718.5,
      "bbox_min": [
        -866.2289428710938,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2744.83544921875,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 865.5,
      "bbox_min": [
        -866.2289428710938,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2744.83544921875,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -866.2289428710938,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -865.5,
        -2748.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950865387916565,
        0.9807860851287842,
        -0.0
      ],
      "plane_d": 2846.99462890625,
      "bbox_min": [
        -860.38818359375,
        -2736.566162109375,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2731.6298828125,
        764.595947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2850.166015625,
      "bbox_min": [
        -860.38818359375,
        -2736.566162109375,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2504.648193359375,
      "bbox_min": [
        -860.38818359375,
        -2734.103271484375,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -860.38818359375,
        -2734.0,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2731.6298828125,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.5,
        -2734.103271484375,
        744.0
      ],
      "bbox_max": [
        -853.0,
        -2733.896728515625,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -858.3370361328125,
        -2736.566162109375,
        744.0
      ],
      "bbox_max": [
        -853.0,
        -2733.000244140625,
        744.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        0.9807860851287842,
        0.0
      ],
      "plane_d": 2513.98193359375,
      "bbox_min": [
        -853.5,
        -2733.099365234375,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2732.900634765625,
        756.7365112304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -853.5,
        -2733.099365234375,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2732.900634765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        0.8314830660820007,
        -0.0
      ],
      "plane_d": 2799.181884765625,
      "bbox_min": [
        -871.5,
        -2802.49755859375,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2742.473876953125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188839197158813,
        0.32406729459762573,
        0.2250170260667801
      ],
      "plane_d": -51.825958251953125,
      "bbox_min": [
        -862.3924560546875,
        -2802.49755859375,
        731.2932739257812
      ],
      "bbox_max": [
        -854.6973266601562,
        -2792.40966796875,
        768.1845092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069751501083374,
        0.32028982043266296,
        0.27351534366607666
      ],
      "plane_d": -89.19590759277344,
      "bbox_min": [
        -857.3999633789062,
        -2802.49755859375,
        762.8639526367188
      ],
      "bbox_max": [
        -854.6973266601562,
        -2795.0146484375,
        768.1845092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1815.5491943359375,
      "bbox_min": [
        -871.5,
        -2795.43212890625,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2742.473876953125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766169011592865,
        0.9609803557395935,
        0.0
      ],
      "plane_d": 2888.092041015625,
      "bbox_min": [
        -862.7232055664062,
        -2758.3701171875,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2742.473876953125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314489126205444,
        0.555601179599762,
        -0.0
      ],
      "plane_d": 2247.92236328125,
      "bbox_min": [
        -860.94384765625,
        -2758.3701171875,
        718.0
      ],
      "bbox_max": [
        -859.685791015625,
        -2757.53857421875,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -860.94384765625,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -859.685791015625,
        -2757.53857421875,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -860.94384765625,
        -2757.90087890625,
        730.0
      ],
      "bbox_max": [
        -858.3373413085938,
        -2756.999755859375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -862.7232055664062,
        -2757.53857421875,
        731.0
      ],
      "bbox_max": [
        -853.0,
        -2742.473876953125,
        744.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": -2302.420166015625,
      "bbox_min": [
        -860.0330200195312,
        -2753.0,
        731.0
      ],
      "bbox_max": [
        -853.0,
        -2742.473876953125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -856.6923828125,
        -2748.0,
        731.0
      ],
      "bbox_max": [
        -853.0,
        -2742.473876953125,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069751501083374,
        0.32028982043266296,
        0.27351534366607666
      ],
      "plane_d": -89.19590759277344,
      "bbox_min": [
        -855.3218383789062,
        -2795.43212890625,
        762.8598022460938
      ],
      "bbox_max": [
        -854.5233764648438,
        -2794.5068359375,
        765.4237060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        0.9807860851287842,
        0.0
      ],
      "plane_d": 2572.8291015625,
      "bbox_min": [
        -871.5,
        -2793.0,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2753.433837890625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20241229236125946,
        0.9793003797531128,
        0.0
      ],
      "plane_d": 2526.19287109375,
      "bbox_min": [
        -860.38818359375,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2753.433837890625,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        0.9793003797531128,
        -0.0
      ],
      "plane_d": 2871.710693359375,
      "bbox_min": [
        -860.38818359375,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2755.896484375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -860.38818359375,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2756.0,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 743.9999389648438,
      "bbox_min": [
        -853.5,
        -2756.103271484375,
        744.0
      ],
      "bbox_max": [
        -853.0,
        -2755.896484375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -858.3373413085938,
        -2756.999755859375,
        744.0
      ],
      "bbox_max": [
        -853.0,
        -2753.433837890625,
        744.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -2870.53369140625,
      "bbox_min": [
        -871.5,
        -2775.864501953125,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2756.900634765625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -853.5,
        -2757.099365234375,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2756.900634765625,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.5,
      "bbox_min": [
        -871.5,
        -2775.864501953125,
        782.5
      ],
      "bbox_max": [
        -871.3280639648438,
        -2774.71533203125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        839.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        680.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 20
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1013.125,
        -2788.75,
        760.0
      ],
      "bbox_max": [
        -1012.9199829101562,
        -2776.68798828125,
        762.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230919003486633,
        -0.23741605877876282,
        -0.6486691832542419
      ],
      "plane_d": 565.3014526367188,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1013.125,
        -2788.75,
        760.0
      ],
      "bbox_max": [
        -1012.7234497070312,
        -2777.22900390625,
        762.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2776.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "bbox_max": [
        -970.0,
        -2818.693115234375,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1013.125,
        -2789.0185546875,
        760.0
      ],
      "bbox_max": [
        -1012.0335693359375,
        -2779.8427734375,
        762.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.606892050811439e-06,
        0.4061366319656372,
        0.9138123393058777
      ],
      "plane_d": 465.8314208984375,
      "bbox_min": [
        -977.939697265625,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2857.0,
        761.111083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1070.0,
        -2857.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8552238941192627,
        0.42890995740890503,
        0.29090940952301025
      ],
      "plane_d": 1840.6619873046875,
      "bbox_min": [
        -1068.0999755859375,
        -2857.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2774.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": 807.29736328125,
      "bbox_min": [
        -1068.0999755859375,
        -2776.417236328125,
        723.0
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.9541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7660439610481262,
        0.642788290977478,
        -8.769334272074047e-06
      ],
      "plane_d": 2599.7958984375,
      "bbox_min": [
        -1066.1202392578125,
        -2776.417236328125,
        723.7416381835938
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.9541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -978.9999389648438,
        -2774.0,
        724.000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9355461001396179,
        0.10546036809682846,
        0.3370926082134247
      ],
      "plane_d": 984.2843017578125,
      "bbox_min": [
        -1012.960693359375,
        -2791.787109375,
        723.1113891601562
      ],
      "bbox_max": [
        -970.0,
        -2774.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1012.960693359375,
        -2791.787109375,
        731.0165405273438
      ],
      "bbox_max": [
        -1000.7862548828125,
        -2776.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -979.22216796875,
        -2776.0,
        723.1113891601562
      ],
      "bbox_max": [
        -970.0,
        -2774.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2720.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2716.5,
      "bbox_min": [
        -1070.0,
        -2720.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 756.5,
      "bbox_min": [
        -1070.0,
        -2716.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2716.5,
        756.5
      ],
      "bbox_max": [
        -1058.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2714.5,
      "bbox_min": [
        -1070.0,
        -2716.5,
        720.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1070.0,
        -2714.5,
        736.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2714.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2712.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2714.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2716.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1070.0,
        -2720.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        760.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1070.0,
        -2720.0,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2716.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2720.0,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2716.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -2434.21533203125,
      "bbox_min": [
        -1020.0,
        -2720.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2720.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 756.5,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -979.2222900390625,
        -2766.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2769.5,
      "bbox_min": [
        -1070.0,
        -2774.0,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2766.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2774.0,
        756.5
      ],
      "bbox_max": [
        -1058.0,
        -2769.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2769.5,
        756.5
      ],
      "bbox_max": [
        -1058.0,
        -2766.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -979.2222900390625,
        -2766.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1070.0,
        -2774.0,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2767.0,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2774.0,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2767.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1444.9727783203125,
      "bbox_min": [
        -1066.6634521484375,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -979.2222900390625,
        -2766.0,
        726.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -1066.6634521484375,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -979.2222900390625,
        -2766.0,
        726.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2767.0,
        723.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1066.6634521484375,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2766.0,
        726.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7660439610481262,
        0.642788290977478,
        -8.769334272074047e-06
      ],
      "plane_d": 2599.7958984375,
      "bbox_min": [
        -1066.6634521484375,
        -2774.0,
        723.6817016601562
      ],
      "bbox_max": [
        -1066.1201171875,
        -2773.3525390625,
        726.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        -1070.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2720.0,
        760.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1034.5,
      "bbox_min": [
        -1070.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        -1070.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -1034.5,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 758.0,
      "bbox_min": [
        -1070.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -1060.0,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1070.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1060.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2402.129150390625,
      "bbox_min": [
        -1070.0,
        -2735.0,
        720.0
      ],
      "bbox_max": [
        -1060.0,
        -2720.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1070.0,
        -2735.0,
        720.0
      ],
      "bbox_max": [
        -1067.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 745.0,
      "bbox_min": [
        -1070.0,
        -2735.0,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.0,
      "bbox_min": [
        -1070.0,
        -2735.0,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2735.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1070.0,
        -2720.5,
        757.5
      ],
      "bbox_max": [
        -1060.0,
        -2720.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2414.60986328125,
      "bbox_min": [
        -1070.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -1060.0,
        -2733.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -640.9561157226562,
      "bbox_min": [
        -1070.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -1060.0,
        -2751.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1067.0,
        -2751.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 745.0,
      "bbox_min": [
        -1070.0,
        -2757.5,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2751.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2751.0,
      "bbox_min": [
        -1070.0,
        -2751.0,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2751.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1070.0,
        -2766.0,
        757.5
      ],
      "bbox_max": [
        -1060.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        -0.0,
        0.9805806875228882
      ],
      "plane_d": -500.68450927734375,
      "bbox_min": [
        -1070.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.0,
      "bbox_min": [
        -1068.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1064.5,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3713906705379486,
        -0.9284766912460327,
        0.0
      ],
      "plane_d": -2159.358154296875,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284766912460327,
        0.0
      ],
      "plane_d": 2934.264892578125,
      "bbox_min": [
        -1067.0,
        -2734.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2736.5,
        732.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2742.0,
      "bbox_min": [
        -1070.0,
        -2744.0,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2742.0,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2744.0,
      "bbox_min": [
        -1070.0,
        -2744.0,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2744.0,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 758.0,
      "bbox_min": [
        -1060.0,
        -2766.0,
        757.5
      ],
      "bbox_max": [
        -1034.5,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1060.0,
        -2766.0,
        758.0
      ],
      "bbox_max": [
        -1058.0,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1060.0,
        -2766.0,
        757.5
      ],
      "bbox_max": [
        -1058.0,
        -2720.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1060.0,
        -2766.0,
        757.5
      ],
      "bbox_max": [
        -1058.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2766.0,
        757.5
      ],
      "bbox_max": [
        -1058.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1010.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        722.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1020.0,
        -2766.0,
        757.5
      ],
      "bbox_max": [
        -1008.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2724.0,
      "bbox_min": [
        -1020.0,
        -2762.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2720.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -2434.21533203125,
      "bbox_min": [
        -1020.0,
        -2722.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2720.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2722.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2720.0,
        722.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1020.0,
        -2720.5,
        757.5
      ],
      "bbox_max": [
        -1008.0,
        -2720.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 756.0,
      "bbox_min": [
        -993.0,
        -2762.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2485.48046875,
      "bbox_min": [
        -993.0,
        -2762.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1393.7076416015625,
      "bbox_min": [
        -993.0,
        -2727.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -980.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2767.0,
        723.111083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -1068.0,
        -2767.0,
        680.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1068.0,
      "bbox_min": [
        -1068.0,
        -2764.0,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        718.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2764.0,
      "bbox_min": [
        -1068.0,
        -2764.0,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        718.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 2706.804931640625,
      "bbox_min": [
        -1068.0,
        -2764.0,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        718.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -640.9561157226562,
      "bbox_min": [
        -1068.0,
        -2757.5,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        715.77783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1068.0,
        -2756.0,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        715.111083984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2414.60986328125,
      "bbox_min": [
        -1068.0,
        -2752.5,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2725.0,
        713.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -628.4752807617188,
      "bbox_min": [
        -1068.0,
        -2735.0,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2725.0,
        705.7777099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2402.129150390625,
      "bbox_min": [
        -1068.0,
        -2730.0,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2725.0,
        703.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1172.3831787109375,
      "bbox_min": [
        -1068.0,
        -2726.0,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2725.0,
        701.77783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1172.3831787109375,
      "bbox_min": [
        -1067.0,
        -2725.0,
        680.0
      ],
      "bbox_max": [
        -1064.0,
        -2722.0,
        701.3333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1172.3831787109375,
      "bbox_min": [
        -1068.0,
        -2764.0,
        699.9999389648438
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2764.0,
      "bbox_min": [
        -1068.0,
        -2764.0,
        702.8888549804688
      ],
      "bbox_max": [
        -1046.5,
        -2728.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2402.129150390625,
      "bbox_min": [
        -1068.0,
        -2764.0,
        702.8888549804688
      ],
      "bbox_max": [
        -1064.0,
        -2728.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -628.4752807617188,
      "bbox_min": [
        -1068.0,
        -2764.0,
        703.5555419921875
      ],
      "bbox_max": [
        -1064.0,
        -2730.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1067.0,
        -2733.5,
        703.5555419921875
      ],
      "bbox_max": [
        -1067.0,
        -2730.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2414.60986328125,
      "bbox_min": [
        -1068.0,
        -2764.0,
        712.888916015625
      ],
      "bbox_max": [
        -1064.0,
        -2751.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 2706.804931640625,
      "bbox_min": [
        -1068.0,
        -2764.0,
        713.5555419921875
      ],
      "bbox_max": [
        -1064.0,
        -2752.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1068.0,
        -2757.5,
        713.5555419921875
      ],
      "bbox_max": [
        -1067.0,
        -2752.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -640.9561157226562,
      "bbox_min": [
        -1068.0,
        -2757.5,
        715.111083984375
      ],
      "bbox_max": [
        -1067.0,
        -2756.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2795.0,
        720.0
      ],
      "bbox_max": [
        -880.5184326171875,
        -2766.999755859375,
        723.5556030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4620361328125,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -885.3666381835938,
        -2766.999755859375,
        723.5556030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292984008789,
        -0.1630813479423523,
        -0.6428514122962952
      ],
      "plane_d": -602.9217529296875,
      "bbox_min": [
        -894.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        824.5013427734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -894.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        824.5013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563965916633606,
        -0.07589651644229889,
        -0.6496953964233398
      ],
      "plane_d": -361.36151123046875,
      "bbox_min": [
        -894.0,
        -2854.677490234375,
        766.400146484375
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        811.0656127929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033253312110901,
        -0.5795758366584778
      ],
      "plane_d": -798.1557006835938,
      "bbox_min": [
        -884.5228271484375,
        -2747.351318359375,
        766.400146484375
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        783.1830444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -878.5,
      "bbox_min": [
        -894.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -878.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188839197158813,
        0.32406729459762573,
        0.2250170260667801
      ],
      "plane_d": -51.825958251953125,
      "bbox_min": [
        -878.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069751501083374,
        0.32028982043266296,
        0.27351534366607666
      ],
      "plane_d": -89.19590759277344,
      "bbox_min": [
        -877.9344482421875,
        -2859.5,
        763.2899169921875
      ],
      "bbox_max": [
        -873.5,
        -2846.85400390625,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -878.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        774.012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033253312110901,
        -0.5795758366584778
      ],
      "plane_d": -798.1557006835938,
      "bbox_min": [
        -878.5,
        -2722.19140625,
        763.6296997070312
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        774.012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -874.5,
      "bbox_min": [
        -878.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -874.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -874.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -874.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2754.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -878.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -874.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4619140625,
      "bbox_min": [
        -890.8987426757812,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -887.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -887.5,
        -2735.5,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033253312110901,
        -0.5795758366584778
      ],
      "plane_d": -798.1557006835938,
      "bbox_min": [
        -890.8987426757812,
        -2724.954833984375,
        770.4376831054688
      ],
      "bbox_max": [
        -878.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292984008789,
        -0.1630813479423523,
        -0.6428514122962952
      ],
      "plane_d": -602.9217529296875,
      "bbox_min": [
        -897.8980712890625,
        -2788.75,
        790.9302978515625
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7230919003486633,
        -0.23741605877876282,
        -0.6486691832542419
      ],
      "plane_d": 565.3014526367188,
      "bbox_min": [
        -970.0,
        -2718.603271484375,
        782.79443359375
      ],
      "bbox_max": [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2709794342517853,
        -0.9625852108001709
      ],
      "plane_d": 26.5570068359375,
      "bbox_min": [
        -932.0,
        -2859.5,
        812.65625
      ],
      "bbox_max": [
        -914.0,
        -2788.75,
        839.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2843.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 918.0,
      "bbox_min": [
        -927.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        830.4619140625
      ],
      "bbox_max": [
        -919.0,
        -2852.0,
        839.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 918.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2843.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.4619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 822.9999389648438,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.4619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2852.0,
        830.4619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -914.0,
        -2859.5,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563965916633606,
        -0.07589651644229889,
        -0.6496953964233398
      ],
      "plane_d": -361.36151123046875,
      "bbox_min": [
        -895.9375,
        -2794.44287109375,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        812.65625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.4982432503529708e-06,
        -0.270979642868042,
        -0.9625850319862366
      ],
      "plane_d": 26.5576171875,
      "bbox_min": [
        -914.0,
        -2859.5,
        812.65625
      ],
      "bbox_max": [
        -895.9375,
        -2788.75,
        832.5732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -9.996506378229242e-07,
        -0.2709798812866211,
        -0.9625849723815918
      ],
      "plane_d": 26.5545654296875,
      "bbox_min": [
        -970.0,
        -2859.5,
        803.5133056640625
      ],
      "bbox_max": [
        -932.0,
        -2788.75,
        832.5732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -970.0,
        -2859.5,
        803.5133056640625
      ],
      "bbox_max": [
        -953.0294189453125,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -970.0,
        -2818.693115234375,
        803.5133056640625
      ],
      "bbox_max": [
        -960.3125,
        -2788.75,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -954.572998046875,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -939.038330078125,
        -2930.0,
        817.5613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6921083927154541,
        -0.23178932070732117,
        -0.6835638880729675
      ],
      "plane_d": 547.8385009765625,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        792.7979125976562
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        792.7979125976562
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        818.93994140625
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968570470809937,
        -0.04264342784881592,
        0.06676524132490158
      ],
      "plane_d": 771.4093627929688,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        836.5609130859375
      ],
      "bbox_max": [
        -957.2632446289062,
        -2976.006103515625,
        841.7111206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -957.2863159179688,
        -2976.006103515625,
        841.7111206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902596354484558,
        -0.23094093799591064,
        -0.685716986656189
      ],
      "plane_d": 550.4041748046875,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -893.16796875,
        -2969.43994140625,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -914.2279052734375,
        -2969.43994140625,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012172247283160686,
        -0.11178828030824661,
        -0.9936575293540955
      ],
      "plane_d": 532.547119140625,
      "bbox_min": [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      "bbox_max": [
        -914.2279052734375,
        -2969.43994140625,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28555822372436523,
        0.010150653310120106,
        -0.9583075642585754
      ],
      "plane_d": 1120.8348388671875,
      "bbox_min": [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      "bbox_max": [
        -934.7142944335938,
        -2970.04833984375,
        859.526611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28555822372436523,
        0.010150653310120106,
        -0.9583075642585754
      ],
      "plane_d": 1120.8348388671875,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        801.9602661132812
      ],
      "bbox_max": [
        -893.377685546875,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        801.9602661132812
      ],
      "bbox_max": [
        -893.377685546875,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012172247283160686,
        -0.11178828030824661,
        -0.9936575293540955
      ],
      "plane_d": 532.547119140625,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        801.9602661132812
      ],
      "bbox_max": [
        -905.8515625,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8210588693618774,
        0.007935827597975731,
        0.5707883238792419
      ],
      "plane_d": 340.41064453125,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        801.9602661132812
      ],
      "bbox_max": [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -957.1978759765625,
        -2990.9130859375,
        801.9602661132812
      ],
      "bbox_max": [
        -944.0224609375,
        -2978.0,
        821.9124755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -957.1957397460938,
        -2984.7890625,
        817.5243530273438
      ],
      "bbox_max": [
        -954.572998046875,
        -2978.0,
        821.439697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -957.1957397460938,
        -2984.7890625,
        817.5243530273438
      ],
      "bbox_max": [
        -956.2754516601562,
        -2978.0,
        821.439697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -957.1957397460938,
        -2984.7890625,
        820.763671875
      ],
      "bbox_max": [
        -956.512939453125,
        -2978.0,
        821.439697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -957.1978759765625,
        -2984.7890625,
        821.0216064453125
      ],
      "bbox_max": [
        -956.512939453125,
        -2978.0,
        821.9124755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9939219355583191,
        -0.10033050924539566,
        -0.045308977365493774
      ],
      "plane_d": 688.4334716796875,
      "bbox_min": [
        -962.9921875,
        -3053.61669921875,
        821.0216064453125
      ],
      "bbox_max": [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968570470809937,
        -0.04264342784881592,
        0.06676524132490158
      ],
      "plane_d": 771.4093627929688,
      "bbox_min": [
        -961.00341796875,
        -3042.81494140625,
        821.0216064453125
      ],
      "bbox_max": [
        -954.774169921875,
        -2978.0,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -957.2632446289062,
        -2984.7890625,
        821.0216064453125
      ],
      "bbox_max": [
        -956.512939453125,
        -2978.0,
        836.5609130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -961.00341796875,
        -3042.81494140625,
        841.4196166992188
      ],
      "bbox_max": [
        -954.774169921875,
        -2978.0,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -961.00341796875,
        -3042.81494140625,
        844.1331176757812
      ],
      "bbox_max": [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt03b",
      "entity_class": "CGameArea",
      "piece_name": "mt03b",
      "offset": 54,
      "centroid": [
        -829.5,
        -2745.0,
        754.5
      ],
      "bbox_min": [
        -872.5,
        -2782.0,
        721.0
      ],
      "bbox_max": [
        -808.0,
        -2708.0,
        776.0
      ],
      "dimensions_source": {
        "span_x": 64.5,
        "span_y": 74.0,
        "height_z": 55.0,
        "door_width": 74.0,
        "door_depth": 64.5,
        "leaf_depth": 64.5,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          -0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -872.5,
          -2748.5,
          721.0
        ],
        [
          -872.5,
          -2748.5,
          730.0
        ],
        [
          -872.5,
          -2741.5,
          730.0
        ],
        [
          -872.5,
          -2741.5,
          721.0
        ],
        [
          -808.0,
          -2782.0,
          762.0
        ],
        [
          -808.0,
          -2768.0,
          762.0
        ],
        [
          -808.0,
          -2768.0,
          776.0
        ],
        [
          -808.0,
          -2782.0,
          776.0
        ],
        [
          -808.0,
          -2722.0,
          762.0
        ],
        [
          -808.0,
          -2708.0,
          762.0
        ],
        [
          -808.0,
          -2708.0,
          776.0
        ],
        [
          -808.0,
          -2722.0,
          776.0
        ]
      ],
      "plane_distance": 872.5
    },
    {
      "tag": "CSlidingDoor piece: m3bd1t",
      "entity_class": "CSlidingDoor",
      "piece_name": "m3bd1t",
      "offset": 5265,
      "centroid": [
        -824.5,
        -2715.0,
        771.75
      ],
      "bbox_min": [
        -824.9000244140625,
        -2720.5,
        769.5
      ],
      "bbox_max": [
        -824.0999755859375,
        -2709.5,
        774.0
      ],
      "dimensions_source": {
        "span_x": 0.800048828125,
        "span_y": 11.0,
        "height_z": 4.5,
        "door_width": 11.0,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -824.9000244140625,
          -2710.89990234375,
          774.0
        ],
        [
          -824.9000244140625,
          -2719.10009765625,
          774.0
        ],
        [
          -824.0999755859375,
          -2710.89990234375,
          774.0
        ],
        [
          -824.0999755859375,
          -2719.10009765625,
          774.0
        ],
        [
          -824.9000244140625,
          -2709.5,
          769.5
        ],
        [
          -824.9000244140625,
          -2720.5,
          769.5
        ],
        [
          -824.0999755859375,
          -2720.5,
          769.5
        ],
        [
          -824.0999755859375,
          -2709.5,
          769.5
        ]
      ],
      "plane_distance": 769.5,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m3bd1b",
      "entity_class": "CSlidingDoor",
      "piece_name": "m3bd1b",
      "offset": 6443,
      "centroid": [
        -824.5,
        -2715.0,
        767.25
      ],
      "bbox_min": [
        -824.9000244140625,
        -2720.5,
        765.0
      ],
      "bbox_max": [
        -824.0999755859375,
        -2709.5,
        769.5
      ],
      "dimensions_source": {
        "span_x": 0.800048828125,
        "span_y": 11.0,
        "height_z": 4.5,
        "door_width": 11.0,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -824.9000244140625,
          -2719.10009765625,
          765.0
        ],
        [
          -824.9000244140625,
          -2710.89990234375,
          765.0
        ],
        [
          -824.0999755859375,
          -2719.10009765625,
          765.0
        ],
        [
          -824.0999755859375,
          -2710.89990234375,
          765.0
        ],
        [
          -824.9000244140625,
          -2709.5,
          769.5
        ],
        [
          -824.9000244140625,
          -2720.5,
          769.5
        ],
        [
          -824.0999755859375,
          -2720.5,
          769.5
        ],
        [
          -824.0999755859375,
          -2709.5,
          769.5
        ]
      ],
      "plane_distance": -769.5,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m3bd2l",
      "entity_class": "CSlidingDoor",
      "piece_name": "m3bd2l",
      "offset": 7776,
      "centroid": [
        -809.0,
        -2718.499969482422,
        770.5
      ],
      "bbox_min": [
        -809.7999877929688,
        -2722.0,
        766.0
      ],
      "bbox_max": [
        -808.2000122070312,
        -2710.89990234375,
        775.0
      ],
      "dimensions_source": {
        "span_x": 1.5999755859375,
        "span_y": 11.10009765625,
        "height_z": 9.0,
        "door_width": 11.10009765625,
        "door_depth": 1.5999755859375,
        "leaf_depth": 1.5599755859375,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -809.7999877929688,
          -2722.0,
          766.0
        ],
        [
          -809.7999877929688,
          -2710.89990234375,
          775.0
        ],
        [
          -809.7999877929688,
          -2722.0,
          775.0
        ],
        [
          -809.7999877929688,
          -2719.10009765625,
          766.0
        ],
        [
          -809.0,
          -2722.0,
          766.0
        ],
        [
          -809.0,
          -2710.89990234375,
          775.0
        ],
        [
          -809.0,
          -2722.0,
          775.0
        ],
        [
          -809.0,
          -2719.10009765625,
          766.0
        ],
        [
          -809.0,
          -2710.89990234375,
          766.0
        ],
        [
          -809.0,
          -2722.0,
          766.0
        ],
        [
          -809.0,
          -2722.0,
          775.0
        ],
        [
          -809.0,
          -2719.099853515625,
          775.0
        ],
        [
          -808.2000122070312,
          -2710.89990234375,
          766.0
        ],
        [
          -808.2000122070312,
          -2719.099853515625,
          775.0
        ],
        [
          -808.2000122070312,
          -2722.0,
          775.0
        ],
        [
          -808.2000122070312,
          -2722.0,
          766.0
        ]
      ],
      "plane_distance": -809.0,
      "authentic_texture": "chksecdoorshut_h"
    },
    {
      "tag": "CSlidingDoor piece: m3bd2r",
      "entity_class": "CSlidingDoor",
      "piece_name": "m3bd2r",
      "offset": 10700,
      "centroid": [
        -809.0,
        -2711.500030517578,
        770.5
      ],
      "bbox_min": [
        -809.7999877929688,
        -2719.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.2000122070312,
        -2708.0,
        775.0
      ],
      "dimensions_source": {
        "span_x": 1.5999755859375,
        "span_y": 11.10009765625,
        "height_z": 9.0,
        "door_width": 11.10009765625,
        "door_depth": 1.5999755859375,
        "leaf_depth": 1.5599755859375,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -809.0,
          -2708.0,
          766.0
        ],
        [
          -809.0,
          -2710.89990234375,
          766.0
        ],
        [
          -809.0,
          -2719.10009765625,
          775.0
        ],
        [
          -809.0,
          -2708.0,
          775.0
        ],
        [
          -808.2000122070312,
          -2708.0,
          766.0
        ],
        [
          -808.2000122070312,
          -2708.0,
          775.0
        ],
        [
          -808.2000122070312,
          -2719.10009765625,
          775.0
        ],
        [
          -808.2000122070312,
          -2710.89990234375,
          766.0
        ],
        [
          -809.7999877929688,
          -2719.10009765625,
          766.0
        ],
        [
          -809.7999877929688,
          -2708.0,
          775.0
        ],
        [
          -809.7999877929688,
          -2710.900146484375,
          775.0
        ],
        [
          -809.7999877929688,
          -2708.0,
          766.0
        ],
        [
          -809.0,
          -2719.10009765625,
          766.0
        ],
        [
          -809.0,
          -2708.0,
          775.0
        ],
        [
          -809.0,
          -2710.900146484375,
          775.0
        ],
        [
          -809.0,
          -2708.0,
          766.0
        ]
      ],
      "plane_distance": -809.8,
      "authentic_texture": "chksecdoorshut_h"
    },
    {
      "tag": "CSlidingDoor piece: m3bd3top",
      "entity_class": "CSlidingDoor",
      "piece_name": "m3bd3top",
      "offset": 13811,
      "centroid": [
        -824.5,
        -2775.0,
        771.75
      ],
      "bbox_min": [
        -824.9000244140625,
        -2780.5,
        769.5
      ],
      "bbox_max": [
        -824.0999755859375,
        -2769.5,
        774.0
      ],
      "dimensions_source": {
        "span_x": 0.800048828125,
        "span_y": 11.0,
        "height_z": 4.5,
        "door_width": 11.0,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -824.9000244140625,
          -2770.89990234375,
          774.0
        ],
        [
          -824.9000244140625,
          -2779.10009765625,
          774.0
        ],
        [
          -824.0999755859375,
          -2770.89990234375,
          774.0
        ],
        [
          -824.0999755859375,
          -2779.10009765625,
          774.0
        ],
        [
          -824.9000244140625,
          -2769.5,
          769.5
        ],
        [
          -824.9000244140625,
          -2780.5,
          769.5
        ],
        [
          -824.0999755859375,
          -2780.5,
          769.5
        ],
        [
          -824.0999755859375,
          -2769.5,
          769.5
        ]
      ],
      "plane_distance": 769.5,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m3bd3bot",
      "entity_class": "CSlidingDoor",
      "piece_name": "m3bd3bot",
      "offset": 14919,
      "centroid": [
        -824.5,
        -2775.0,
        767.25
      ],
      "bbox_min": [
        -824.9000244140625,
        -2780.5,
        765.0
      ],
      "bbox_max": [
        -824.0999755859375,
        -2769.5,
        769.5
      ],
      "dimensions_source": {
        "span_x": 0.800048828125,
        "span_y": 11.0,
        "height_z": 4.5,
        "door_width": 11.0,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -824.9000244140625,
          -2779.10009765625,
          765.0
        ],
        [
          -824.9000244140625,
          -2770.89990234375,
          765.0
        ],
        [
          -824.0999755859375,
          -2779.10009765625,
          765.0
        ],
        [
          -824.0999755859375,
          -2770.89990234375,
          765.0
        ],
        [
          -824.9000244140625,
          -2769.5,
          769.5
        ],
        [
          -824.9000244140625,
          -2780.5,
          769.5
        ],
        [
          -824.0999755859375,
          -2780.5,
          769.5
        ],
        [
          -824.0999755859375,
          -2769.5,
          769.5
        ]
      ],
      "plane_distance": -769.5,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: scan1l",
      "entity_class": "CSlidingDoor",
      "piece_name": "scan1l",
      "offset": 15934,
      "centroid": [
        -816.75,
        -2735.200048828125,
        769.7
      ],
      "bbox_min": [
        -819.5,
        -2741.800048828125,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2730.800048828125,
        777.5
      ],
      "dimensions_source": {
        "span_x": 5.5,
        "span_y": 11.0,
        "height_z": 12.5,
        "door_width": 11.0,
        "door_depth": 5.5,
        "leaf_depth": 5.46,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -819.5,
          -2741.800048828125,
          765.0
        ],
        [
          -814.0,
          -2741.800048828125,
          765.0
        ],
        [
          -819.5,
          -2741.800048828125,
          777.5
        ],
        [
          -814.0,
          -2741.800048828125,
          777.5
        ],
        [
          -818.0,
          -2730.800048828125,
          765.0
        ],
        [
          -818.0,
          -2730.800048828125,
          772.0
        ],
        [
          -818.0,
          -2730.800048828125,
          769.0
        ],
        [
          -815.5,
          -2730.800048828125,
          772.0
        ],
        [
          -815.5,
          -2730.800048828125,
          765.0
        ],
        [
          -815.5,
          -2730.800048828125,
          769.0
        ]
      ],
      "plane_distance": 2730.8
    },
    {
      "tag": "CSlidingDoor piece: scan1r",
      "entity_class": "CSlidingDoor",
      "piece_name": "scan1r",
      "offset": 17839,
      "centroid": [
        -816.75,
        -2694.799951171875,
        769.7
      ],
      "bbox_min": [
        -819.5,
        -2699.199951171875,
        765.0
      ],
      "bbox_max": [
        -814.0,
        -2688.199951171875,
        777.5
      ],
      "dimensions_source": {
        "span_x": 5.5,
        "span_y": 11.0,
        "height_z": 12.5,
        "door_width": 11.0,
        "door_depth": 5.5,
        "leaf_depth": 5.46,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -819.5,
          -2688.199951171875,
          765.0
        ],
        [
          -814.0,
          -2688.199951171875,
          765.0
        ],
        [
          -819.5,
          -2688.199951171875,
          777.5
        ],
        [
          -814.0,
          -2688.199951171875,
          777.5
        ],
        [
          -818.0,
          -2699.199951171875,
          769.0
        ],
        [
          -818.0,
          -2699.199951171875,
          772.0
        ],
        [
          -818.0,
          -2699.199951171875,
          765.0
        ],
        [
          -815.5,
          -2699.199951171875,
          772.0
        ],
        [
          -815.5,
          -2699.199951171875,
          765.0
        ],
        [
          -815.5,
          -2699.199951171875,
          769.0
        ]
      ],
      "plane_distance": -2699.2
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 19208,
      "centroid": [
        -816.75,
        -2729.97998046875,
        783.5
      ],
      "bbox_min": [
        -818.0,
        -2729.97998046875,
        782.0
      ],
      "bbox_max": [
        -815.5,
        -2729.97998046875,
        785.0
      ],
      "dimensions_source": {
        "span_x": 2.5,
        "span_y": 0.0,
        "height_z": 3.0,
        "door_width": 2.5,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -815.5,
          -2729.97998046875,
          785.0
        ],
        [
          -818.0,
          -2729.97998046875,
          785.0
        ],
        [
          -815.5,
          -2729.97998046875,
          782.0
        ],
        [
          -818.0,
          -2729.97998046875,
          782.0
        ]
      ],
      "plane_distance": 2729.98
    }
  ],
  "tutorial_messages": []
}